export const LineChartReportIcon = ({
  width = "12",
  height = "12",
  fillColor = "#000",
  style = {},
  className = "",
}) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      className={className}
      viewBox="0 0 12 12"
    >
      <g transform="translate(-49 -391)">
        <path
          d="M3.885,6.62,6.683,4.1,9,6.1l2.316-2.438L12,4.178,9.077,7.306,6.683,5.21,4.5,7.227ZM14,2V14H2V2ZM7.908,8.586H2.776V13.68H7.908ZM12,12.3H9v.682h3ZM12,10.7H9v.7h3Zm1.285-8.039L2.776,2.573V8H13.285ZM7.142,9.12H3.462v3.857H7.142Z"
          transform="translate(47 389)"
          fill={fillColor}
        />
        <path
          id="Path_10"
          data-name="Path 10"
          d="M0,0H3.055V.66H0Z"
          transform="translate(55.948 398)"
        />
      </g>
    </svg>
  </>
);

export const TrafficLightIcon = ({
  size = 16, // width in px; height scales ~2.1x
  active = "green", // "red" | "yellow" | "green" | null
  body = "#1f1f1f", // housing color
  off = "#555", // dimmed light color
  red = "#ef4444",
  yellow = "#f59e0b",
  green = "#22c55e",
  glow = true, // soft glow for the active light
  style = {},
  className = "",
}) => {
  const w = 24,
    h = 50; // viewBox
  const is = (c) => active === c;

  const lightFill = {
    red: is("red") ? red : off,
    yellow: is("yellow") ? yellow : off,
    green: is("green") ? green : off,
  };

  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      width={size}
      height={Math.round(size * (h / w))}
      role="img"
      aria-label={`${active ?? "off"} traffic light`}
      className={className}
      style={{ display: "inline-block", verticalAlign: "-2px", ...style }}
    >
      {/* housing */}
      <rect x="3" y="3" width="18" height="44" rx="4" fill={body} />
      {/* red */}
      <circle cx="12" cy="13" r="6" fill={lightFill.red} />
      {/* yellow */}
      <circle cx="12" cy="25" r="6" fill={lightFill.yellow} />
      {/* green (with optional glow) */}
      <g style={glow && is("green") ? { filter: "url(#glow)" } : undefined}>
        <circle cx="12" cy="37" r="6" fill={lightFill.green} />
      </g>

      {/* SVG glow filter */}
      <defs>
        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="1.6" result="b" />
          <feMerge>
            <feMergeNode in="b" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
    </svg>
  );
};

export const CalendarIcon = ({
  fillColor = "var(--color-bloodred)",
  width = "70%",
  height = "70%",
  style = {},
  className = "",
  cursor = "pointer",
  onClick,
  id,
}) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60.691 61.756"
      width={width}
      height={height}
      style={{ ...style, cursor }}
      className={className}
      onClick={onClick}
      id={id}
      fill={fillColor}
    >
      <g
        id="calendar-01_3_"
        data-name="calendar-01 (3)"
        transform="translate(-3.369 -1.5)"
      >
        <path
          id="Path_11"
          data-name="Path 11"
          d="M59.354,11.56v2.86a5.159,5.159,0,0,1-10.319,0V11.56H18.4v2.86a5.159,5.159,0,1,1-10.318,0V11.56H3.369v51.7H64.061v-51.7H59.354ZM15.211,60H6.624v-7.04h8.586V60Zm0-8.955H6.624V43h8.586v8.051Zm0-9.964H6.624V33.029h8.586v8.052Zm0-9.967H6.624V23.05h8.586v8.065ZM26.736,60h-9.61v-7.04h9.61Zm0-8.955h-9.61V43h9.61Zm0-9.964h-9.61V33.029h9.61Zm0-9.967h-9.61V23.05h9.61ZM38.259,60h-9.61v-7.04h9.61V60Zm0-8.955h-9.61V43h9.61v8.051Zm0-9.964h-9.61V33.029h9.61v8.052Zm0-9.967h-9.61V23.05h9.61v8.065ZM49.782,60H40.174v-7.04h9.608Zm0-8.955H40.174V43h9.608Zm0-9.964H40.174V33.029h9.608Zm0-9.967H40.174V23.05h9.608ZM60.806,60H51.7v-7.04h9.11V60Zm0-8.955H51.7V43h9.11v8.051Zm0-9.964H51.7V33.029h9.11v8.052Zm0-9.967H51.7V23.05h9.11v8.065ZM16.891,5.154V14.37a3.654,3.654,0,1,1-7.308,0V5.154a3.654,3.654,0,0,1,7.308,0Zm40.957,0V14.37a3.654,3.654,0,1,1-7.308,0V5.154a3.654,3.654,0,0,1,7.308,0Z"
          fill={fillColor}
        />
      </g>
    </svg>
  </>
);
export const CoinsIcon = ({
  width = "31.088",
  height = "31.816",
  fillColor = "#f1cb55",
  style = {},
  className = "",
  cursor = "pointer",
  onClick,
  id,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 31.088 31.816"
    width={width}
    height={height}
    style={{ ...style, cursor }}
    className={className}
    onClick={onClick}
    id={id}
    fill={fillColor}
  >
    <path
      id="Path_4161"
      data-name="Path 4161"
      d="M48.116,39.815a17.34,17.34,0,0,0,4.782.628c5.113,0,8.254-1.818,8.254-3.12v-2.2a8.519,8.519,0,0,1-1.382.758A17.516,17.516,0,0,1,52.9,37.146a17.514,17.514,0,0,1-6.872-1.266,8.546,8.546,0,0,1-1.382-.758V36.8A11.154,11.154,0,0,1,48.116,39.815Z"
      transform="translate(-30.064 -23.878)"
      fill={fillColor}
    />
    <path
      id="Path_4162"
      data-name="Path 4162"
      d="M52.9,22.706a17.514,17.514,0,0,1-6.872-1.266,8.546,8.546,0,0,1-1.382-.758v2.2c0,1.3,3.14,3.12,8.254,3.12s8.254-1.817,8.254-3.12v-2.2a8.52,8.52,0,0,1-1.382.758A17.516,17.516,0,0,1,52.9,22.706Z"
      transform="translate(-30.064 -14.6)"
      fill={fillColor}
    />
    <path
      id="Path_4163"
      data-name="Path 4163"
      d="M61.47,54.882c5.113,0,8.254-1.817,8.254-3.12v-2.2a8.492,8.492,0,0,1-1.382.757,17.51,17.51,0,0,1-6.872,1.267,20.673,20.673,0,0,1-3.484-.288,11,11,0,0,1,.889,3.412,19.176,19.176,0,0,0,2.595.173Z"
      transform="translate(-38.636 -33.155)"
      fill={fillColor}
    />
    <path
      id="Path_4164"
      data-name="Path 4164"
      d="M61.814,69.322c5.113,0,8.254-1.817,8.254-3.12V64a8.52,8.52,0,0,1-1.382.758,17.517,17.517,0,0,1-6.872,1.267,21.12,21.12,0,0,1-2.576-.156,10.993,10.993,0,0,1-.717,3.168,18.835,18.835,0,0,0,3.293.284Z"
      transform="translate(-38.98 -42.433)"
      fill={fillColor}
    />
    <path
      id="Path_4165"
      data-name="Path 4165"
      d="M13.07,41.131a9.212,9.212,0,1,0,9.212,9.212,9.222,9.222,0,0,0-9.212-9.212Z"
      transform="translate(-3.858 -27.739)"
      fill={fillColor}
    />
    <ellipse
      id="Ellipse_511"
      data-name="Ellipse 511"
      cx="8.254"
      cy="3.12"
      rx="8.254"
      ry="3.12"
      transform="translate(14.581)"
      fill={fillColor}
    />
  </svg>
);

export const CashRegisterIcon = ({
  width = "24",
  height = "24",
  fillColor = "var(--color-black)",
  style = {},
  className = "",
  cursor = "pointer",
  onClick,
  id,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 65.743 65.742"
    style={{ ...style, cursor }}
    className={className}
    onClick={onClick}
    id={id}
    fill={fillColor}
  >
    <g id="register" transform="translate(0.05 0.05)">
      <path
        id="Path_18902"
        data-name="Path 18902"
        d="M26.188-495.658l-.342.328v10.27H23.439a17.216,17.216,0,0,0-2.981.164,4.062,4.062,0,0,0-2.106,2.106c-.123.424-.164,4.417-.164,16.657v16.082h-.752c-.629,0-.821.055-1.094.342L16-449.38v18.353l.342.328.328.342h64.3l.328-.342.342-.328V-449.38l-.342-.328c-.274-.287-.465-.342-1.094-.342h-.752v-16.082c0-12.034-.041-16.233-.164-16.629a3.736,3.736,0,0,0-.752-1.2c-1.053-1.176.191-1.094-17.436-1.094H45.539v-3.98a39.838,39.838,0,0,0-.123-4.212A21.929,21.929,0,0,0,41.19-496a14,14,0,0,0-2.325,1.012l-2.01,1-1.5-1A7.182,7.182,0,0,0,33.518-496a6.981,6.981,0,0,0-1.819.971l-1.477.985-1.477-.985C27.118-496.1,26.722-496.205,26.188-495.658Zm17.163,14.182v10.64H28.034v-22.018l.916.615a3.819,3.819,0,0,0,1.258.615,6.983,6.983,0,0,0,1.819-.971l1.477-.985,1.477.985a6.517,6.517,0,0,0,1.805.957,13.2,13.2,0,0,0,2.325-1l1.969-1,1.135.752,1.135.752Zm-17.5,2.434c0,3.446-.027,3.829-.219,3.829a3.523,3.523,0,0,0-3.063,3.282,3.624,3.624,0,0,0,2.27,3.118c.424.123,3.186.164,10.886.164,11.747,0,11.159.055,12.185-1.094a3.055,3.055,0,0,0,0-4.376,3.277,3.277,0,0,0-2.12-1.094c-.232,0-.246-.219-.246-3.829v-3.829H76.6l.328.342.342.328v32.151H20.376V-482.2l.342-.328c.328-.342.369-.342,2.735-.342h2.393Zm0,7.111c0,.889-.041,1.094-.205,1.094-.369,0-.889-.643-.889-1.094s.52-1.094.889-1.094C25.805-473.025,25.846-472.82,25.846-471.931Zm20.445-.752a1.066,1.066,0,0,1,.342.752c0,.451-.52,1.094-.889,1.094-.164,0-.205-.205-.205-1.094C45.539-473.162,45.69-473.3,46.291-472.683ZM79.454-440.2v7.658H18.188v-15.317H79.454Z"
        transform="translate(-16 496)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18903"
        data-name="Path 18903"
        d="M120-438.906v1.094h3.282V-440H120Z"
        transform="translate(-105.777 447.658)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18904"
        data-name="Path 18904"
        d="M160-438.906v1.094h5.47V-440H160Z"
        transform="translate(-140.307 447.658)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18905"
        data-name="Path 18905"
        d="M120-406.906v1.094h10.94V-408H120Z"
        transform="translate(-105.777 420.034)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18906"
        data-name="Path 18906"
        d="M120-374.906v1.094h3.282V-376H120Z"
        transform="translate(-105.777 392.411)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18907"
        data-name="Path 18907"
        d="M160-374.906v1.094h5.47V-376H160Z"
        transform="translate(-140.307 392.411)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18908"
        data-name="Path 18908"
        d="M272.342-383.658l-.342.328v7.412l.342.328.328.342H295.4l.328-.342.342-.328v-7.412l-.342-.328L295.4-384H272.67Zm21.539,4.034v2.188H274.188v-4.376h19.693Z"
        transform="translate(-236.991 399.317)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18909"
        data-name="Path 18909"
        d="M297.469-303.718a2.165,2.165,0,0,0-.629,3.515,2.165,2.165,0,0,0,3.651-2A2.223,2.223,0,0,0,297.469-303.718Z"
        transform="translate(-257.879 330.167)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18910"
        data-name="Path 18910"
        d="M345.469-303.718a2.165,2.165,0,0,0-.629,3.515,2.165,2.165,0,0,0,3.651-2A2.223,2.223,0,0,0,345.469-303.718Z"
        transform="translate(-299.314 330.167)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18911"
        data-name="Path 18911"
        d="M393.469-303.718a2.165,2.165,0,0,0-.629,3.515,2.165,2.165,0,0,0,3.651-2A2.223,2.223,0,0,0,393.469-303.718Z"
        transform="translate(-340.75 330.167)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18912"
        data-name="Path 18912"
        d="M297.469-255.836a2.165,2.165,0,0,0-.629,3.515,2.062,2.062,0,0,0,3.036,0A2.167,2.167,0,0,0,297.469-255.836Z"
        transform="translate(-257.879 288.848)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18913"
        data-name="Path 18913"
        d="M345.469-255.836a2.165,2.165,0,0,0-.629,3.515,2.061,2.061,0,0,0,3.036,0A2.167,2.167,0,0,0,345.469-255.836Z"
        transform="translate(-299.314 288.848)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18914"
        data-name="Path 18914"
        d="M393.469-255.836a2.165,2.165,0,0,0-.629,3.515,2.062,2.062,0,0,0,3.036,0A2.167,2.167,0,0,0,393.469-255.836Z"
        transform="translate(-340.75 288.848)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18915"
        data-name="Path 18915"
        d="M297.469-207.836a2.165,2.165,0,0,0-.629,3.515,2.061,2.061,0,0,0,3.036,0A2.167,2.167,0,0,0,297.469-207.836Z"
        transform="translate(-257.879 247.413)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18916"
        data-name="Path 18916"
        d="M345.469-207.836a2.165,2.165,0,0,0-.629,3.515,2.061,2.061,0,0,0,3.036,0A2.167,2.167,0,0,0,345.469-207.836Z"
        transform="translate(-299.314 247.413)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18917"
        data-name="Path 18917"
        d="M393.469-207.836a2.165,2.165,0,0,0-.629,3.515,2.061,2.061,0,0,0,3.036,0A2.167,2.167,0,0,0,393.469-207.836Z"
        transform="translate(-340.75 247.413)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18918"
        data-name="Path 18918"
        d="M48.342-135.658,48-135.33v11.788l.342.328.328.342h55.55l.328-.342.342-.328V-135.33l-.342-.328L104.22-136H48.67Zm54.36,6.222v4.376H50.188v-8.752H102.7Z"
        transform="translate(-43.624 185.232)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
      <path
        id="Path_18919"
        data-name="Path 18919"
        d="M234.173-111.807a4.36,4.36,0,0,0-2.024,2.092,3,3,0,0,0,.862,3.268,3,3,0,0,0,3.268.862,4.062,4.062,0,0,0,2.106-2.106,3,3,0,0,0-.862-3.268A3.1,3.1,0,0,0,234.173-111.807Zm1.846,2.352a1.08,1.08,0,0,1-.752,1.846,1.066,1.066,0,0,1-.752-.342,1.066,1.066,0,0,1-.342-.752,1.066,1.066,0,0,1,.342-.752,1.066,1.066,0,0,1,.752-.342A1.066,1.066,0,0,1,236.019-109.455Z"
        transform="translate(-202.446 164.499)"
        stroke="#aaa"
        strokeWidth="0.1"
      />
    </g>
  </svg>
);

export const CatagoriesIcon = ({
  width = "25.496",
  height = "18.747",
  fillColor = "#000000",
}) => (
  <svg
    className="categories-menu-header-icon"
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25.496 18.747"
  >
    <rect width="5.249" height="5.249" transform="translate(6.75 13.498)" />
    <rect width="5.249" height="5.249" transform="translate(6.75)" />
    <rect width="5.249" height="5.249" transform="translate(6.75 6.749)" />
    <rect width="5.249" height="5.249" transform="translate(0 6.749)" />
    <rect width="5.249" height="5.249" transform="translate(0)" />
    <rect width="5.249" height="5.249" transform="translate(0 13.498)" />
    <rect width="5.249" height="5.249" transform="translate(20.247)" />
    <rect width="5.249" height="5.249" transform="translate(20.247 6.749)" />
    <rect width="5.249" height="5.249" transform="translate(20.247 13.498)" />
    <rect width="5.249" height="5.249" transform="translate(13.499 13.498)" />
    <rect width="5.249" height="5.249" transform="translate(13.499 6.749)" />
    <rect width="5.249" height="5.249" transform="translate(13.499)" />
  </svg>
);

export const DesktopComputerIcon = ({
  width = "24",
  height = "24",
  fillColor = "var(--color-black)",
  style = {},
  className = "",
  cursor = "pointer",
  onClick,
  id,
}) => (
  <svg
    viewBox="0 0 576 512"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={{ ...style, cursor }}
    className={className}
    onClick={onClick}
    id={id}
    fill={fillColor}
  >
    <path d="m528 0h-480c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48v-320c0-26.5-21.5-48-48-48zm-16 352h-448v-288h448z" />
  </svg>
);

export const ClipBoardCheckIcon = ({
  width = "38",
  height = "38",
  fillColor = "#fff",
  style = {},
  className = "",
  cursor = "pointer",
  onClick,
  id,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 69.287 89.789"
    style={{ ...style, cursor }}
    className={className}
    onClick={onClick}
    id={id}
  >
    <g
      id="clipBoardCheck"
      data-name="Industry (1)"
      transform="translate(-17.912 -4.299)"
    >
      <path
        id="Path_19295"
        data-name="Path 19295"
        d="M79.6,72.1v11a8.756,8.756,0,0,1-9,8.6H64.4"
        fill="none"
        stroke={fillColor}
        strokeMiterlimit="10"
        strokeWidth="4.775"
      />
      <path
        id="Path_19296"
        data-name="Path 19296"
        d="M46.8,91.7H29.3a8.82,8.82,0,0,1-9-8.6V22a8.756,8.756,0,0,1,9-8.6h7.6"
        fill="none"
        stroke={fillColor}
        strokeMiterlimit="10"
        strokeWidth="4.775"
      />
      <path
        id="Path_19297"
        data-name="Path 19297"
        d="M62.4,13.4h8.2a8.82,8.82,0,0,1,9,8.6V43.6"
        fill="none"
        stroke={fillColor}
        strokeMiterlimit="10"
        strokeWidth="4.775"
      />
      <path
        id="Path_19298"
        data-name="Path 19298"
        d="M34.1,75.3,49,66.4l7.5,14.1S73.1,49,87.2,42.6c0,0-3.2,12,0,18.9,0,0-15.6,10-29.4,32.3Z"
        fill={fillColor}
      />
      <path
        id="Path_19299"
        data-name="Path 19299"
        d="M70,26c0-3.5-.7-4.1-4.1-4.2H58.3V14.3c0-5.8-3.7-9.9-8.8-10-5.2-.1-8.8,3.9-8.8,9.9v7.6H32.6c-2.6-.1-3.8,1.2-3.7,3.8v4.7h41C70,28.7,70,27.3,70,26ZM49.5,15.3a3,3,0,1,1,3-3A3.075,3.075,0,0,1,49.5,15.3Z"
        fill={fillColor}
        fillRule="evenodd"
      />
    </g>
  </svg>
);

export const MagnifyingGlassIcon = ({
  fillColor = "white",
  width = "36.697",
  height = "36.755",
  style = {},
  className = "",
  cursor = "pointer",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    style={{ ...style, cursor }}
    viewBox="0 0 56.697 56.755"
  >
    <g id="Group_10" data-name="Group 10" transform="translate(-9.384 -14.562)">
      <path
        id="Path_14"
        data-name="Path 14"
        d="M33.657,14.562a24.186,24.186,0,0,0-17.172,7.16A24.274,24.274,0,0,0,33.657,63.169a24.107,24.107,0,0,0,14.264-4.6l.58-.408.118.117L60.726,70.388a3.129,3.129,0,1,0,4.424-4.426L52.925,53.739l.406-.582A24.35,24.35,0,0,0,33.657,14.562Zm14.438,38.71a20.4,20.4,0,1,1,0-28.814A20.3,20.3,0,0,1,48.095,53.272Z"
        fill={fillColor}
      />
      <path
        id="Path_15"
        data-name="Path 15"
        d="M49.316,56.835h0c0-.059-.582-7.277-9.722-7.277-9.256,0-9.721,7.277-9.721,7.334v2.1a1.1,1.1,0,0,0,1.106,1.106H48.268a1.106,1.106,0,0,0,1.107-1.106Z"
        transform="translate(-5.938 -10.141)"
        fill={fillColor}
      />
      <path
        id="Path_16"
        data-name="Path 16"
        d="M41.26,42.731a5.1,5.1,0,0,0,4.832-5.356,5.1,5.1,0,0,0-4.832-5.357,5.1,5.1,0,0,0-4.832,5.357A5.1,5.1,0,0,0,41.26,42.731Z"
        transform="translate(-7.836 -5.058)"
        fill={fillColor}
      />
    </g>
  </svg>
);

export const CalculatedReceiptIcon = ({
  width = "24.9",
  height = "24.872",
  fillColor = "#aaa",
  style = {},
  className = "",
  cursor = "pointer",
  onClick,
  id,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24.9 24.872"
    width={width}
    height={height}
    style={{ ...style, cursor }}
    className={className}
    onClick={onClick}
    id={id}
    fill={fillColor}
  >
    <g id="receipt-_2_" transform="translate(0.05 511.717)">
      <path
        id="Path_18920"
        data-name="Path 18920"
        d="M30.5-511.612a4.417,4.417,0,0,0-3.462,3.176,6.788,6.788,0,0,0-.126,1.859.411.411,0,0,0,.484.223c.228-.087.271-.223.271-.818a3.471,3.471,0,0,1,.339-1.632,3.548,3.548,0,0,1,1.67-1.724c.78-.382.378-.353,5.931-.368l4.963-.015-.145.106a4.5,4.5,0,0,0-1.327,1.641,4.3,4.3,0,0,0-.426,1.845c-.029.726,0,.867.252.959a.4.4,0,0,0,.45-.16,3.789,3.789,0,0,0,.077-.736,3.39,3.39,0,0,1,.4-1.666,2.88,2.88,0,0,1,.591-.833,3.49,3.49,0,0,1,2.818-1.143,3.323,3.323,0,0,1,1.5.407,2.773,2.773,0,0,1,.925.688,2.841,2.841,0,0,1,.688.925c.426.876.387.286.421,7l.024,5.955.131.276.131.276-2.619.015-2.615.015-.116.136a.329.329,0,0,0,0,.5l.116.116,3.6-.01,3.6-.015.32-.155a1.836,1.836,0,0,0,.857-.876c.131-.271.131-.3.145-1.443l.019-1.167-.121-.14-.121-.14-1.288-.014-1.288-.015v-4.425c0-2.886-.019-4.556-.053-4.8a4.591,4.591,0,0,0-1.574-2.842,4.671,4.671,0,0,0-1.787-.92c-.334-.1-.431-.1-6.827-.107C32.165-511.675,30.776-511.665,30.5-511.612ZM49.6-496.927c-.015.852-.015.867-.15,1.065a1.009,1.009,0,0,1-1.52.237c-.31-.271-.353-.431-.353-1.356v-.809h2.043Z"
        transform="translate(-25.59)"
        stroke="#707070"
        strokeWidth="0.1"
      />
      <path
        id="Path_18921"
        data-name="Path 18921"
        d="M.1-386.874l-.1.131V-368.5l.121.116.116.121H14.908l.136-.116.136-.116.015-9c0-4.948,0-9.069-.015-9.156a.557.557,0,0,0-.126-.257C14.961-387,14.826-387,7.582-387H.2Zm14.327,9.243v8.594H.775v-17.188H14.428Z"
        transform="translate(0 -118.632)"
        stroke="#707070"
        strokeWidth="0.1"
      />
      <path
        id="Path_18922"
        data-name="Path 18922"
        d="M43.121-340.879l-.121.116v2.561c0,2.518,0,2.566.1,2.692l.1.126h5.3c5.181,0,5.3,0,5.389-.092a.556.556,0,0,0,.126-.257c.015-.087.024-1.259.015-2.6l-.015-2.44-.136-.116a.341.341,0,0,0-.489-.014l-.126.1v4.643h-9.49v-4.067h4.164c2.987,0,4.193-.015,4.28-.053a.406.406,0,0,0,.2-.431.545.545,0,0,0-.136-.194c-.1-.1-.194-.1-4.571-.1H43.237Z"
        transform="translate(-40.918 -162.405)"
        stroke="#707070"
        strokeWidth="0.1"
      />
      <path
        id="Path_18923"
        data-name="Path 18923"
        d="M43.206-192.879a.375.375,0,0,0-.029.513l.092.116,1.322.015c1.438.015,1.545,0,1.641-.237a.4.4,0,0,0-.15-.479A10.88,10.88,0,0,0,44.659-193H43.322Z"
        transform="translate(-41.003 -303.239)"
        stroke="#707070"
        strokeWidth="0.1"
      />
      <path
        id="Path_18924"
        data-name="Path 18924"
        d="M124.121-192.879a.377.377,0,0,0-.121.266.377.377,0,0,0,.121.266l.116.121h2.677l.14-.14c.15-.155.169-.242.082-.407-.116-.223-.14-.223-1.554-.228h-1.346Z"
        transform="translate(-117.996 -303.239)"
        stroke="#707070"
        strokeWidth="0.1"
      />
      <path
        id="Path_18925"
        data-name="Path 18925"
        d="M205.121-192.879a.377.377,0,0,0-.121.266.377.377,0,0,0,.121.266l.116.121h1.331c1.327,0,1.332,0,1.462-.111a.351.351,0,0,0,0-.552C207.9-193,207.9-193,206.569-193h-1.331Z"
        transform="translate(-195.074 -303.239)"
        stroke="#707070"
        strokeWidth="0.1"
      />
      <path
        id="Path_18926"
        data-name="Path 18926"
        d="M43.2-147.879a.324.324,0,0,0-.068.426c.1.213.213.228,1.574.228h1.288l.145-.145c.121-.126.14-.174.116-.305-.063-.32-.082-.324-1.588-.324H43.314Z"
        transform="translate(-40.995 -346.061)"
        stroke="#707070"
        strokeWidth="0.1"
      />
      <path
        id="Path_18927"
        data-name="Path 18927"
        d="M124.069-147.874a.357.357,0,0,0,.1.576,4.887,4.887,0,0,0,1.414.073c1.2,0,1.288,0,1.4-.1a.493.493,0,0,0,.15-.218.455.455,0,0,0-.189-.431c-.044-.015-.688-.029-1.428-.029h-1.351Z"
        transform="translate(-117.964 -346.061)"
        stroke="#707070"
        strokeWidth="0.1"
      />
      <path
        id="Path_18928"
        data-name="Path 18928"
        d="M205.135-147.889a.385.385,0,0,0,.194.639c.063.015.683.024,1.38.015,1.2-.015,1.278-.019,1.365-.111a.405.405,0,0,0,0-.557c-.092-.092-.16-.1-1.467-.1C205.242-148,205.237-148,205.135-147.889Z"
        transform="translate(-195.103 -346.061)"
        stroke="#707070"
        strokeWidth="0.1"
      />
      <path
        id="Path_18929"
        data-name="Path 18929"
        d="M43.2-102.874a.341.341,0,0,0,.015.489l.116.136h2.731l.116-.136a.323.323,0,0,0,0-.494L46.061-103H43.3Z"
        transform="translate(-41.021 -388.882)"
        stroke="#707070"
        strokeWidth="0.1"
      />
      <path
        id="Path_18930"
        data-name="Path 18930"
        d="M124.154-102.874a.347.347,0,0,0,.024.508l.126.116h1.351c1.331,0,1.351,0,1.457-.107a.394.394,0,0,0,0-.552c-.1-.087-.218-.092-1.482-.092h-1.375Z"
        transform="translate(-118.049 -388.882)"
        stroke="#707070"
        strokeWidth="0.1"
      />
      <path
        id="Path_18931"
        data-name="Path 18931"
        d="M205.028-102.889a.377.377,0,0,0,.242.639c.087.015.712.024,1.38.015,1.147-.015,1.23-.019,1.317-.111a.405.405,0,0,0,0-.557c-.092-.092-.16-.1-1.467-.1C205.135-103,205.13-103,205.028-102.889Z"
        transform="translate(-194.996 -388.882)"
        stroke="#707070"
        strokeWidth="0.1"
      />
      <path
        id="Path_18932"
        data-name="Path 18932"
        d="M43.261-58.684a.459.459,0,0,0-.261.368.456.456,0,0,0,.1.232l.1.126h2.76l.116-.121a.323.323,0,0,0,0-.494l-.116-.136-1.3-.01A12.725,12.725,0,0,0,43.261-58.684Z"
        transform="translate(-40.918 -431.019)"
        stroke="#707070"
        strokeWidth="0.1"
      />
      <path
        id="Path_18933"
        data-name="Path 18933"
        d="M124.454-58.705a.379.379,0,0,0-.189.615l.1.126h1.375c1.264,0,1.38,0,1.482-.092a.394.394,0,0,0,0-.552c-.107-.107-.136-.107-1.4-.116C125.108-58.73,124.493-58.72,124.454-58.705Z"
        transform="translate(-118.16 -431.012)"
        stroke="#707070"
        strokeWidth="0.1"
      />
      <path
        id="Path_18934"
        data-name="Path 18934"
        d="M205.089-58.712a.363.363,0,0,0-.1.6c.111.107.145.107,1.477.107,1.3,0,1.37,0,1.462-.1a.405.405,0,0,0,0-.557c-.087-.092-.165-.1-1.39-.107A5.686,5.686,0,0,0,205.089-58.712Z"
        transform="translate(-194.95 -430.972)"
        stroke="#707070"
        strokeWidth="0.1"
      />
    </g>
  </svg>
);

export const MoneyBagIcon = ({
  width = "13.929",
  height = "13.703",
  fillColor = "#b03a2e",
  style = {},
  className = "",
  cursor = "pointer",
  onClick,
  id,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 21.464 26.903"
    width={width}
    height={height}
    style={{ ...style, cursor }}
    className={className}
    onClick={onClick}
    id={id}
    fill={fillColor}
  >
    <g transform="translate(8.842 13.426)">
      <g transform="translate(2.431 3.862)">
        <path
          d="M74.427,27.427a1.207,1.207,0,0,0-.344-.261,4.116,4.116,0,0,0-.875-.321v2.407a1.628,1.628,0,0,0,1.3-.71h0a1.137,1.137,0,0,0,.095-.751A.744.744,0,0,0,74.427,27.427Z"
          transform="translate(-73.209 -26.845)"
          fill={fillColor}
        />
      </g>
      <path
        d="M70.613,23.237a.923.923,0,0,0-.148.423,1.037,1.037,0,0,0,.049.468.752.752,0,0,0,.281.321,2.151,2.151,0,0,0,.416.223c.123.051.257.1.405.147V22.641A1.587,1.587,0,0,0,70.613,23.237Z"
        transform="translate(-70.457 -22.641)"
        fill={fillColor}
      />
    </g>
    <path
      d="M72.537,13.877c1.969-1.72,3.284-5.593,2.475-5.762-1.075-.225-3.411.762-4.54.937-1.6.2-3.346-1.806-4.325-.686-.8.908.571,4.215,2.709,5.655-6.38,3.259-15.343,19.62.3,20.808C90.792,36.47,79.956,17.052,72.537,13.877Zm1.858,12.9a2.382,2.382,0,0,1-.878,1.607,3.281,3.281,0,0,1-1.794.66v.705a.678.678,0,0,1-.216.5.624.624,0,0,1-.688.106.671.671,0,0,1-.369-.6v-.771c-.11-.021-.219-.047-.328-.078a3.112,3.112,0,0,1-1.557-1,2.949,2.949,0,0,1-.48-.825c-.029-.078-.057-.158-.08-.24a1.466,1.466,0,0,1-.05-.224.694.694,0,0,1,.069-.373.639.639,0,0,1,.621-.353.647.647,0,0,1,.547.451c.024.076.042.154.067.23a1.58,1.58,0,0,0,.379.59,1.865,1.865,0,0,0,.809.459V25a4.471,4.471,0,0,1-1.671-.75,1.987,1.987,0,0,1-.563-.7,2.265,2.265,0,0,1-.2-.948,2.3,2.3,0,0,1,.19-.959,2.342,2.342,0,0,1,.523-.745,3.122,3.122,0,0,1,1.717-.79v-.732a.685.685,0,0,1,.214-.5.623.623,0,0,1,.686-.106.671.671,0,0,1,.373.6V20.1c.083.011.166.024.248.039a3.108,3.108,0,0,1,1.662.839,2.515,2.515,0,0,1,.507.761,2.161,2.161,0,0,1,.092.242,1.513,1.513,0,0,1,.06.236.7.7,0,0,1-.054.378.641.641,0,0,1-.606.381.647.647,0,0,1-.566-.423c-.026-.073-.04-.149-.067-.221a1.136,1.136,0,0,0-.1-.209,1.244,1.244,0,0,0-.3-.328,2.011,2.011,0,0,0-.873-.355V23.95a7.793,7.793,0,0,1,1.086.336,2.566,2.566,0,0,1,1.329,1.08c-.047-.083-.09-.163,0,0s.047.085,0,0A2.394,2.394,0,0,1,74.394,26.78Z"
      transform="translate(-60.449 -8.024)"
      fill={fillColor}
    />
  </svg>
);

export const EventCalendarIcon = ({
  width = "51.469px",
  height = "50.9px",
  fillColor = "#b03a2e",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 51.469 50.9"
    x="0px"
    y="0px"
    width={width}
    height={height}
    style={style}
    className={className}
  >
    <g>
      <path
        fill={fillColor}
        d="M43.867,9.235h-4.323V6.09c0-0.678-0.551-1.229-1.229-1.229h-5.11c-0.68,0-1.229,0.551-1.229,1.229v3.145
		H19.494V6.09c0-0.678-0.551-1.229-1.229-1.229h-5.11c-0.678,0-1.227,0.551-1.227,1.229v3.145H7.604
		c-0.68,0-1.229,0.549-1.229,1.229V44.81c0,0.679,0.551,1.229,1.229,1.229h36.264c0.678,0,1.228-0.549,1.228-1.229V10.464
		C45.095,9.784,44.545,9.235,43.867,9.235z M34.433,7.319h2.702v4.962h-2.702V7.319z M14.385,7.319h2.701v4.962h-2.701V7.319
		L14.385,7.319z M24.556,36.703c-0.477,0.468-1.242,0.468-1.72,0l-5.209-5.06l1.721-1.77l4.374,4.226l8.451-7.912l1.67,1.77
		L24.556,36.703z M42.639,19.258H8.832v-7.567h3.097v1.819c0,0.678,0.549,1.229,1.227,1.229h5.11c0.68,0,1.229-0.551,1.229-1.229
		v-1.819h12.48v1.819c0,0.678,0.551,1.229,1.229,1.229h5.111c0.677,0,1.227-0.551,1.227-1.229v-1.819h3.097V19.258z"
      />
    </g>
  </svg>
);

export const BookMarkIcon = ({
  width = "20.566",
  height = "42.237",
  fillColor = "#b03a2e",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 50.566 72.237"
    style={style}
    className={className}
  >
    <path
      d="M138.566,88.237h-5.3L113.284,70.959,93.338,88.237H88V16h50.566ZM92.816,20.816v61.5L113.282,64.59l20.468,17.7V20.816Z"
      transform="translate(-88 -16)"
      fill={fillColor}
    />
  </svg>
);
export const SaveIcon = ({
  width = "20",
  height = "20",
  fillColor = "#000",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    style={style}
    className={className}
  >
    <path
      fill={fillColor}
      d="M17 1h-4v4H7V1H3C1.9 1 1 1.9 1 3v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5l-4-4zm2 16c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1V3c0-.6.4-1 1-1h2v5h8V2h3.2L19 5v12zM5 11v2h10v-2H5z"
    />
  </svg>
);
export const SummationIcon = ({
  width = "20.389",
  height = "23.63",
  fillColor = "var(--color-bloodred)",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 20.389 23.63"
    style={style}
    className={className}
  >
    <g id="sum-sign" transform="translate(-35.403 511.719)" fill={fillColor}>
      <path
        id="Path_18935"
        data-name="Path 18935"
        d="M36.374-511.681a1.63,1.63,0,0,0-.744.564,1.317,1.317,0,0,0-.092,1.317c.06.129.869,1.04,2.293,2.57,1.211,1.3,3.263,3.508,4.558,4.9s2.357,2.561,2.357,2.593-4.035,4.262-8.528,8.921c-.689.712-.8.911-.8,1.387a1.324,1.324,0,0,0,.772,1.234l.194.106h18.4l.263-.129a1.39,1.39,0,0,0,.656-.675c.092-.2.1-.282.1-1.784,0-1.784-.009-1.849-.365-2.233a1.063,1.063,0,0,0-.975-.4,1.068,1.068,0,0,0-.957.379c-.319.328-.379.536-.4,1.387l-.018.753H39.937l.374-.384c.208-.208,1.978-2.048,3.938-4.086,3.3-3.434,3.568-3.73,3.661-3.975a1.346,1.346,0,0,0-.074-1.119c-.079-.134-1.756-1.974-3.994-4.377-2.122-2.283-3.878-4.174-3.9-4.211s1.077-.06,6.55-.06h6.582l.018,1.165c.014,1.068.023,1.188.111,1.382a1.354,1.354,0,0,0,2.283.314c.305-.384.3-.361.3-2.561v-1.988l-.129-.263a1.39,1.39,0,0,0-.675-.656l-.213-.1-9.129-.009C40.247-511.723,36.457-511.709,36.374-511.681Z"
        transform="translate(0 0)"
      />
    </g>
  </svg>
);

export const BroadCastTowerIcon = ({
  width = "640",
  height = "512",
  fillColor = "#000",
  style = {},
  className = "",
}) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      className={className}
      viewBox="0 0 640 512"
    >
      <path
        d="m150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82c3.76-10.35-3.85-21.18-14.86-21.18h-33.73c-7.01 0-13.46 4.49-15.41 11.23-4.89 16.98-7.53 34.65-7.53 52.77s2.64 35.79 7.54 52.76c1.94 6.74 8.39 11.24 15.4 11.24zm-61.02-168.66c5.64-10.62-1.95-23.34-13.96-23.34h-35.33c-6.27 0-12.14 3.59-14.74 9.31-16.49 36.23-25.89 76.34-25.89 118.69 0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zm524.14-14.05c-2.6-5.71-8.46-9.29-14.73-9.29h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29 16.53-36.23 25.96-76.35 25.96-118.71s-9.42-82.48-25.94-118.71zm-125 54.71h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76s-2.64-35.79-7.54-52.76c-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61l49.19-118.15h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92zm-101.14 155.88 48.38-116.19 48.38 116.19z"
        fill={fillColor}
      />
    </svg>
  </>
);

export const WifiIcon = ({
  width = "19.873",
  height = "14.052",
  fillColor = "#fff",
  style = {},
  className = "",
}) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      style={style}
      className={className}
      viewBox="0 0 19.873 14.052"
    >
      <g id="iconfinder_2639756_wifi_icon" transform="translate(0 0.001)">
        <path
          id="Path_14440"
          data-name="Path 14440"
          d="M12.268,12a9.106,9.106,0,0,0-6.456,2.678L8.3,17.161a5.611,5.611,0,0,1,7.945,0l2.483-2.483A9.106,9.106,0,0,0,12.268,12Z"
          transform="translate(-2.332 -7.082)"
          fill={fillColor}
        />
        <path
          id="Path_14441"
          data-name="Path 14441"
          d="M10.759,20.236l2.98,2.98,2.98-2.98a4.21,4.21,0,0,0-5.96,0Z"
          transform="translate(-3.803 -9.164)"
          fill={fillColor}
        />
        <path
          id="Path_14442"
          data-name="Path 14442"
          d="M10.794,8.513a10.506,10.506,0,0,1,7.449,3.09l2.487-2.487a14.052,14.052,0,0,0-19.873,0L3.345,11.6A10.506,10.506,0,0,1,10.794,8.513Z"
          transform="translate(-0.858 -5.001)"
          fill={fillColor}
        />
      </g>
    </svg>
  </>
);

export const TournamentControlPanelIcon = ({
  width = "25",
  height = "25",
  onClick,
  style = {},
  fillColor = "var(--color-bloodred)",
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    onClick={onClick}
    fill={fillColor}
    style={style}
    viewBox="0 0 128.001 122.897"
  >
    <g id="Group_75" data-name="Group 75" transform="translate(11298 5711)">
      <g
        id="Group_70"
        data-name="Group 70"
        transform="translate(-11225.72 -5680.189)"
      >
        <path
          id="Path_25"
          data-name="Path 25"
          d="M11.311,125.425c29.468,0,44.409-10.964,44.409-32.587V52.875A44.74,44.74,0,0,0,51.3,33.363L47.7,35.093A40.783,40.783,0,0,1,51.72,52.875V92.838c0,19.236-13.218,28.587-40.409,28.587Z"
          transform="translate(-11.311 -33.363)"
          fill={fillColor}
        />
      </g>
      <path
        id="Path_32"
        data-name="Path 32"
        d="M52.239,125.449h9.539a6.251,6.251,0,0,0,0-12.5H52.239a6.251,6.251,0,0,0,0,12.5Zm9.539-8.5a2.251,2.251,0,0,1,0,4.5H52.239a2.251,2.251,0,0,1,0-4.5Z"
        transform="translate(-11284.019 -5713.552)"
        fill={fillColor}
      />
      <g
        id="Group_71"
        data-name="Group 71"
        transform="translate(-11199.853 -5663.492)"
      >
        <g
          id="Group_64"
          data-name="Group 64"
          transform="translate(14.281 3.263)"
        >
          <path
            id="Path_28"
            data-name="Path 28"
            d="M0,101.688a15.655,15.655,0,0,0,15.572-15.7V69.023A15.654,15.654,0,0,0,0,53.323v4a11.65,11.65,0,0,1,11.572,11.7V85.986A11.65,11.65,0,0,1,0,97.687Z"
            transform="translate(0 -53.323)"
            fill={fillColor}
          />
        </g>
        <g id="Group_65" data-name="Group 65" transform="translate(0)">
          <path
            id="Path_29"
            data-name="Path 29"
            d="M18.2,105.232h5.095a6.591,6.591,0,0,0,6.561-6.606V56.666a6.591,6.591,0,0,0-6.561-6.606H18.2a6.591,6.591,0,0,0-6.562,6.606v41.96A6.591,6.591,0,0,0,18.2,105.232Zm5.1-51.172a2.587,2.587,0,0,1,2.561,2.606v41.96a2.586,2.586,0,0,1-2.561,2.606H18.2a2.587,2.587,0,0,1-2.562-2.606V56.666A2.587,2.587,0,0,1,18.2,54.06Z"
            transform="translate(-11.635 -50.06)"
            fill={fillColor}
          />
        </g>
      </g>
      <g
        id="Group_72"
        data-name="Group 72"
        transform="translate(-11286.288 -5679.948)"
      >
        <path
          id="Path_24"
          data-name="Path 24"
          d="M108.368,92.838h4V52.875a40.778,40.778,0,0,1,3.92-17.562L112.671,33.6a44.78,44.78,0,0,0-4.3,19.271Z"
          transform="translate(-108.368 -33.604)"
          fill={fillColor}
        />
      </g>
      <g
        id="Group_73"
        data-name="Group 73"
        transform="translate(-11298 -5663.489)"
      >
        <g id="Group_67" data-name="Group 67" transform="translate(0 3.54)">
          <path
            id="Path_30"
            data-name="Path 30"
            d="M128,101.975v-4A11.651,11.651,0,0,1,116.43,86.27V69.307A11.65,11.65,0,0,1,128,57.6v-4a15.654,15.654,0,0,0-15.57,15.7V86.27A15.655,15.655,0,0,0,128,101.975Z"
            transform="translate(-112.43 -53.603)"
            fill={fillColor}
          />
        </g>
        <g id="Group_68" data-name="Group 68" transform="translate(11.631)">
          <path
            id="Path_31"
            data-name="Path 31"
            d="M104.71,105.234h5.1a6.593,6.593,0,0,0,6.563-6.606V56.667a6.591,6.591,0,0,0-6.563-6.6h-5.1a6.589,6.589,0,0,0-6.56,6.6V98.628A6.591,6.591,0,0,0,104.71,105.234Zm5.1-51.171a2.587,2.587,0,0,1,2.563,2.6V98.628a2.587,2.587,0,0,1-2.563,2.606h-5.1a2.587,2.587,0,0,1-2.56-2.606V56.667a2.585,2.585,0,0,1,2.56-2.6Z"
            transform="translate(-98.15 -50.063)"
            fill={fillColor}
          />
        </g>
      </g>
      <g
        id="Group_74"
        data-name="Group 74"
        transform="translate(-11285.645 -5711)"
      >
        <g id="Group_62" data-name="Group 62">
          <path
            id="Path_27"
            data-name="Path 27"
            d="M108.2,38.256a7.4,7.4,0,0,0,3.86-1.089,7.544,7.544,0,0,0,2.517-10.292A49.424,49.424,0,0,0,71.88,2.552H55.723a49.427,49.427,0,0,0-42.7,24.324,7.545,7.545,0,0,0,2.52,10.293A7.418,7.418,0,0,0,25.79,34.628,34.649,34.649,0,0,1,55.724,17.56H71.881a34.661,34.661,0,0,1,29.933,17.065A7.482,7.482,0,0,0,108.2,38.256ZM71.881,6.551a45.457,45.457,0,0,1,39.264,22.378,3.535,3.535,0,0,1-1.17,4.824,3.415,3.415,0,0,1-4.729-1.183A38.628,38.628,0,0,0,71.881,13.56H55.724A38.615,38.615,0,0,0,22.36,32.57,3.43,3.43,0,0,1,19.4,34.256a3.388,3.388,0,0,1-1.77-.5,3.534,3.534,0,0,1-1.175-4.825A45.462,45.462,0,0,1,55.724,6.551Z"
            transform="translate(-11.956 -2.552)"
            fill={fillColor}
          />
        </g>
      </g>
    </g>
  </svg>
);

export const EarnedIcon = ({
  // fillColor = "white",
  width = "12.231",
  height = "9.952",
  fillColor = "var(--color-bloodred)",
  onClick,
  style = {},
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    onClick={onClick}
    fill={fillColor}
    style={style}
    viewBox="0 0 12.231 9.952"
  >
    <g id="earnIcon" transform="translate(-3.5 -11.3)">
      <g transform="translate(3.5 11.3)">
        <path
          d="M41.461,12.227a.923.923,0,0,0-.927-.927H39.427a.923.923,0,0,0-.927.927v.541h2.961Z"
          transform="translate(-33.865 -11.3)"
          fill={fillColor}
        />
        <path
          d="M13.482,27.6H3.749A1.258,1.258,0,0,0,2.5,28.849V34.2a1.258,1.258,0,0,0,1.249,1.249h9.733A1.258,1.258,0,0,0,14.731,34.2V28.849A1.25,1.25,0,0,0,13.482,27.6ZM6.041,29.235a1.107,1.107,0,1,1-1.107,1.107A1.107,1.107,0,0,1,6.041,29.235ZM4.315,33.316a2.53,2.53,0,0,1,.721-1.841,1.544,1.544,0,0,0,1,.386,1.48,1.48,0,0,0,1-.386,2.53,2.53,0,0,1,.721,1.841C7.753,33.986,4.315,33.986,4.315,33.316Zm8.382.412H9.324a.309.309,0,1,1,0-.618H12.7a.313.313,0,0,1,.309.309A.305.305,0,0,1,12.7,33.728Zm0-1.893H9.324a.309.309,0,1,1,0-.618H12.7a.313.313,0,0,1,.309.309A.3.3,0,0,1,12.7,31.836Zm0-1.88H9.324a.309.309,0,1,1,0-.618H12.7a.313.313,0,0,1,.309.309A.305.305,0,0,1,12.7,29.956Z"
          transform="translate(-2.5 -25.501)"
          fill={fillColor}
        />
      </g>
    </g>
  </svg>
);
export const DownArrow = ({
  fillColor = "white",
  width = "12.592",
  height = "8.906",
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    onClick={onClick}
    viewBox="0 0 12.592 8.906"
  >
    <path
      id="arrow_down-01_1_"
      data-name="arrow down-01 (1)"
      d="M4.4,7.45l6.3,8.906,6.3-8.906Z"
      transform="translate(-4.396 -7.449)"
      fill={fillColor}
    />
  </svg>
);
export const UpArrow = ({
  fillColor = "white",
  width = "12.592",
  height = "8.906",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12.592 8.906"
  >
    <path
      id="arrow_up-01_1_"
      data-name="arrow up-01 (1)"
      d="M4.4,7.45l6.3,8.906,6.3-8.906Z"
      transform="translate(-4.396 16.355) scale(1, -1)"
      fill={fillColor}
    />
  </svg>
);

export const EyeIcon = ({
  width = "29.746",
  height = "19.019",
  fillColor = "#C79F27",
  style = {},
  className = "",
}) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="ShowSvg"
      width={width}
      height={height}
      style={style}
      className={className}
      viewBox="0 0 49.746 29.019"
    >
      <path
        id="iconmonstr-eye-3"
        d="M31.091,19.509a6.218,6.218,0,1,1-12.318-1.2,3.874,3.874,0,0,0,4.985-4.914,6.562,6.562,0,0,1,1.115-.1A6.219,6.219,0,0,1,31.091,19.509ZM24.9,5C9.215,5,0,18.579,0,18.579s10.022,15.44,24.9,15.44c16.029,0,24.842-15.44,24.842-15.44S40.852,5,24.9,5Zm-.031,24.873A10.364,10.364,0,1,1,35.237,19.509,10.364,10.364,0,0,1,24.873,29.873Z"
        transform="translate(0 -5)"
        fill={fillColor}
      />
    </svg>
  </>
);
export const FilterIcon = ({ fillColor = "#f08400", width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="filters"
    width={width}
    height={height}
    viewBox="0 0 23.875 26.275"
  >
    <g id="Group_147" data-name="Group 147">
      <path
        id="Path_148"
        d="M33.936 39.584H31.6a4.089 4.089 0 0 0-3.909-2.984 4.192 4.192 0 0 0-3.938 2.984H12.338a1.138 1.138 0 1 0 0 2.277h11.415a4.05 4.05 0 0 0 7.815 0h2.338a1.136 1.136 0 0 0 1.138-1.138 1.091 1.091 0 0 0-1.108-1.139zm-6.246 2.984a1.851 1.851 0 0 1-1.846-1.846 1.846 1.846 0 0 1 3.692 0 1.851 1.851 0 0 1-1.845 1.847z"
        className="cls-1"
        data-name="Path 148"
        transform="translate(-11.2 -27.585)"
      />
      <path
        id="Path_149"
        d="M12.338 12.561h2.431a4.05 4.05 0 0 0 7.815 0h11.352a1.136 1.136 0 0 0 1.138-1.138 1.117 1.117 0 0 0-1.138-1.138H22.584a4.05 4.05 0 0 0-7.815 0h-2.431a1.136 1.136 0 0 0-1.138 1.138 1.117 1.117 0 0 0 1.138 1.138zm6.338-2.984a1.851 1.851 0 0 1 1.846 1.846 1.813 1.813 0 0 1-1.846 1.846 1.851 1.851 0 0 1-1.846-1.846 1.893 1.893 0 0 1 1.846-1.846z"
        className="cls-1"
        data-name="Path 149"
        transform="translate(-11.2 -7.3)"
      />
      <path
        id="Path_150"
        d="M33.936 68.884H22.584a4.05 4.05 0 0 0-7.815 0h-2.431a1.136 1.136 0 0 0-1.138 1.139 1.117 1.117 0 0 0 1.138 1.138h2.431a4.05 4.05 0 0 0 7.815 0h11.352a1.136 1.136 0 0 0 1.138-1.138 1.117 1.117 0 0 0-1.138-1.139zm-15.26 2.984a1.851 1.851 0 0 1-1.846-1.846 1.846 1.846 0 0 1 3.692 0 1.851 1.851 0 0 1-1.846 1.847z"
        className="cls-1"
        data-name="Path 150"
        transform="translate(-11.2 -47.871)"
      />
    </g>
    <style>
      {`   
        .cls-1 {
          fill: ${fillColor};
        }
      `}
    </style>
  </svg>
);

export const EyeSlashIcon = ({
  width = "44.913",
  height = "20.359",
  fillColor = "#C79F27",
  style = {},
  className = "",
}) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="HideSvg"
      width={width}
      height={height}
      style={style}
      className={className}
      viewBox="0 0 64.913 50.359"
    >
      <path
        id="iconmonstr-eye-8"
        d="M52.329,0,43.4,8.374A35.272,35.272,0,0,0,32.072,6.508C11.868,6.508,0,23.994,0,23.994A55.228,55.228,0,0,0,13.736,37.709l-7.77,7.765L9.74,49.249,56.106,3.777,52.329,0ZM36.271,15.426a10.642,10.642,0,0,0-14.054,13.9l-4.607,4.557a48.512,48.512,0,0,1-10.837-9.77c3.985-4.4,12.858-12.263,25.3-12.263a29.632,29.632,0,0,1,6.967.841Zm-7.7,19.836L42.162,21.934A10.651,10.651,0,0,1,28.575,35.262ZM64.064,23.994S52.714,43.878,32.072,43.878a29.1,29.1,0,0,1-10.28-1.967L26.1,37.685a22.8,22.8,0,0,0,5.971.854c12.789,0,21.632-9.415,25.369-14.318a40.864,40.864,0,0,0-9.575-7.88l3.975-3.9A44.36,44.36,0,0,1,64.064,23.994Z"
        transform="translate(0.859) rotate(1)"
        fill={fillColor}
      />
    </svg>
  </>
);

export const SmileyBubblyChat = ({
  width = "37.369",
  height = "37.369",
  fillColor = "#000000",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width}
    height={height}
    viewBox="0 0 37.369 37.369"
    style={style}
    className={className}
  >
    <defs>
      <filter
        id="Path_6"
        width="37.369"
        height="37.369"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="6" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="blur" />
        <feFlood floodOpacity="0.161" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g id="Group_2" data-name="Group 2" transform="translate(-171 -197)">
      <g transform="matrix(1, 0, 0, 1, 171, 197)" filter="url(#Path_6)">
        <path
          id="Path_6-2"
          data-name="Path 6"
          d="M12.885,21.369l-1.2-.692,2.767-4.842H18.6a1.381,1.381,0,0,0,1.383-1.383V4.767A1.381,1.381,0,0,0,18.6,3.383H4.767A1.381,1.381,0,0,0,3.383,4.767v9.684a1.381,1.381,0,0,0,1.383,1.383h6.226v1.383H4.767A2.767,2.767,0,0,1,2,14.451V4.767A2.766,2.766,0,0,1,4.767,2H18.6a2.766,2.766,0,0,1,2.767,2.767v9.684A2.767,2.767,0,0,1,18.6,17.218H15.257Z"
          transform="translate(7 1)"
          fill={fillColor}
          stroke={fillColor}
          strokeWidth="1.5"
        />
      </g>
      <path
        id="Path_7"
        data-name="Path 7"
        d="M13.66,17.3a4.186,4.186,0,0,1-3.493-1.874l1-.663a2.995,2.995,0,0,0,4.991,0l1,.663A4.186,4.186,0,0,1,13.66,17.3Z"
        transform="translate(176.833 194)"
        fill={fillColor}
        stroke={fillColor}
        strokeWidth="1.5"
      />
      <path
        id="Path_8"
        data-name="Path 8"
        d="M19.122,8a1.111,1.111,0,1,0,.8.325,1.122,1.122,0,0,0-.8-.325Z"
        transform="translate(173.742 196)"
        fill={fillColor}
        stroke={fillColor}
        strokeWidth="1.5"
      />
      <path
        id="Path_9"
        data-name="Path 9"
        d="M11.088,8a1.078,1.078,0,1,0,.773.316A1.088,1.088,0,0,0,11.088,8Z"
        transform="translate(177.508 196.068)"
        fill={fillColor}
        stroke={fillColor}
        strokeWidth="1.5"
      />
    </g>
  </svg>
);

export const ManagerIcon = ({
  width = "31.469px",
  height = "30.9px",
  fillColor = "var(--color-yellowgold)",
  style = {},
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 51.469 50.9"
      enableBackground="new 0 0 51.469 50.9"
      width={width}
      height={height}
      style={style}
      className={className}
    >
      <g>
        <path
          fill={fillColor}
          d="M14.311,32.097H13.96h-0.933l-2.217,3.85l-2.101-3.85H7.776h-0.35c-1.517,0-2.8,1.284-2.8,2.8v7.7H17.11
		v-7.7C17.11,33.381,15.827,32.097,14.311,32.097z M10.811,18.914c0.933-4.317,4.316-7.583,8.633-8.517
		c0.817-0.233,1.051,1.05,0.234,1.167c-3.734,0.817-6.65,3.617-7.584,7.233l1.166-0.933c0.584-0.467,1.401,0.467,0.817,1.05
		l-2.917,2.333l-2.333-2.917c-0.584-0.583,0.467-1.4,0.933-0.817L10.811,18.914z M41.494,18.797
		c-0.934-3.617-3.851-6.417-7.584-7.233c-0.816-0.116-0.467-1.4,0.351-1.167c4.2,0.933,7.584,4.2,8.517,8.517l1.051-1.4
		c0.582-0.583,1.517,0.233,1.05,0.817l-2.45,2.917l-2.917-2.333c-0.584-0.583,0.233-1.517,0.817-1.05L41.494,18.797z M27.261,16.347
		l0.233,1.75l-0.7,1.167l-0.583-1.167l0.116-1.75c-0.816-0.934-0.7-1.75,0.467-1.75C28.077,14.597,28.194,15.414,27.261,16.347z
		 M26.794,6.43c1.983,0,3.616,1.633,3.616,3.617c0,1.867-1.633,3.5-3.616,3.5s-3.5-1.633-3.5-3.5
		C23.294,8.063,24.811,6.43,26.794,6.43z M23.41,15.18h0.351l3.033,5.367l3.033-5.367h0.467c1.517,0,2.8,1.284,2.8,2.8v7.7H20.61
		v-7.7C20.61,16.464,21.894,15.18,23.41,15.18z M39.277,32.097h0.467h0.816l2.217,3.85l2.217-3.85h0.817h0.35
		c1.517,0,2.8,1.284,2.8,2.8v7.7H36.478v-7.7C36.478,33.381,37.761,32.097,39.277,32.097z M42.777,23.814
		c1.983,0,3.5,1.633,3.5,3.617s-1.517,3.617-3.5,3.617s-3.616-1.633-3.616-3.617S40.794,23.814,42.777,23.814z M10.811,23.814
		c-1.867,0-3.5,1.633-3.5,3.617s1.633,3.617,3.5,3.617c1.983,0,3.616-1.633,3.616-3.617S12.794,23.814,10.811,23.814z"
        />
      </g>
    </svg>
  );
};

export const MirrorIcon = ({
  width = "31.469px",
  height = "30.9px",
  fillColor = "var(--color-yellowgold)",
  style = {},
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 51.469 50.9"
      enableBackground="new 0 0 51.469 50.9"
      width={width}
      height={height}
      style={style}
      className={className}
    >
      <g>
        <path
          fill={fillColor}
          d="M25.407,1.143C19.555,1.118,14.688,7.4,14.656,15.164c-0.025,5.627,2.43,10.477,6.022,12.744
     c1.515,0.962,2.353,2.599,2.344,4.286c-0.014,3.377,0.091,5.403-1.628,12.485c-0.63,2.417,0.991,5.069,3.466,5.079
     c2.251,0.01,4.118-2.401,3.456-5.105c-1.604-6.59-1.537-9.348-1.524-12.048c0.008-1.913,1.028-3.598,2.663-4.435
     c3.835-2.121,6.501-7.118,6.526-12.969C36.071,7.491,31.316,1.112,25.407,1.143z M24.871,47.283
     c-0.787-0.004-1.458-0.907-1.396-1.976c0.004-1.125,0.627-1.967,1.414-1.964c0.788,0.003,1.46,0.907,1.398,1.976
     C26.282,46.445,25.66,47.286,24.871,47.283z M25.299,26.352c-4.051-0.017-7.52-5.096-7.493-11.173s3.537-11.126,7.588-11.109
     c4.052,0.018,7.519,5.098,7.493,11.174C32.861,21.319,29.351,26.369,25.299,26.352z"
        />
        <g>
          <rect
            x="22.938"
            y="11.015"
            fill={fillColor}
            width="7.241"
            height="0.477"
          />

          <rect
            x="20.441"
            y="12.146"
            transform="matrix(1 0.0042 -0.0042 1 0.0516 -0.0955)"
            fill={fillColor}
            width="5.173"
            height="0.477"
          />
        </g>
        <g>
          <rect
            x="22.938"
            y="11.015"
            fill={fillColor}
            width="7.241"
            height="0.477"
          />

          <rect
            x="20.441"
            y="12.146"
            transform="matrix(1 0.0042 -0.0042 1 0.0516 -0.0955)"
            fill={fillColor}
            width="5.173"
            height="0.477"
          />
        </g>
        <g>
          <rect
            x="20.736"
            y="18.691"
            fill="currentColor"
            width="7.242"
            height="0.478"
          />

          <rect
            x="25.344"
            y="17.612"
            transform="matrix(-1 -0.0043 0.0043 -1 55.7836 35.8223)"
            fill="currentColor"
            width="5.173"
            height="0.478"
          />
        </g>
        <g>
          <rect
            x="20.736"
            y="18.691"
            fill="currentColor"
            width="7.242"
            height="0.478"
          />

          <rect
            x="25.344"
            y="17.612"
            transform="matrix(-1 -0.0043 0.0043 -1 55.7836 35.8223)"
            fill="currentColor"
            width="5.173"
            height="0.478"
          />
        </g>
      </g>
    </svg>
  );
};

export const CheckMarkIcon = ({
  width = "24",
  height = "24",
  fillColor = "#fff",
  style = {},
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 13.08 13.316"
      width={width}
      height={height}
      style={style}
      className={className}
    >
      <path
        d="M6297.454,19190.949l3.891,4.619a48.73,48.73,0,0,1,3.251-5.287c2.1-3.014,5.167-6.781,5.167-6.781s-3.692,3.83-5.768,6.16-2.772,3.119-2.772,3.119Z"
        transform="translate(-6297.072 -19183.152)"
        fill={fillColor}
        stroke={fillColor}
        strokeWidth="1"
      />
    </svg>
  );
};

export const PhoneIcon = ({
  width = "18.66",
  height = "19.393",
  fillColor = "#fff", // Default fill color
  style = {},
  className = "",
}) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18.66 19.393"
      style={style}
      className={className}
    >
      <g transform="translate(0 0)">
        <path
          d="M18.494,21.484a15.24,15.24,0,0,1-3.6-2.811,15.7,15.7,0,0,1-2.708-3.741l.962-2.685L9.908,7,8.839,8.115v0c-.007.008-.015.013-.024.022-2.7,2.8-1.244,8.538,3.379,13.342s10.143,6.313,12.841,3.511c.008-.008.013-.017.021-.024l1.069-1.113-5.046-3.372Z"
          transform="translate(-7.466 -7.002)"
          fill={fillColor}
        />
        <path
          d="M39.21,17.1H40.7A9.921,9.921,0,0,0,30.991,7V8.555A8.4,8.4,0,0,1,39.21,17.1Z"
          transform="translate(-22.045 -7.002)"
          fill={fillColor}
        />
        <path
          d="M36.219,22.159h1.494a6.867,6.867,0,0,0-6.725-6.989v1.553A5.343,5.343,0,0,1,36.219,22.159Z"
          transform="translate(-22.043 -12.064)"
          fill={fillColor}
        />
        <path
          d="M33.232,27.221h1.494a3.815,3.815,0,0,0-3.735-3.883v1.553A2.289,2.289,0,0,1,33.232,27.221Z"
          transform="translate(-22.045 -17.126)"
          fill={fillColor}
        />
      </g>
    </svg>
  </>
);

export const PaperPlaneIcon = ({
  width = "35.376",
  height = "35.376",
  fillColor = "white",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 35.376 35.376"
    style={style}
    className={className}
  >
    <g transform="translate(8.291 8.478)">
      <path
        d="M17.62,35.36v8.771L36.757,18.615Z"
        transform="translate(-17.62 -18.615)"
        fill={fillColor}
      />
    </g>
    <g transform="translate(0 0)">
      <path
        d="M5.693,22.662a1.038,1.038,0,0,0-.08,1.81l7.148,4.4L38.781,5.942l.082-.109Z"
        transform="translate(-5.121 -5.833)"
        fill={fillColor}
      />
    </g>
    <g transform="translate(15.481 1.362)">
      <path
        d="M48.165,8.053,28.46,34.387l11.958,7.359a1.037,1.037,0,0,0,1.561-.691L48.355,7.886Z"
        transform="translate(-28.46 -7.886)"
        fill={fillColor}
      />
    </g>
  </svg>
);

export const PaperPlane2Icon = ({
  width = "20px",
  height = "20px",
  fillColor = "#FFFF",
}) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    enableBackground="new 0 0 20 20"
  >
    <path
      fill={fillColor}
      d="M16.968,2.49c0-0.016-0.004-0.031-0.008-0.047c-0.002-0.012-0.005-0.023-0.008-0.035
	c-0.01-0.018-0.019-0.035-0.029-0.049c-0.005-0.008-0.007-0.016-0.013-0.021l-0.003-0.002c-0.016-0.016-0.033-0.029-0.053-0.041
	c-0.006-0.004-0.011-0.01-0.016-0.014l0,0c-0.022-0.01-0.047-0.018-0.07-0.02c-0.009-0.002-0.018-0.004-0.027-0.004
	c-0.021-0.002-0.045,0-0.068,0.006c-0.009,0.002-0.018,0.006-0.025,0.01c-0.02,0.008-0.037,0.016-0.053,0.025
	C16.593,2.3,16.59,2.3,16.589,2.302L1.783,13.179c-0.106,0.078-0.13,0.229-0.052,0.336c0.046,0.059,0.117,0.096,0.193,0.096h4.327
	c0.065,0,0.128-0.025,0.172-0.074l8-8.303L12.3,8.126l-5.531,5.744c-0.136,0.139-0.322,0.217-0.517,0.217H6.014v2.307
	c0,0.131,0.107,0.238,0.238,0.238c0.07,0,0.138-0.029,0.183-0.084l1.895-2.234l3.691,3.168c0.043,0.037,0.097,0.057,0.154,0.057
	c0.022,0,0.045-0.004,0.066-0.01c0.077-0.021,0.139-0.082,0.162-0.158l4.555-14.807c0.003-0.012,0.004-0.021,0.005-0.031
	C16.966,2.517,16.968,2.503,16.968,2.49z"
    />
  </svg>
);

export const PaperPenWritingIcon = ({
  width = "44.032",
  height = "47.633",
  fillColor = "white",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 44.032 47.633"
    style={style}
    className={className}
    fill={fillColor}
  >
    <path
      d="M12.3,54.986a2.681,2.681,0,0,0,2.677,2.677H43.928A2.681,2.681,0,0,0,46.6,54.986V39.746l-1.966,4.261a3.51,3.51,0,0,1-1.42,1.529h0L37.591,48.6a2.539,2.539,0,0,1-1.147.273,2.139,2.139,0,0,1-1.42-.492,2.222,2.222,0,0,1-.819-1.366L33.112,42.04H20.548a1.256,1.256,0,1,1,0-2.513H32.839a4.806,4.806,0,0,1,.273-.819l1.639-3.551h-14.2a1.256,1.256,0,0,1,0-2.513H35.9L42.125,19.1l.656-1.366h0l.055-.109L44.31,14.4H24.645v8.521a3.835,3.835,0,0,1-3.824,3.824H12.355L12.3,54.986Zm8.248-9.013H30a1.256,1.256,0,0,1,0,2.513h-9.45a1.236,1.236,0,0,1-1.256-1.256A1.271,1.271,0,0,1,20.548,45.973Z"
      transform="translate(-12.3 -10.03)"
    />
    <path
      d="M20.916,25.316a2.308,2.308,0,0,0,2.294-2.294V15.647A1.119,1.119,0,0,0,22.063,14.5a1.312,1.312,0,0,0-.819.328l-8.521,8.521a1.118,1.118,0,0,0,.819,1.912h7.374Z"
      transform="translate(-12.34 -10.075)"
    />
    <path
      d="M83.212,8.53,79.061,6.619a2.6,2.6,0,0,0-3.387,1.256L74.8,9.732l8.74,4.042h0l.874-1.857A2.436,2.436,0,0,0,83.212,8.53Z"
      transform="translate(-40.659 -6.4)"
    />
    <path
      d="M81.079,19.151v-.109L72.339,15l-.055.109-.109.219L70.7,18.551,73.1,19.7l6.337,2.9Z"
      transform="translate(-38.799 -10.302)"
    />
    <path
      d="M65.254,40.533l5.681-12.291L65.254,25.62,62.14,24.2l-5.9,12.837L55.093,39.55,53.4,43.264l1.42.655L59.081,46l3,1.42Z"
      transform="translate(-30.949 -14.477)"
    />
    <path
      d="M52.6,61.8v.164l.328,1.529.983,4.7a.823.823,0,0,0,.819.655,1.013,1.013,0,0,0,.382-.109l5.681-3h0L56.26,63.548Z"
      transform="translate(-30.586 -31.538)"
    />
  </svg>
);

export const PeopleIcon = ({
  width = "43.256",
  height = "36.402",
  fillColor = "#fff",
  style = {},
  className = "",
}) => (
  <svg
    id="people"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 43.256 36.402"
    style={style}
    className={className}
    fill={fillColor}
  >
    <path
      d="M67.438,19.595a7.856,7.856,0,0,1,3.657,5.841,6.342,6.342,0,1,0-3.657-5.841ZM63.28,32.585a6.344,6.344,0,1,0-6.345-6.344A6.343,6.343,0,0,0,63.28,32.585Zm2.691.434H60.588a8.132,8.132,0,0,0-8.123,8.123v6.584l.017.1.454.143A36.978,36.978,0,0,0,63.981,49.75a22.613,22.613,0,0,0,9.644-1.812l.423-.215h.045V41.14A8.128,8.128,0,0,0,65.971,33.019Zm10.5-6.55H71.126a7.817,7.817,0,0,1-2.411,5.445,9.655,9.655,0,0,1,6.893,9.238v2.028a21.871,21.871,0,0,0,8.513-1.789l.424-.215h.045V34.59A8.13,8.13,0,0,0,76.47,26.469Zm-24.321-.432a6.3,6.3,0,0,0,3.372-.978,7.861,7.861,0,0,1,2.953-5.009c.006-.118.018-.237.018-.355a6.344,6.344,0,1,0-6.344,6.342Zm5.7,5.878A7.821,7.821,0,0,1,55.435,26.5c-.2-.015-.394-.031-.6-.031H49.454a8.131,8.131,0,0,0-8.121,8.121v6.585l.015.1.455.143a37.993,37.993,0,0,0,9.147,1.718V41.151A9.654,9.654,0,0,1,57.846,31.914Z"
      transform="translate(-41.333 -13.348)"
    />
  </svg>
);
export const LockIcon = ({
  width = "44.22",
  height = "58.951",
  fillColor = "#fff",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 44.22 58.951"
    style={style}
    className={className}
    fill={fillColor}
  >
    <path
      d="M47.291,24.05H43.6V19.142a17.195,17.195,0,0,0-34.389,0v4.912H5.536A1.23,1.23,0,0,0,4.3,25.284v30.7A4.918,4.918,0,0,0,9.217,60.9H43.606a4.918,4.918,0,0,0,4.915-4.912V25.28A1.236,1.236,0,0,0,47.291,24.05Zm-11.054,0H16.583V19.142a9.827,9.827,0,0,1,19.654,0Z"
      transform="translate(-4.302 -1.949)"
    />
  </svg>
);

export const LineIntersectingCircleIcon = ({
  width = "50",
  height = "50",
  fillColor = "#B03A2E",
  strokeColor = "#B03A2E",
  strokeWidth = "5",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 157.987 180.047"
    style={style}
    className={className}
  >
    <g id="power-icon" transform="translate(-25.246 -3.601)">
      <path
        id="Path_53"
        data-name="Path 53"
        d="M147.921,71.364a8.225,8.225,0,0,0-11.013,2.61,7.219,7.219,0,0,0,2.6,10.119l2.967,2.171A60.335,60.335,0,0,1,167.594,135c0,33.773-28.364,61.152-63.353,61.152S40.888,168.778,40.888,135A60.294,60.294,0,0,1,65.357,86.745l3.153-2.37a7.512,7.512,0,0,0,3.064-10.4,8.223,8.223,0,0,0-11.009-2.613L57.295,73.7c-19.44,13.887-32.049,36.17-32.049,61.309,0,42.108,35.366,76.249,78.993,76.249S183.233,177.116,183.233,135c0-25.134-12.606-47.416-32.042-61.3l-3.272-2.334Z"
        transform="translate(0 -27.607)"
        fill={fillColor}
        strokeWidth={strokeWidth}
        stroke={strokeColor}
      />
      <path
        id="Path_54"
        data-name="Path 54"
        d="M182.631,96.7c0,5.334-4.04,9.7-8.979,9.7s-8.979-4.363-8.979-9.7V13.3c0-5.333,4.041-9.7,8.979-9.7s8.979,4.364,8.979,9.7Z"
        transform="translate(-69.412)"
        fill={fillColor}
      />
    </g>
  </svg>
);
export const TimerIcon = ({
  width = "32.242",
  height = "33.395",
  fillColor = "var(--color-yellowgold)", // Assuming you might want to change the fill color dynamically
  style = {}, // For custom styling
  className = "", // To allow custom class names,
  onClick,
  id,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20.024 18.724"
    width={width}
    height={height}
    id={id}
    onClick={onClick}
    style={{ cursor: "pointer", ...style }}
    className={className}
    fill={fillColor}
  >
    <path
      d="M44.869,38.738l-1.652,1.505a1.55,1.55,0,0,0-.613-.126,1.322,1.322,0,1,0,1.444,1.316,1.211,1.211,0,0,0-.138-.559l1.652-1.505a.419.419,0,0,0,0-.631A.524.524,0,0,0,44.869,38.738Zm-1.806,3.114a.7.7,0,0,1-.919,0,.556.556,0,0,1,0-.838.7.7,0,0,1,.919,0A.556.556,0,0,1,43.063,41.852Z"
      transform="translate(-36.482 -33.61)"
      fill={fillColor}
    />
    <path
      d="M48.127,76.872a.35.35,0,0,0-.366.331v.539a.367.367,0,0,0,.731,0V77.2A.35.35,0,0,0,48.127,76.872Z"
      transform="translate(-42.006 -66.181)"
      fill={fillColor}
    />
    <path
      d="M48.127,31.39a.35.35,0,0,0,.366-.331V30.52a.367.367,0,0,0-.731,0v.539A.35.35,0,0,0,48.127,31.39Z"
      transform="translate(-42.006 -26.445)"
      fill={fillColor}
    />
    <path
      d="M23.578,55.327h-.591a.334.334,0,1,0,0,.666h.591a.334.334,0,1,0,0-.666Z"
      transform="translate(-20.974 -47.842)"
      fill={fillColor}
    />
    <path
      d="M70.259,55.327h-.591a.334.334,0,1,0,0,.666h.591a.334.334,0,1,0,0-.666Z"
      transform="translate(-60.03 -47.842)"
      fill={fillColor}
    />
    <path
      d="M23.626,9.606l.441-.4a.872.872,0,0,0,0-1.312,1.054,1.054,0,0,0-1.393,0l-.465.423a6.439,6.439,0,0,0-2.746-.991V6.508h.563a.777.777,0,0,0,.81-.738.777.777,0,0,0-.81-.738H17.238v0a.772.772,0,0,0-.779.735.772.772,0,0,0,.779.735v0h.595v.815a6.42,6.42,0,0,0-2.746.992l-.441-.4a1.091,1.091,0,0,0-1.44,0,.842.842,0,0,0,0,1.269l.465.424a5.235,5.235,0,0,0-1.144,3.249,5.868,5.868,0,0,0,6.121,5.572,5.868,5.868,0,0,0,6.121-5.577A5.224,5.224,0,0,0,23.626,9.606Zm-9.305-.7,0,0h0Zm4.328,8.613a4.914,4.914,0,0,1-5.125-4.665,4.912,4.912,0,0,1,5.12-4.674h.005a4.913,4.913,0,0,1,5.125,4.669A4.913,4.913,0,0,1,18.648,17.519Z"
      transform="translate(-12.527 -5.032)"
      fill={fillColor}
    />
  </svg>
);

export const SkitsOlympicLogoIcon = ({
  width = "40px",
  height = "40px",
  fillColor = "#fff", // Assuming you might want to change the fill color dynamically
  style = {}, // For custom styling
  className = "", // To allow custom class names,
  onClick,
  id,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    id={id}
    onClick={onClick}
    style={{ cursor: "pointer", ...style }}
    viewBox="0 0 48.996 36.832"
    className={className}
    fill={fillColor}
  >
    <path
      d="M36.3,28.438h-.993a2.447,2.447,0,0,0-2.385,2.519V44.884a2.351,2.351,0,0,0,2.385,2.411H61.629a2.439,2.439,0,0,0,2.486-2.411V30.175a10.493,10.493,0,0,1-11.941-1.74H45.963a6.322,6.322,0,0,1-9.664,0Zm6.994,7.931h9.34a1.057,1.057,0,1,1,0,2.113h-9.34a1.057,1.057,0,0,1,0-2.113Z"
      transform="translate(-32.921 -12.51)"
      fill={fillColor}
    />
    <path
      d="M42.6,30.138a4.229,4.229,0,1,1-4.229-4.229A4.227,4.227,0,0,1,42.6,30.138Z"
      transform="translate(-30.153 -18.26)"
      fill={fillColor}
    />
    <path
      d="M42.457,25.476A2.123,2.123,0,1,0,44.58,27.6,2.126,2.126,0,0,0,42.457,25.476Z"
      transform="translate(-16.048 -19.245)"
      fill={fillColor}
    />
    <path
      d="M50.7,50.692V27.842l-3.591,1.025a.671.671,0,0,0-.468.678V48.989a.674.674,0,0,0,.468.681Z"
      transform="translate(-1.701 -13.86)"
      fill={fillColor}
    />
    <path
      d="M46.784,23.574a8.351,8.351,0,1,0,8.351,8.351A8.352,8.352,0,0,0,46.784,23.574Zm0,12.59a4.239,4.239,0,1,1,4.242-4.239A4.237,4.237,0,0,1,46.784,36.164Z"
      transform="translate(-20.375 -23.574)"
      fill={fillColor}
    />
    <path
      d="M52.606,44.575V28.945l-9.517,5.3v5.032Z"
      transform="translate(-9.778 -11.35)"
      fill={fillColor}
    />
  </svg>
);

export const CellPhoneIcon = ({
  width = "18.66",
  height = "19.393",
  fillColor = "#fff", // Default fill color
  style = {},
  className = "",
}) => (
  <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18.66 19.393"
      style={style}
      className={className}
    >
      <g transform="translate(0 0)">
        <path
          d="M18.494,21.484a15.24,15.24,0,0,1-3.6-2.811,15.7,15.7,0,0,1-2.708-3.741l.962-2.685L9.908,7,8.839,8.115v0c-.007.008-.015.013-.024.022-2.7,2.8-1.244,8.538,3.379,13.342s10.143,6.313,12.841,3.511c.008-.008.013-.017.021-.024l1.069-1.113-5.046-3.372Z"
          transform="translate(-7.466 -7.002)"
          fill={fillColor}
        />
        <path
          d="M39.21,17.1H40.7A9.921,9.921,0,0,0,30.991,7V8.555A8.4,8.4,0,0,1,39.21,17.1Z"
          transform="translate(-22.045 -7.002)"
          fill={fillColor}
        />
        <path
          d="M36.219,22.159h1.494a6.867,6.867,0,0,0-6.725-6.989v1.553A5.343,5.343,0,0,1,36.219,22.159Z"
          transform="translate(-22.043 -12.064)"
          fill={fillColor}
        />
        <path
          d="M33.232,27.221h1.494a3.815,3.815,0,0,0-3.735-3.883v1.553A2.289,2.289,0,0,1,33.232,27.221Z"
          transform="translate(-22.045 -17.126)"
          fill={fillColor}
        />
      </g>
    </svg>
  </>
);

export const ComedyIcon = ({
  width = "30",
  height = "30",
  fillColor = "currentColor",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    viewBox="0 0 62.796 62.934"
    style={style}
  >
    <g transform="translate(-9.995 -8.9)">
      <path
        d="M70.732,339.958c3.934,4.2,2.883,11.54-8.919,14.16,0-5.248-8.913-7.08-20.453-7.08-12.328,0-20.978,1.839-20.978,7.343-11.8-2.358-12.328-10.489-7.606-14.949,6.292-6.292,7.868-.263,28.584-.263C60.243,339.17,63.914,332.878,70.732,339.958Z"
        transform="translate(0 -306.672)"
        fill={fillColor}
      />
      <g transform="translate(23.003 8.9)">
        <path
          d="M231.357,29.878c12.584,0,18.357-2.883,18.357-2.883V24.111c0-7.606-4.722-15.211-18.357-15.211C217.2,8.9,213,16.768,213,24.1v3.146C213,27.257,218.767,29.878,231.357,29.878Z"
          transform="translate(-213 -8.9)"
          fill={fillColor}
        />
      </g>
      <path
        d="M422.941,581.9a5.611,5.611,0,0,0-3.146,1.051,2.007,2.007,0,0,1,1.314-.525,2.621,2.621,0,1,1-2.621,2.621c0-.525.263-.788.525-1.313a5.5,5.5,0,0,0-1.314,3.409,5.248,5.248,0,1,0,5.241-5.241Z"
        transform="translate(-381.581 -536.285)"
        fill={fillColor}
      />
      <g transform="translate(23.003 53.477)">
        <path
          d="M216.937,708.8c.525.263,1.576,1.051,2.358,1.576,2.883,2.1,6.818,4.722,12.065,4.722,5.51,0,9.445-2.621,12.328-4.46.525-.263,1.314-.788,1.839-1.044a13.387,13.387,0,0,1-2.364,3.671c-2.621,2.883-7.08,6.029-11.8,6.029-4.985,0-9.964-3.409-12.584-6.555a19.831,19.831,0,0,1-1.839-3.941m-.263-4.2a4.218,4.218,0,0,0-2.621,1.051c-4.46,4.453,6.029,17.307,17.306,17.307s21.5-13.11,17.307-17.307a3.206,3.206,0,0,0-2.358-1.051c-3.671,0-7.868,6.292-15.211,6.292-6.818.006-10.752-6.292-14.423-6.292Z"
          transform="translate(-213.003 -704.6)"
          fill={fillColor}
        />
      </g>
    </g>
  </svg>
);
export const FightIcon = ({
  width = "30",
  height = "30",
  fillColor = "currentColor",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 70.478 51.676"
  >
    <g id="_971341" data-name="971341" transform="translate(-21 930.559)">
      <path
        id="Path_19"
        data-name="Path 19"
        d="M24.639-930.522a3.179,3.179,0,0,0-.79.222,1.7,1.7,0,0,1-.529.171,1.109,1.109,0,0,0-.375.1,1.779,1.779,0,0,0-.722.716c-.028.108-.085.148-.25.176-.358.057-.489.2-.569.643a8.915,8.915,0,0,1-.239.893A3.014,3.014,0,0,0,21-926.354a10.225,10.225,0,0,0,.256,2.308,9.624,9.624,0,0,0,.517,1.228c.472.955.751,1.3,1.319,1.581.426.216.443.21.483-.239.034-.4.131-.694.227-.694.21,0,.722.534.722.75a24.648,24.648,0,0,1-2.382,2.4,2.832,2.832,0,0,0-.881,1.058,1.738,1.738,0,0,0-.193.887,3.585,3.585,0,0,0,1.649,3.1l.6.495.119.415c.063.227.142.563.176.745.08.438.267.694,1.075,1.467.972.927,1.285,1.319,1.376,1.694.119.517.3.625,1.234.739a2.364,2.364,0,0,0,1.456-.21,10.493,10.493,0,0,0,1.939-1.5l.62-.608.415.256a5.953,5.953,0,0,0,2.962.915l.694.034-.108.142a.509.509,0,0,0-.114.233,3.094,3.094,0,0,0,.785.8,1.266,1.266,0,0,0,.256-.085,1.284,1.284,0,0,1,.392-.085c.182,0,.188.006.193.244a.975.975,0,0,0,.074.375,1.378,1.378,0,0,0,.972.387l.392.034.034.233a1.419,1.419,0,0,0,.148.421.63.63,0,0,1,.074.426,1.363,1.363,0,0,0,.057.512.538.538,0,0,1,0,.478c-.1.239-.08.392.176,1.041a10.11,10.11,0,0,1,.364,1.177c.2.8.506,1.8.944,3.144a5.776,5.776,0,0,1,.426,1.973.626.626,0,0,1-.2.58,1.917,1.917,0,0,0-.29.432,3.063,3.063,0,0,0-.085,1.353,6.232,6.232,0,0,0,.546.887c.415.586.472.705.455.87a20.042,20.042,0,0,1-.347,2.092c-.165.688-.722,3.957-.819,4.8a2,2,0,0,0,.188,1.439,7.248,7.248,0,0,0,2.092.6,3.573,3.573,0,0,1,.552.119,5.361,5.361,0,0,1-.028.83l-.057.8-.222.227-.216.222-.193-.188-.193-.182-.188.222a.773.773,0,0,0-.21.563c-.023.273-.051.364-.154.432-.068.051-.267.2-.449.336a4.051,4.051,0,0,1-1.376.694c-.358.136-.8.313-.967.4-.569.279-.984.881-.887,1.274.028.108.108.182.279.256.216.1.421.108,1.979.119l1.746.011.188-.142c.347-.256.415-.273,1.257-.273.824-.006,2.888-.091,2.917-.125s.165-2.405.159-2.758c0-.279-.011-.313-.256-.54l-.262-.245-.074-.6a4.446,4.446,0,0,1,0-1.694c.063-.154.171-.233.54-.421a2.917,2.917,0,0,1,1.74-.449,5.763,5.763,0,0,0,.944-.051l.29-.063-.108-.608a32.1,32.1,0,0,0-1.1-4.645,4.835,4.835,0,0,1-.284-1.791,15.2,15.2,0,0,0-.512-3.525,21.519,21.519,0,0,1-.728-6.857l-.011-2,.267-.534a13.413,13.413,0,0,1,1.922-2.888c.182-.131.182-.136.165-.563-.023-.392-.011-.432.091-.461a5.633,5.633,0,0,0,.694-.5,7.457,7.457,0,0,1,1.729-1.08,3.323,3.323,0,0,0,.591-.33,3.279,3.279,0,0,1,1.251-.6,12.384,12.384,0,0,0,2.36-1.1,14.2,14.2,0,0,1,1.819-.932,11.633,11.633,0,0,0,2.468-1.791c.466-.4,1.029-.847,1.262-1,.37-.25,1.7-1.023,1.763-1.023a6.5,6.5,0,0,1-.063,1.507,14.475,14.475,0,0,0-.119,2.5.774.774,0,0,0,.21.443.594.594,0,0,1,.165.3.205.205,0,0,0,.1.176,6.56,6.56,0,0,0,.921.063,4.416,4.416,0,0,0,1.348-.091l.517-.119.25.136a2.108,2.108,0,0,0,.58.2,25.9,25.9,0,0,0,3.2.017l.631-.04.034.91a11.514,11.514,0,0,0,.119,1.342,10.874,10.874,0,0,1,.1,2.706,4.387,4.387,0,0,1-.165,1.279,2.672,2.672,0,0,0-.125.927,3.766,3.766,0,0,1-.608,2.178,1.076,1.076,0,0,0-.313.665.328.328,0,0,1-.176.188.441.441,0,0,0-.193.159,2.882,2.882,0,0,1-.472.443,8.2,8.2,0,0,0-.967,1.023c-.341.432-.563.66-.631.66a4.43,4.43,0,0,0-1.615,1.08,7.952,7.952,0,0,1-.682.557,24.042,24.042,0,0,0-1.9,1.541,12.563,12.563,0,0,1-1.467,1.035c-.216.119-.409.529-.642,1.365a10.043,10.043,0,0,1-.313.972,1.833,1.833,0,0,0-.136.864,1.572,1.572,0,0,1-.171.9,1.406,1.406,0,0,0-.171.762,19.825,19.825,0,0,1-.335,2.218c-.188.995-.4,2.195-.489,2.667a24.035,24.035,0,0,1-.819,3.224l-.222.665.489.114c.273.063.6.131.739.154.262.04.267.045.182.284a.785.785,0,0,1-.347.336,3.589,3.589,0,0,0-1.171,1.319,1.054,1.054,0,0,0-.1,1.029l.091.222,1.205.046a6.9,6.9,0,0,0,2.456-.068,3.855,3.855,0,0,0,1.177-.716,6.937,6.937,0,0,0,.074-1.518v-1.393l.273-.756a5.508,5.508,0,0,0,.267-.932c0-.1-.04-.443-.091-.773l-.085-.6.239-.512a2.179,2.179,0,0,0,.284-1.052c.045-.614.1-.859.176-.859a6.327,6.327,0,0,0,1.3-1.382,4.008,4.008,0,0,0,.847-1.49c.074-.216.188-.529.262-.682.119-.284.136-.29.6-.472a4.491,4.491,0,0,0,.756-.364,5.222,5.222,0,0,0,1.154-1.166c.108-.165.239-.3.29-.3s.358.023.688.051a2.547,2.547,0,0,1,1.262.364,4.015,4.015,0,0,0,.8.318c.154,0,.426-.21,1.075-.836.512-.489.6-.506,1.131-.233.353.182.375.188,1.183.2l.819.011.324.444a4.85,4.85,0,0,0,1.382,1.291,7.656,7.656,0,0,0,2.371,1.052c.421.1.432.108.472.307a5.762,5.762,0,0,0,2.519,2.752,5.138,5.138,0,0,1,.711.648c.2.233.813.87,1.353,1.427l.984,1-.068.711c-.068.682-.063.716.051.9a1.189,1.189,0,0,1,.114.705,1.4,1.4,0,0,0,.273,1.035,1.139,1.139,0,0,0,1.012.267l.3-.034.04.216a2.649,2.649,0,0,0,2.741,1.91,1.235,1.235,0,0,0,.984-.341,1.451,1.451,0,0,0-.25-1.092,1.526,1.526,0,0,1-.165-.392,8.288,8.288,0,0,0-.387-.881,4.507,4.507,0,0,0-1.183-1.484l-.9-.91-.2-.824a20.334,20.334,0,0,1-.54-4.281,2.473,2.473,0,0,0-.119-1.257,6.49,6.49,0,0,0-.927-1.092,15.623,15.623,0,0,1-1.694-2.07c-1.928-2.7-2.058-2.854-2.7-3.355a5.349,5.349,0,0,0-1.643-.967c-.4-.131-.381-.114-.466-.523a4.028,4.028,0,0,1,.034-.534,1,1,0,0,0-.034-.6c-.085-.159-.119-.506-.045-.506a3.778,3.778,0,0,1,.4.2,1.7,1.7,0,0,0,.495.2c.3,0,.614-.415.859-1.143a2.008,2.008,0,0,1,.307-.591c.586-.614.847-2.058.779-4.3a5.642,5.642,0,0,1,.023-1.211,3.121,3.121,0,0,0,.307-1.08,7.471,7.471,0,0,0-.2-1.984c-.125-.665-.131-.682-.415-1.006-.159-.182-.586-.671-.95-1.086a13.17,13.17,0,0,0-1.956-1.893c-.534-.426-.6-.506-.6-.739,0-.114.034-.142.216-.171a2.2,2.2,0,0,0,1.49-.773,2.587,2.587,0,0,0,.4-1.274,2.109,2.109,0,0,1,.341-.989c.4-.824.409-.853.165-2-.1-.455-.188-.972-.2-1.149-.028-.3-.045-.324-.188-.358a2.027,2.027,0,0,1-.523-.29,2.056,2.056,0,0,0-1.137-.421.382.382,0,0,1-.347-.154,3.277,3.277,0,0,0-.563-.534l-.148-.108-.068.284c-.08.33-.011.324-.762.051a3.382,3.382,0,0,0-.552-.165,4.408,4.408,0,0,0-1.6,1.058,1.773,1.773,0,0,0-.438,1.018,2.7,2.7,0,0,1-.3.8l-.3.6.148.307c.148.3.154.324.068.523a1.542,1.542,0,0,0-.08.557c.006.188-.006.591-.028.887a1.437,1.437,0,0,0,.136.961c.1.233.176.426.176.432s-.29,0-.637-.011a10.206,10.206,0,0,0-1.257.034c-.6.063-.614.057-.824-.074a2.74,2.74,0,0,0-1.461-.4,1.7,1.7,0,0,0-.938.176c-.233.1-.682.33-1,.5l-.563.313-.58-.057a9.158,9.158,0,0,0-2.314.148,4.509,4.509,0,0,1-.461.08c-.04,0-.142-.188-.233-.415s-.256-.608-.375-.847a2.009,2.009,0,0,1-.256-1.1,2.616,2.616,0,0,1,0-.654c.023,0,.534-.08,1.131-.176,1.632-.262,1.78-.364,1.768-1.274a2.78,2.78,0,0,0-.3-1.251c-.21-.529-.267-.751-.222-.779a14.152,14.152,0,0,1,1.5-.046,5.415,5.415,0,0,0,1.746-.108c1.046-.364,1.973-1.029,1.973-1.421,0-.284-.159-.5-.569-.773a5.555,5.555,0,0,0-4.2-.648,3.455,3.455,0,0,0-.586.171,10.507,10.507,0,0,1-1.973.239l-.125-.028.114-.142a.412.412,0,0,0-.011-.569c-.256-.227-.279-.222-.569.1l-.279.307.045-.284a4.471,4.471,0,0,0,.045-.512c0-.193-.017-.227-.131-.245a.686.686,0,0,0-.307.068,1.022,1.022,0,0,1-.4.091c-.21,0-.227.011-.358.3a5.03,5.03,0,0,0-.256,1.387c0,.034-.142.108-.318.159a3.9,3.9,0,0,0-1.171.54,14.213,14.213,0,0,1-1.967.847c-.972.375-1.814.705-1.876.739a1.159,1.159,0,0,0-.273.375c-.159.307-.171.313-.409.313-.335,0-.426.063-.631.421-.279.489-.273.483-.864.2a1.316,1.316,0,0,0-.978-.21,6.113,6.113,0,0,0-2.479.8,1.528,1.528,0,0,1-.864.381,2,2,0,0,1-.54-.119,2.02,2.02,0,0,0-.989-.08,11.254,11.254,0,0,0-2.109.284,1.517,1.517,0,0,1-1.052-.028,6.515,6.515,0,0,0-1.99-.057c-.842.028-1.626.08-1.746.114a1.013,1.013,0,0,0-.392.262.611.611,0,0,1-.279.193.2.2,0,0,0-.159.108,1.033,1.033,0,0,1-.358.233,1.175,1.175,0,0,1-.728.091c-.574-.046-.824-.125-.989-.3-.114-.119-.159-.136-.222-.08s-.125-.006-.324-.375a3.919,3.919,0,0,0-1.4-1.427c-.29-.148-.353-.2-.375-.341l-.023-.165.54-.04a12.527,12.527,0,0,1,2.081.023c.159.028.682.091,1.166.142s1.137.114,1.45.148a6.016,6.016,0,0,0,1.973-.1,7.908,7.908,0,0,0,.864-.341,6.4,6.4,0,0,1,.91-.33c.682-.159,1.893-.37,2.6-.461l.722-.091.415.154a8.807,8.807,0,0,0,1.672.426,1.844,1.844,0,0,0,.563-.176,1,1,0,0,1,.677-.142.778.778,0,0,0,.836-.461c.324-.506.176-.853-.569-1.353a.812.812,0,0,0-.739-.182c-.233.017-.824.074-1.313.131-.961.114-.7.119-3.946-.114-3.332-.245-5.049-.25-5.754-.023a3.161,3.161,0,0,1-1.183.125,5.9,5.9,0,0,1-2.615-.478,10.427,10.427,0,0,0-1.91-.6,5.761,5.761,0,0,0-1.814-.028,7.369,7.369,0,0,1-.745.142,2.7,2.7,0,0,0-1.49.574,1.4,1.4,0,0,1-1.12.444c-.364,0-.455-.017-.608-.131-.273-.2-.267-.267.006-.4a1.3,1.3,0,0,0,.341-.222c.125-.136.1-.2-.426-.893l-.387-.512.063-.415c.057-.387.074-.421.25-.506.2-.091.233-.148.131-.21a1.79,1.79,0,0,1-.2-.353,3.907,3.907,0,0,0-.893-1.069,4.349,4.349,0,0,0-1.205-.978A4.11,4.11,0,0,0,24.639-930.522Z"
        transform="translate(0 0)"
        fill={fillColor}
      />
    </g>
  </svg>
);

export const ActionIcon = ({
  width = "30",
  height = "30",
  fillColor = "currentColor",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 69 50.46"
  >
    <g
      id="Group_2137"
      data-name="Group 2137"
      transform="translate(-1150 -3616)"
    >
      <g id="run" transform="translate(1150 3616)">
        <g id="Group_2131" data-name="Group 2131" transform="translate(0 0)">
          <path
            id="Path_20"
            data-name="Path 20"
            d="M20.244,16.184a3.953,3.953,0,0,1-3.478-4.377l7.854.9A3.952,3.952,0,0,1,20.244,16.184Z"
            transform="translate(5.008 -2.213)"
            fill={fillColor}
          />
          <path
            id="Path_21"
            data-name="Path 21"
            d="M23.968,11.672l-10.062-.767L13.859,8.19l9.352-.163L21.75,10.768Z"
            transform="translate(8.001 -1.505)"
            fill={fillColor}
          />
          <path
            id="Path_22"
            data-name="Path 22"
            d="M10.821,32.246a15.911,15.911,0,0,0,6.51,4.371c1.325-1.688,2.793-3.279,4.006-5.04.012-.046.014-.093.024-.14l1.2-4.353.522.145-.92,1.712.693.373a2.128,2.128,0,0,1,.541-.371l.759-1.412,1.889.53.377-1.342-.512-.143.658.019.844-1.568-3.1-.092-.05.085-.509.949-.821-.228L24.7,19.392c.041-.143.088-.28.137-.418a9.609,9.609,0,0,0-2.969,5.183,1.6,1.6,0,0,1-1.942,1.169l-.049-.014a1.6,1.6,0,0,1-1.124-1.927c1.472-5.953,4.9-9.263,10.632-9.316.554,0,.057,2.529,1.426,2.746s1.368.217,2.572-1.58a5.209,5.209,0,0,1,.75.621,1.968,1.968,0,0,1,.358.067,4.665,4.665,0,0,0,4.02-.156c1.29-.794,2.046-2.549,2.682-3.843a1.692,1.692,0,0,1,.492-.612l-3.389-10.3A.771.771,0,0,1,39.759.53L43.27,11.2a1.832,1.832,0,0,1,.969,2.511A12.089,12.089,0,0,1,39.991,19a6.78,6.78,0,0,1-4.593.736,7.109,7.109,0,0,1-.626,2.227c-.02.079-.034.159-.056.238l-1.779,6.345L29.907,27.7l-.376,1.342,3.03.851-.493,1.76a12.211,12.211,0,0,1,2.327,1.909c2.792,2.928,4.244,7.314,4.092,12.342a2.641,2.641,0,0,1-2.641,2.56h-.081A2.647,2.647,0,0,1,33.2,45.737c.11-3.606-.827-6.64-2.637-8.54a7.93,7.93,0,0,0-5.214-2.336C23.822,36.928,22,38.776,20.575,40.93a2.671,2.671,0,0,1-2.932,1.2,20.509,20.509,0,0,1-10.493-6.21C4.884,33.462,8.547,29.779,10.821,32.246Z"
            transform="translate(-6.437 0)"
            fill={fillColor}
          />
        </g>
      </g>
      <path
        id="Path_53"
        data-name="Path 53"
        d="M20.244,16.184a3.953,3.953,0,0,1-3.478-4.377l7.854.9A3.952,3.952,0,0,1,20.244,16.184Z"
        transform="matrix(1, 0.017, -0.017, 1, 1186.256, 3615.428)"
        fill={fillColor}
      />
      <path
        id="Path_54"
        data-name="Path 54"
        d="M3.5.026A3.953,3.953,0,0,0,.026,4.4L7.88,3.5A3.952,3.952,0,0,0,3.5.026Z"
        transform="translate(1203.775 3623.616) rotate(14)"
        fill={fillColor}
      />
      <path
        id="Path_55"
        data-name="Path 55"
        d="M10.821,32.246a15.911,15.911,0,0,0,6.51,4.371c1.325-1.688,2.793-3.279,4.006-5.04.012-.046.014-.093.024-.14l1.2-4.353.836,3.719-1.234-1.862.693.373c.167-.157-.885,1.419-.693,1.327l1.993-3.11,1.889.53.377-1.342-.512-.143.658.019-.326,2.347-2.525,1.7L22,30.8l.846-2.255-.295-1.319L24.7,19.392c.041-.143.088-.28.137-.418a9.609,9.609,0,0,0-2.969,5.183,1.6,1.6,0,0,1-1.942,1.169l-.049-.014a1.6,1.6,0,0,1-1.124-1.927c1.472-5.953,4.9-9.263,10.632-9.316.554,0,.057,2.529,1.426,2.746s1.368.217,2.572-1.58a5.209,5.209,0,0,1,.75.621,1.968,1.968,0,0,1,.358.067,4.665,4.665,0,0,0,4.02-.156c1.29-.794,2.046-2.549,2.682-3.843a1.692,1.692,0,0,1,.492-.612l-.147.39c-.133-.4.358-.6.546-.712s.169.01.417,0l.769.207a1.832,1.832,0,0,1,.969,2.511A12.089,12.089,0,0,1,39.991,19a6.78,6.78,0,0,1-4.593.736,7.109,7.109,0,0,1-.626,2.227c-.02.079-.034.159-.056.238l-1.779,6.345L29.53,29.711v-.672l3.407-.491-.87,3.1a12.211,12.211,0,0,1,2.327,1.909c2.792,2.928,4.244,7.314,4.092,12.342a2.641,2.641,0,0,1-2.641,2.56h-.081A2.647,2.647,0,0,1,33.2,45.737c.11-3.606-.827-6.64-2.637-8.54a7.93,7.93,0,0,0-5.214-2.336C23.822,36.928,22,38.776,20.575,40.93a2.671,2.671,0,0,1-2.932,1.2,20.509,20.509,0,0,1-10.493-6.21C4.884,33.462,8.547,29.779,10.821,32.246Z"
        transform="translate(1174.563 3618)"
        fill={fillColor}
      />
      <line
        id="Line_517"
        data-name="Line 517"
        x1="7"
        transform="translate(1188.5 3632.5)"
        fill="none"
        stroke={fillColor}
        strokeWidth="1"
      />
      <line
        id="Line_518"
        data-name="Line 518"
        x1="4"
        transform="translate(1188.5 3640.5)"
        fill="none"
        stroke={fillColor}
        strokeWidth="1"
      />
      <line
        id="Line_519"
        data-name="Line 519"
        x1="4"
        transform="translate(1188.5 3650.5)"
        fill="none"
        stroke={fillColor}
        strokeWidth="1"
      />
    </g>
  </svg>
);
export const CameraIcon = ({ width = "30", height = "23.7", onClick, id }) => (
  <div id={id} onClick={onClick} style={{ cursor: "pointer" }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 30 23.7"
      style={{ cursor: "pointer" }}
    >
      <g id="Group_17" data-name="Group 17" transform="translate(16851 16085)">
        <g id="Camera-03" transform="translate(-16851 -16085)">
          <path
            id="Path_30"
            data-name="Path 30"
            d="M30,22.5a1.272,1.272,0,0,1-1.4,1.2H1.4A1.272,1.272,0,0,1,0,22.5V2.5A1.272,1.272,0,0,1,1.4,1.3H28.5a1.272,1.272,0,0,1,1.4,1.2v20Z"
            fill="#fff"
          />
          <path
            id="Path_31"
            data-name="Path 31"
            d="M2.5,1.8V.3A.319.319,0,0,1,2.8,0H6.2a.265.265,0,0,1,.3.3V1.8Z"
          />
          <path
            id="Path_32"
            data-name="Path 32"
            d="M17.4,4.8a.319.319,0,0,1-.3.3H12.8a.319.319,0,0,1-.3-.3V2a.319.319,0,0,1,.3-.3h4.3a.319.319,0,0,1,.3.3Z"
          />
          <path
            id="Path_33"
            data-name="Path 33"
            d="M16.9,4.2a.319.319,0,0,1-.3.3H13.4a.319.319,0,0,1-.3-.3V2.6a.319.319,0,0,1,.3-.3h3.2a.319.319,0,0,1,.3.3Z"
            fill="#fff"
          />
          <path
            id="Path_34"
            data-name="Path 34"
            d="M15.9,3.7a.319.319,0,0,1-.3.3H14.5a.319.319,0,0,1-.3-.3V3.1a.319.319,0,0,1,.3-.3h1.1a.319.319,0,0,1,.3.3Z"
          />
          <g id="Group_13" data-name="Group 13">
            <path
              id="Path_35"
              data-name="Path 35"
              d="M28.1,3.1v2h-4v-2h4m.1-.4H24a.319.319,0,0,0-.3.3V5.2a.319.319,0,0,0,.3.3h4.2a.319.319,0,0,0,.3-.3V2.9c0-.1-.1-.2-.3-.2Z"
            />
          </g>
          <rect
            id="Rectangle_43"
            data-name="Rectangle 43"
            width="30"
            height="15.6"
            transform="translate(0 6.9)"
            fill="#fdfd96"
          />
          <circle
            id="Ellipse_1"
            data-name="Ellipse 1"
            cx="1"
            cy="1"
            r="1"
            transform="translate(2.4 9.2)"
            fill="#fff"
          />
          <circle
            id="Ellipse_2"
            data-name="Ellipse 2"
            cx="0.6"
            cy="0.6"
            r="0.6"
            transform="translate(2.8 9.6)"
            fill="#d14527"
          />
          <g id="Group_16" data-name="Group 16">
            <g id="Group_14" data-name="Group 14">
              <path
                id="Path_36"
                data-name="Path 36"
                d="M8.7,19.2A8.042,8.042,0,0,1,10,8,7.951,7.951,0,0,1,21.2,9.3"
                fill="#fff"
              />
              <path
                id="Path_37"
                data-name="Path 37"
                d="M21.2,9.3A7.973,7.973,0,1,1,8.7,19.2"
                fill="#fff"
              />
            </g>
            <g id="Group_15" data-name="Group 15">
              <path
                id="Path_38"
                data-name="Path 38"
                d="M15,6.9A7.2,7.2,0,1,1,7.8,14,7.149,7.149,0,0,1,15,6.9m0-1.3a8.5,8.5,0,1,0,8.5,8.5A8.623,8.623,0,0,0,15,5.6Z"
              />
            </g>
            <circle
              id="Ellipse_3"
              data-name="Ellipse 3"
              cx="4.4"
              cy="4.4"
              r="4.4"
              transform="translate(10.9 9.7)"
            />
            <path
              id="Path_39"
              data-name="Path 39"
              d="M.9,0A.9.9,0,1,1,0,.9.9.9,0,0,1,.9,0Z"
              transform="translate(12.9 13.7)"
              fill="#fff"
            />
            <circle
              id="Ellipse_5"
              data-name="Ellipse 5"
              cx="0.8"
              cy="0.8"
              r="0.8"
              transform="translate(14.5 15.1)"
              fill="#fff"
            />
          </g>
          <rect
            id="Rectangle_44"
            data-name="Rectangle 44"
            width="3.7"
            height="0.8"
            transform="translate(24.3 3.2)"
          />
        </g>
      </g>
    </svg>
  </div>
);

export const MusicalIcon = ({
  width = "30",
  height = "30",
  fillColor = "currentColor",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 57.229 42.345"
  >
    <g
      id="Group_2138"
      data-name="Group 2138"
      transform="translate(-1305.771 -4000.116)"
    >
      <g id="theater-stage-2808" transform="translate(1305.771 3967.225)">
        <path
          id="Path_27"
          data-name="Path 27"
          d="M56.594,32.891H.636A.636.636,0,0,0,0,33.527V74.6s0,0,0,0a.648.648,0,0,0,.049.244.632.632,0,0,0,.139.205v0a.686.686,0,0,0,.064.042.617.617,0,0,0,.14.092.636.636,0,0,0,.242.049H56.593a.633.633,0,0,0,.242-.049.645.645,0,0,0,.143-.093.616.616,0,0,0,.06-.039v0a.629.629,0,0,0,.189-.449s0,0,0,0V33.527A.635.635,0,0,0,56.594,32.891ZM46.038,34.163h9.92v2.231a4.96,4.96,0,1,1-9.92,0V34.163Zm-1.272,2.231a4.96,4.96,0,0,1-9.92,0V34.163h9.92ZM55.141,73.963H2.09c4.563-5.222,6.122-11.445,4.632-18.526a17.683,17.683,0,0,0,8.772-13.121,6.209,6.209,0,0,0,7.526-3.2,6.218,6.218,0,0,0,11.192,0,6.209,6.209,0,0,0,7.526,3.2A17.681,17.681,0,0,0,50.51,55.438C49.019,62.518,50.577,68.74,55.141,73.963Zm-3.213-18.2a5.8,5.8,0,0,0,4.03-1.64V72.961c-4.222-4.9-5.6-10.554-4.207-17.211C51.809,55.752,51.87,55.76,51.928,55.76ZM1.272,54.12A5.8,5.8,0,0,0,5.3,55.76c.058,0,.118-.008.177-.01,1.392,6.657.015,12.309-4.207,17.211Zm32.3-17.727a4.96,4.96,0,1,1-9.92,0V34.163h9.92v2.231Zm-11.192,0a4.96,4.96,0,1,1-9.92,0V34.163h9.92v2.231ZM1.272,34.163h9.92v2.231a4.96,4.96,0,1,1-9.92,0Zm4.96,8.463a6.234,6.234,0,0,0,5.6-3.507,6.264,6.264,0,0,0,2.454,2.648A16.236,16.236,0,0,1,5.827,54.458a4.993,4.993,0,0,1-4.555-2.189V40.151A6.218,6.218,0,0,0,6.232,42.626Zm49.726,9.642c-1.382,1.676-2.8,2.358-4.556,2.189a16.235,16.235,0,0,1-8.453-12.691A6.268,6.268,0,0,0,45.4,39.118,6.213,6.213,0,0,0,55.958,40.15V52.268Z"
          fill={fillColor}
          stroke={fillColor}
          strokeWidth="1.5"
        />
      </g>
      <g id="tragedy-theater-2812" transform="translate(1321.315 3969.041)">
        <path
          id="Path_28"
          data-name="Path 28"
          d="M7.768,92.907l-.082-.013c-4.2-.64-6.7-4.713-7.642-12.452L0,80.085l.358.034a25.589,25.589,0,0,0,9.255-.8l.154.557a26.15,26.15,0,0,1-9.1.846C1.6,87.89,3.9,91.682,7.691,92.309a5.942,5.942,0,0,0,2.345-1.864l.462.348a6.518,6.518,0,0,1-2.653,2.08Z"
          transform="translate(0 -33.316)"
          fill={fillColor}
          stroke={fillColor}
          strokeWidth=".5"
        />
        <path
          id="Path_29"
          data-name="Path 29"
          d="M38.182,125.01a.869.869,0,0,0-.387-.124,2.706,2.706,0,0,0-.353-.024,2.06,2.06,0,0,0-.587.077,1.951,1.951,0,0,0-.526.256,2.436,2.436,0,0,0-.276.215.827.827,0,0,0-.245.322.6.6,0,0,1-.15-.479,1.2,1.2,0,0,1,.142-.488,1.364,1.364,0,0,1,.81-.658,1.391,1.391,0,0,1,1.032.1,1.224,1.224,0,0,1,.389.322A.611.611,0,0,1,38.182,125.01Z"
          transform="translate(-31.97 -73.421)"
          fill={fillColor}
          stroke={fillColor}
          strokeWidth="1.5"
        />
        <path
          id="Path_30"
          data-name="Path 30"
          d="M71.843,121.181a.825.825,0,0,0-.318-.25,2.444,2.444,0,0,0-.322-.139,1.9,1.9,0,0,0-.574-.113,2.111,2.111,0,0,0-.587.076,2.737,2.737,0,0,0-.335.113.874.874,0,0,0-.344.218.612.612,0,0,1,.026-.5,1.222,1.222,0,0,1,.295-.41,1.387,1.387,0,0,1,.972-.362,1.368,1.368,0,0,1,.949.431,1.2,1.2,0,0,1,.261.436A.6.6,0,0,1,71.843,121.181Z"
          transform="translate(-62.154 -69.62)"
          fill={fillColor}
          stroke={fillColor}
          strokeWidth="1.5"
        />
        <path
          id="Path_31"
          data-name="Path 31"
          d="M52.892,155.491a1.359,1.359,0,0,0-.52-.451,3.271,3.271,0,0,0-.6-.259,2.569,2.569,0,0,0-2.32.3,3.307,3.307,0,0,0-.513.4,1.361,1.361,0,0,0-.39.568,1.057,1.057,0,0,1,.028-.791,2.2,2.2,0,0,1,.426-.692,2.348,2.348,0,0,1,3.073-.4,2.194,2.194,0,0,1,.587.561A1.055,1.055,0,0,1,52.892,155.491Z"
          transform="translate(-43.472 -100.072)"
          fill={fillColor}
          strokeWidth="1.5"
        />
        <path
          id="Path_32"
          data-name="Path 32"
          d="M142.317,95.288a.993.993,0,0,0-.334-.327,2.766,2.766,0,0,0-.364-.208,2.167,2.167,0,0,0-.7-.208,2.056,2.056,0,0,0-.718.064,2.553,2.553,0,0,0-.393.136.946.946,0,0,0-.383.264.7.7,0,0,1,.077-.56,1.4,1.4,0,0,1,.373-.439,1.586,1.586,0,0,1,1.134-.328,1.621,1.621,0,0,1,1.041.545,1.443,1.443,0,0,1,.284.5A.712.712,0,0,1,142.317,95.288Z"
          transform="translate(-124.985 -46.184)"
          stroke={fillColor}
          fill={fillColor}
          strokeWidth="1.5"
        />
        <path
          id="Path_33"
          data-name="Path 33"
          d="M181.287,105.966a.944.944,0,0,0-.2-.421,2.534,2.534,0,0,0-.272-.315,2.038,2.038,0,0,0-.59-.416,2.2,2.2,0,0,0-.708-.17,2.83,2.83,0,0,0-.419,0,1,1,0,0,0-.453.115.709.709,0,0,1,.267-.5,1.44,1.44,0,0,1,.5-.287,1.617,1.617,0,0,1,1.174.052,1.59,1.59,0,0,1,.815.853,1.4,1.4,0,0,1,.1.566A.7.7,0,0,1,181.287,105.966Z"
          transform="translate(-160.181 -55.339)"
          fill={fillColor}
          stroke={fillColor}
          strokeWidth="1.5"
        />
        <path
          id="Path_34"
          data-name="Path 34"
          d="M145.4,134.59a1.244,1.244,0,0,1-.405.814,2.6,2.6,0,0,1-.766.532,2.741,2.741,0,0,1-3.439-.925,2.6,2.6,0,0,1-.4-.846,1.242,1.242,0,0,1,.059-.908,1.556,1.556,0,0,0,.33.735,3.664,3.664,0,0,0,.521.571,2.94,2.94,0,0,0,2.705.729,3.652,3.652,0,0,0,.737-.232A1.559,1.559,0,0,0,145.4,134.59Z"
          transform="translate(-125.827 -81.676)"
          fill={fillColor}
          stroke={fillColor}
          strokeWidth=".5"
        />
        <path
          id="Path_35"
          data-name="Path 35"
          d="M111.508,59.383l-.071-.043c-4.233-2.553-5.112-8.057-2.688-16.827l.1-.347.318.168A30.046,30.046,0,0,0,122.1,45.817l.359.014-.091.348c-2.307,8.8-5.831,13.12-10.773,13.2Zm-2.3-16.371C107,51.246,107.8,56.414,111.664,58.8c4.541-.125,7.83-4.19,10.049-12.424A30.588,30.588,0,0,1,109.212,43.012Z"
          transform="translate(-96.314)"
          fill={fillColor}
          stroke={fillColor}
          strokeWidth=".5"
        />
      </g>
      <g
        id="treble-g-clef-music-note-black-thick-outline-19063"
        transform="translate(1242.027 4017.71)"
      >
        <path
          id="Path_36"
          data-name="Path 36"
          d="M80.991,13.562a3.56,3.56,0,0,0-.43-1.583,3.46,3.46,0,0,0-1.087-1.2,3.36,3.36,0,0,0-2.069-.574c-.168-1.034-.354-2.064-.547-3.089.046-.048.093-.094.139-.143a5.636,5.636,0,0,0,1.024-1.5,4.211,4.211,0,0,0,.363-1.76,5.579,5.579,0,0,0-.293-1.705,6.714,6.714,0,0,1-.066,1.674,4,4,0,0,1-.584,1.478,4.838,4.838,0,0,1-.783.9q-.13-.668-.263-1.333c-.112-.6-.235-1.19-.33-1.8l-.037-.2L76,2.546A3.4,3.4,0,0,1,76,2.165a2.44,2.44,0,0,1,.138-.739,1.464,1.464,0,0,1,.359-.582.5.5,0,0,1,.523-.126,1.353,1.353,0,0,1,.607.5,5.045,5.045,0,0,1,.47.791,3.7,3.7,0,0,0-.188-.94A1.761,1.761,0,0,0,77.3.2a1.122,1.122,0,0,0-.606-.2,1.313,1.313,0,0,0-.632.152,2.192,2.192,0,0,0-.83.815A3.286,3.286,0,0,0,74.826,2a3.611,3.611,0,0,0-.078.544c-.006.091-.007.183-.01.275l.006.258c.01.625.057,1.265.117,1.887.075.76.169,1.515.275,2.265l-.1.069c-.466.318-.946.644-1.411,1.02a8.014,8.014,0,0,0-1.312,1.3,5.966,5.966,0,0,0-.941,1.678,6.69,6.69,0,0,0-.386,1.875,5.245,5.245,0,0,0,1.242,3.748,5.13,5.13,0,0,0,1.606,1.253,4.939,4.939,0,0,0,3.551.306c.014.058.029.117.042.173a2.875,2.875,0,0,1,.021.815,3.783,3.783,0,0,1-.57,1.586,3.365,3.365,0,0,1-1.223,1.181,2.026,2.026,0,0,1-1.652.15,2.508,2.508,0,0,1-.407-.167,1.234,1.234,0,1,0-.521-.183,2.74,2.74,0,0,0,.824.608,2.314,2.314,0,0,0,.969.209,2.589,2.589,0,0,0,.979-.208A3.783,3.783,0,0,0,77.382,21.4a4.379,4.379,0,0,0,.818-1.822,3.672,3.672,0,0,0,.049-1.035l-.015-.4a4.953,4.953,0,0,0,1.3-.927,4.924,4.924,0,0,0,1.459-3.647h0Zm-7.436,2.2a3.7,3.7,0,0,1-.926-2.52,5.711,5.711,0,0,1,.217-1.458,4.921,4.921,0,0,1,.627-1.321,7.561,7.561,0,0,1,1.007-1.177c.268-.259.557-.513.85-.768q.182,1.139.392,2.271a3.165,3.165,0,0,0-1.232,1.742,3.018,3.018,0,0,0-.03,1.412,2.77,2.77,0,0,0,.609,1.207,2.768,2.768,0,0,1-.062-2.435,2.576,2.576,0,0,1,.882-1.03q.059.315.119.63.362,1.817.772,3.625c.064.279.132.557.2.835a3.416,3.416,0,0,1-1.084.13A3.314,3.314,0,0,1,73.555,15.76Zm4.813.24c-.076.07-.157.136-.239.2-.011-.155-.021-.31-.034-.464-.1-1.241-.246-2.475-.413-3.7-.035-.25-.076-.5-.114-.748a2.227,2.227,0,0,1,1.155.513,2.181,2.181,0,0,1,.777,1.766h0A3.5,3.5,0,0,1,78.368,16Z"
          transform="translate(0)"
          fill={fillColor}
          stroke={fillColor}
          strokeWidth=".5"
        />
      </g>
      <g
        id="treble-g-clef-music-note-black-thick-outline-19063-2"
        data-name="treble-g-clef-music-note-black-thick-outline-19063"
        transform="translate(1272.027 4016.71)"
      >
        <path
          id="Path_36-2"
          data-name="Path 36"
          d="M81.429,14.156a3.715,3.715,0,0,0-.449-1.652,3.611,3.611,0,0,0-1.134-1.248,3.507,3.507,0,0,0-2.16-.6c-.175-1.08-.369-2.154-.571-3.224.048-.05.1-.1.145-.149A5.883,5.883,0,0,0,78.33,5.717a4.4,4.4,0,0,0,.379-1.837A5.823,5.823,0,0,0,78.4,2.1a7.008,7.008,0,0,1-.069,1.747,4.178,4.178,0,0,1-.61,1.543,5.05,5.05,0,0,1-.818.944q-.136-.7-.275-1.392c-.117-.629-.246-1.242-.345-1.876l-.038-.213-.024-.2a3.544,3.544,0,0,1-.009-.4,2.547,2.547,0,0,1,.144-.771,1.528,1.528,0,0,1,.374-.607.522.522,0,0,1,.546-.131,1.412,1.412,0,0,1,.633.525A5.266,5.266,0,0,1,78.4,2.1a3.858,3.858,0,0,0-.2-.982,1.839,1.839,0,0,0-.632-.906A1.171,1.171,0,0,0,76.943,0a1.371,1.371,0,0,0-.66.159,2.287,2.287,0,0,0-.866.851,3.43,3.43,0,0,0-.422,1.072,3.77,3.77,0,0,0-.082.568c-.006.1-.008.192-.01.287l.006.269c.011.652.06,1.32.122,1.969.078.794.177,1.581.287,2.365l-.1.072c-.487.332-.987.672-1.472,1.064a8.364,8.364,0,0,0-1.37,1.353,6.228,6.228,0,0,0-.983,1.751,6.983,6.983,0,0,0-.4,1.957,5.475,5.475,0,0,0,1.3,3.912,5.355,5.355,0,0,0,1.676,1.308,5.155,5.155,0,0,0,3.706.319c.015.06.03.122.044.181a3,3,0,0,1,.022.85,3.948,3.948,0,0,1-.6,1.656A3.512,3.512,0,0,1,75.86,23.2a2.115,2.115,0,0,1-1.724.157,2.618,2.618,0,0,1-.425-.175,1.288,1.288,0,1,0-.544-.192,2.859,2.859,0,0,0,.86.635,2.415,2.415,0,0,0,1.011.218,2.7,2.7,0,0,0,1.022-.217,3.949,3.949,0,0,0,1.6-1.292,4.571,4.571,0,0,0,.854-1.9,3.833,3.833,0,0,0,.051-1.08l-.016-.42a5.17,5.17,0,0,0,1.355-.968,5.139,5.139,0,0,0,1.523-3.807h0ZM73.668,16.45a3.858,3.858,0,0,1-.967-2.63,5.961,5.961,0,0,1,.226-1.522,5.136,5.136,0,0,1,.654-1.379,7.892,7.892,0,0,1,1.052-1.229c.279-.27.581-.535.888-.8q.19,1.189.409,2.37a3.3,3.3,0,0,0-1.286,1.818,3.151,3.151,0,0,0-.032,1.474,2.891,2.891,0,0,0,.635,1.26,2.89,2.89,0,0,1-.064-2.541,2.689,2.689,0,0,1,.92-1.075q.062.329.124.657.378,1.9.806,3.783c.066.291.138.581.206.871a3.566,3.566,0,0,1-1.131.135A3.459,3.459,0,0,1,73.668,16.45Zm5.024.25c-.08.073-.163.142-.249.207-.012-.162-.022-.323-.035-.484-.1-1.3-.257-2.583-.431-3.866-.037-.261-.08-.52-.119-.781a2.324,2.324,0,0,1,1.206.536,2.276,2.276,0,0,1,.811,1.843h0A3.648,3.648,0,0,1,78.692,16.7Z"
          transform="translate(0)"
          fill={fillColor}
          stroke={fillColor}
          strokeWidth=".5"
        />
      </g>
    </g>
  </svg>
);

export const CoupleIcon = ({
  width = "30",
  height = "30",
  fillColor = "currentColor",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 38.638 60.852"
  >
    <g
      id="Couple-Holding-Hands-Silhouette"
      transform="translate(-45.881 -46.037)"
    >
      <path
        id="Path_37"
        data-name="Path 37"
        d="M75,69.287c.071,0,.106.028.1.112-.023.185-.032.372-.051.557-.007.066,0,.1.08.117a3.865,3.865,0,0,1,1.621.88,10.3,10.3,0,0,1,2.5,3.306c.767,1.615,1.544,3.227,2.24,4.874.32.759.7,1.482,1.086,2.209.217.413.436.824.69,1.216a1.331,1.331,0,0,1,.106.286c.266.738.583,1.457.857,2.192.095.253.2.5.286.76a.2.2,0,0,1-.034.2,1.973,1.973,0,0,1-.261.266,3.68,3.68,0,0,1-1.769.875c-.435.089-.88.118-1.314.212-.282.061-.565.116-.845.187a1.773,1.773,0,0,0-.557.247c-.058.039-.093.078-.082.149s-.029.1-.106.108c-.963.045-1.925.128-2.89.12a2.554,2.554,0,0,0-.875.146,2.678,2.678,0,0,1-1.286.132c-.092-.013-.115.017-.135.093a9.2,9.2,0,0,0-.2,1.154,3.259,3.259,0,0,1-.261,1.082,3.232,3.232,0,0,0-.229.566c-.25.87-.5,1.74-.688,2.626a4.117,4.117,0,0,0-.088.753c-.036,1.551-.111,3.1-.125,4.652,0,.115.025.175.141.212a1.144,1.144,0,0,1,.476.281,2.288,2.288,0,0,0,.554.365.6.6,0,0,1,.216.191c.076.11.162.212.235.324.129.2.081.345-.141.428a2.976,2.976,0,0,1-.875.217c-.149.009-.152.013-.149.164a8.829,8.829,0,0,0,.025,1.039,1.894,1.894,0,0,0,.107.439.731.731,0,0,1,.007.521.359.359,0,0,1-.026.075,1.726,1.726,0,0,0-.153,1.085,3.816,3.816,0,0,1-.01.759.822.822,0,0,1-.1.315,1.356,1.356,0,0,0-.207.585.648.648,0,0,1-.826.5,4.423,4.423,0,0,1-.517-.212c-.324-.166-.642-.342-.957-.526a.863.863,0,0,1-.393-.8.18.18,0,0,1,.037-.1c.253-.434.47-.886.682-1.341a2.335,2.335,0,0,0,.161-.436,1.919,1.919,0,0,1,.192-.5,1.788,1.788,0,0,0,.218-1.219,5.915,5.915,0,0,0-.2-.991c-.12-.343-.262-.679-.363-1.028a25.9,25.9,0,0,1-.808-3.349c-.112-.742-.257-1.478-.379-2.219-.13-.793-.237-1.59-.339-2.387q-.089-.7-.123-1.407a7.24,7.24,0,0,0-.19-1.074.36.36,0,0,0-.035-.086c-.125-.25-.251-.5-.374-.751a.17.17,0,0,0-.138-.106c-.184-.029-.367-.065-.55-.1a.293.293,0,0,0-.144.011c-.2.058-.391.117-.589.168a1.8,1.8,0,0,1-.935,0c-.75-.2-1.5-.39-2.252-.595-.351-.1-.687-.24-1.043-.319-.23-.051-.461-.095-.691-.141-.095-.019-.111.012-.11.1,0,.564,0,1.129,0,1.7.053-.031,0-.087.049-.117a2.271,2.271,0,0,1,0,.383c-.054-.032-.015-.092-.056-.122-.033.086-.062.174-.1.256a.619.619,0,0,1-.606.4,7.359,7.359,0,0,0-1.1.064,2.437,2.437,0,0,0-.617.159.539.539,0,0,0-.34.437c-.2,1.123-.452,2.236-.7,3.348-.078.346-.162.691-.235,1.039a8.994,8.994,0,0,1-.379,1.135c-.335.945-.723,1.871-1.035,2.824a12.7,12.7,0,0,0-.536,2.155,5.158,5.158,0,0,0-.046.784.169.169,0,0,0,.044.12c.359.4.722.8,1.109,1.171a2.66,2.66,0,0,0,1.13.653,1.435,1.435,0,0,1,.451.193.68.68,0,0,1,.27.368.289.289,0,0,1-.185.415c-.3.143-.611.269-.9.431a.868.868,0,0,1-.687.063,5.7,5.7,0,0,1-1.164-.452c-.336-.172-.665-.357-1.014-.5a1.18,1.18,0,0,0-.479-.1,3.482,3.482,0,0,1-.834-.081c-.056-.013-.11-.032-.166-.049a.237.237,0,0,1-.193-.243c-.027-.376-.075-.751-.119-1.126a.271.271,0,0,1,.062-.218,2.9,2.9,0,0,0,.463-1,11.6,11.6,0,0,0,.376-1.946,48.179,48.179,0,0,0,.272-5.7,1.091,1.091,0,0,1,.045-.314q.447-1.506.889-3.013c.048-.162.12-.315.159-.48a.572.572,0,0,0-.331-.7.135.135,0,0,1-.1-.136,13.324,13.324,0,0,0-.148-1.377,7.021,7.021,0,0,1-.069-.876c0-.756-.019-1.511-.083-2.264q-.034-.4-.108-.805a.157.157,0,0,0-.041-.094c-.072.325-.144.644-.211.963-.145.686-.3,1.37-.421,2.061a6.3,6.3,0,0,0-.041.7,5.893,5.893,0,0,1-.451,2.03,3.917,3.917,0,0,1-.5.847.257.257,0,0,0-.069.179,11.064,11.064,0,0,1-.327,2.931,17.077,17.077,0,0,0-.325,1.808,2.207,2.207,0,0,0,.11.984c.092.269.182.538.274.807a3.223,3.223,0,0,1,.133,1.615c-.065.38-.1.766-.151,1.149a1.022,1.022,0,0,0,.016.357,1.763,1.763,0,0,1-.022.84,17.647,17.647,0,0,0-.4,1.86c-.006.044-.022.086-.027.13-.04.393-.318.536-.651.614a1.135,1.135,0,0,1-.717-.081,2.379,2.379,0,0,1-1.28-1.274,1.908,1.908,0,0,1-.081-1.1,7.027,7.027,0,0,1,.532-1.642c.127-.293.239-.593.379-.88a1.852,1.852,0,0,0,.132-1.052,18.7,18.7,0,0,0-.666-3.04,16.792,16.792,0,0,1-.514-2.366,5.961,5.961,0,0,1,.268-2.707.548.548,0,0,0,.021-.3c-.194-.953-.351-1.913-.453-2.881a19.677,19.677,0,0,1-.117-2.329c.006-.444,0-.889,0-1.333,0-.137,0-.137-.138-.13a4.283,4.283,0,0,1-1.778-.268.382.382,0,0,1-.144-.092,3.153,3.153,0,0,1-.865-3.122c.036-.156.062-.313.087-.471a1.176,1.176,0,0,0-.026-.475c-.16-.637-.336-1.27-.447-1.919-.129-.754-.211-1.513-.268-2.275-.088-1.171-.112-2.343-.131-3.517a10.764,10.764,0,0,1,.23-2.249c.153-.78.336-1.554.45-2.341.1-.677.193-1.354.282-2.032q.149-1.136.283-2.274c.079-.657.152-1.315.224-1.973a.467.467,0,0,1,.092-.244,8.154,8.154,0,0,1,1.587-1.533,17.984,17.984,0,0,1,1.513-1.02,17.753,17.753,0,0,0,2.21-1.556,6.262,6.262,0,0,0,.633-.61.3.3,0,0,0,.074-.178,5.991,5.991,0,0,0,.067-.929,1.366,1.366,0,0,0-.055-.353c-.2-.627-.431-1.241-.613-1.872a6.319,6.319,0,0,1-.3-1.968,4.279,4.279,0,0,1,.227-1.374,1.572,1.572,0,0,1,.964-1.017.1.1,0,0,0,.081-.105c0-.035.02-.07.018-.1-.008-.2.1-.3.287-.359a10.242,10.242,0,0,1,1.049-.3,2.444,2.444,0,0,1,1.437.147,4.683,4.683,0,0,1,1.8,1.3,1.86,1.86,0,0,1,.413,1.556c-.079.541-.192,1.075-.272,1.615a3.389,3.389,0,0,0-.06.516,4.059,4.059,0,0,1-.319,1.488,4.257,4.257,0,0,0-.272.986,1.807,1.807,0,0,0,.455,1.378,5.682,5.682,0,0,0,1.316,1.157c.471.318.968.6,1.427.933a8.627,8.627,0,0,1,.995.845,2.805,2.805,0,0,1,.791,1.607c.11.7.173,1.41.216,2.12.045.745.037,1.493.1,2.237a8.069,8.069,0,0,0,.564,2.523c.1.224.228.431.319.659a4.922,4.922,0,0,1,.323,1.865c0,.836-.021,1.671-.036,2.507,0,.044,0,.088,0,.156a.362.362,0,0,0,.056-.144c.126-.49.244-.982.4-1.463a4.06,4.06,0,0,1,.553-1.1,1.574,1.574,0,0,0,.215-.609,6.027,6.027,0,0,0,.139-1.336c0-.32,0-.64,0-.96a.119.119,0,0,0-.08-.133c-.169-.069-.226-.228-.294-.378a.075.075,0,0,1,0-.064,2.215,2.215,0,0,0,.15-.847,6.806,6.806,0,0,1,.081-.848.266.266,0,0,0-.031-.179c-.062-.118-.121-.237-.177-.358a.922.922,0,0,1-.049-.648c.1-.373.2-.744.334-1.108a1.657,1.657,0,0,1,.29-.55c.007-.008,0-.023.005-.035l.006,0h0a.927.927,0,0,1-1.062-.668.972.972,0,0,1-.077-.455c.012-.115.042-.136.154-.109a.281.281,0,0,0,.323-.126,1.2,1.2,0,0,0,.151-.353,1.716,1.716,0,0,0,.13-.5,1.431,1.431,0,0,0-.2-.474c-.031-.073-.061-.147-.092-.22h0a1.369,1.369,0,0,1,.346.077.281.281,0,0,0,.116.02c.089-.019.111-.053.082-.141a.981.981,0,0,0-.125-.235.766.766,0,0,1-.026-.855,4.862,4.862,0,0,1,.47-.646c.066-.085.1-.155.034-.258a.2.2,0,0,1,.029-.224,3.784,3.784,0,0,1,.452-.524.536.536,0,0,0,.165-.221c-.223,0-.275-.05-.341-.322a.355.355,0,0,0,.312-.162c.1-.121.2-.249.306-.369a.167.167,0,0,0,.013-.187.2.2,0,0,1,.054-.238.986.986,0,0,0,.314-.68,2.887,2.887,0,0,1,.079-.391,1.163,1.163,0,0,1,.312-.605,1.808,1.808,0,0,0,.395-.61c.183-.423.348-.856.572-1.26a1.951,1.951,0,0,1,1.263-1.007,5.462,5.462,0,0,1,1.137-.208,1.1,1.1,0,0,1,.9.383c.08.089.159.18.239.269a1.553,1.553,0,0,0,.378.313,1.4,1.4,0,0,1,.5.539,4.149,4.149,0,0,1,.489,1.26.261.261,0,0,0,.052.134c.136.152.27.307.408.465.079-.057.112-.15.2-.226,0,.15,0,.276,0,.4,0,.069.019.1.09.092a.51.51,0,0,1,.456.247,3.261,3.261,0,0,1,.575,1.542,6.5,6.5,0,0,1,.009,1.5.676.676,0,0,0,0,.172.193.193,0,0,0,.281.161.089.089,0,0,1,.072-.006.771.771,0,0,1-.064.422.229.229,0,0,1-.234.144c-.067,0-.133,0-.2,0s-.112.013-.132.072a.17.17,0,0,0,.041.173.214.214,0,0,0,.126.07,1.094,1.094,0,0,1,.618.392c.093.1.167.219.255.325a.623.623,0,0,1,.124.539c-.026.144-.06.287-.09.43a.541.541,0,0,1-.412.441.315.315,0,0,0-.129.055,3.482,3.482,0,0,1,.517.074,1.655,1.655,0,0,1,.944.654,2.83,2.83,0,0,1,.533,1.292c.065.444.163.881.26,1.319a.991.991,0,0,1-.016.571c-.064.178-.054.181.1.3.035.028.07.055.1.083a.17.17,0,0,1,.02.263.3.3,0,0,1-.07.061.362.362,0,0,0-.173.363,4.655,4.655,0,0,0,.144.879c.092.435.155.874.205,1.315a3.054,3.054,0,0,0,.541,1.471.341.341,0,0,1,.023.033,18.807,18.807,0,0,1,1.356,2.7,9.41,9.41,0,0,0,.557,1.235.179.179,0,0,0,.2.113c.093-.008.187,0,.28,0a1,1,0,0,1,.555.1.291.291,0,0,0,.182.028.218.218,0,0,1,.24.122.873.873,0,0,0,.239.248c.117.089.224.19.345.272a.4.4,0,0,1,.206.347c0,.12.09.156.176.188s.105.079.067.169c-.086.2-.149.418-.247.618a.813.813,0,0,1-.22.3c-.076.059-.156.113-.252.034a.367.367,0,0,0-.018.167c-.016.489-.011.978-.045,1.466a1.891,1.891,0,0,1-.1.507.465.465,0,0,1-.74.216,1.312,1.312,0,0,1-.365-.419,3.52,3.52,0,0,1-.44-1.275,2.975,2.975,0,0,1-.008-.822.223.223,0,0,0-.075-.211,8.138,8.138,0,0,0-.715-.659,2.275,2.275,0,0,1-.313-.344c-.834-.959-1.622-1.956-2.372-2.983a4.578,4.578,0,0,1-.429-.7,4.162,4.162,0,0,0-.386-.653,1.087,1.087,0,0,1-.16-.583,2.047,2.047,0,0,1-.009-.293,1.235,1.235,0,0,0-.13-.591c-.105-.233-.2-.468-.307-.7l-.027,0c-.012.16-.025.321-.036.481a3.909,3.909,0,0,1-.176,1.074,2.421,2.421,0,0,1-.566.923,1.25,1.25,0,0,0-.226.261c.006.012.009.012.006,0S75,69.288,75,69.287ZM49.734,64.7c-.051.3-.1.593-.154.889q-.262,1.536-.522,3.071c-.166.985-.324,1.971-.467,2.959a12.314,12.314,0,0,0-.17,1.428,20.124,20.124,0,0,0,.214,3.746,5.569,5.569,0,0,0,.345,1.255.84.84,0,0,0,.385.388.365.365,0,0,0,.012-.047c.082-.881.14-1.762.139-2.647a.469.469,0,0,1,.016-.145c.208-.661.349-1.339.5-2.013.124-.541.246-1.082.324-1.631a20.425,20.425,0,0,0,.2-2.962,11.955,11.955,0,0,0-.347-2.822,6.968,6.968,0,0,1-.2-.894A1.03,1.03,0,0,0,49.734,64.7ZM61.811,81.294l.032,0c.089-.258.178-.517.268-.775a.121.121,0,0,0-.009-.09,2.292,2.292,0,0,1-.089-1.13,2.9,2.9,0,0,0,.018-.65,1.663,1.663,0,0,1,.2-.99,1.113,1.113,0,0,0,.13-.4c.012-.083.028-.166.04-.25A5.934,5.934,0,0,0,62.49,75.7a16.687,16.687,0,0,0-.3-1.974c-.182-.923-.427-1.832-.613-2.755a18.059,18.059,0,0,1-.416-3.673,8.915,8.915,0,0,0-.105-1.461,2.939,2.939,0,0,0-.317-1.024.533.533,0,0,0-.176-.216,2.172,2.172,0,0,0-.25.759,14.09,14.09,0,0,0-.17,1.869A20.91,20.91,0,0,0,60.488,72c.185,1.017.407,2.027.612,3.041a6.406,6.406,0,0,1,.159,1.051c.017.479.06.958.105,1.435.06.623.129,1.246.2,1.867S61.73,80.66,61.811,81.294Zm6.1-14.247-.015,0c-.008.034-.02.068-.025.1-.056.391-.107.783-.167,1.173a9.682,9.682,0,0,1-.173,1.091c-.151.556-.314,1.11-.428,1.676-.032.158-.065.317-.1.475l.03.019c.028-.033.054-.068.084-.1.227-.245.436-.5.651-.758a1.566,1.566,0,0,0,.353-.792,3.163,3.163,0,0,0,.022-.718c-.021-.284-.088-.561-.118-.843C67.977,67.932,67.945,67.489,67.907,67.046ZM48.039,80.724a1.2,1.2,0,0,0,.208.584,3.116,3.116,0,0,0,.565.634c.249.224.249.224.548.075.177-.088.184-.152.031-.288a.288.288,0,0,0-.146-.089c-.241-.024-.269-.187-.262-.378a.458.458,0,0,0,0-.066,2.918,2.918,0,0,0-.311-1.038c-.021-.041-.042-.077-.1-.074a.94.94,0,0,0-.462.237c-.006,0-.007.016-.008.025A2.517,2.517,0,0,0,48.039,80.724Z"
        fill={fillColor}
      />
      <path
        id="Path_38"
        data-name="Path 38"
        d="M774.632,495.063l.007,0-.011,0Z"
        transform="translate(-709.311 -437.049)"
        fill={fillColor}
      />
    </g>
  </svg>
);
export const FantasyIcon = ({
  width = "30",
  height = "30",
  fillColor = "currentColor",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 55.052 63"
  >
    <g id="_2754289" data-name="2754289" transform="translate(-0.5 1279.696)">
      <path
        id="Path_39"
        data-name="Path 39"
        d="M29.374-1279.682l-.96.069a30.282,30.282,0,0,0-11.766,3.461,30.468,30.468,0,0,0-15.261,19.53,33.845,33.845,0,0,0-.8,4.751,41.038,41.038,0,0,0,0,5.391A30.691,30.691,0,0,0,3.9-1235.123a30.232,30.232,0,0,0,17.378,14.863,28.546,28.546,0,0,0,7.975,1.5,30.374,30.374,0,0,0,8.167-.729c.143-.03.143-.03.108.162a1.476,1.476,0,0,1-.551.881c-.418.369-.512.522-.512.847a.864.864,0,0,0,.207.64c.177.187.3.143.689-.236.2-.187.67-.581,1.049-.871a7.275,7.275,0,0,0,1.886-1.91c.246-.418.271-.443.517-.531a27.137,27.137,0,0,0,4.441-2.073c.689-.4,2.073-1.295,2.673-1.728l.261-.187.345.345c.192.187.571.591.847.9,1.1,1.236,1.506,1.827,1.442,2.117a2.274,2.274,0,0,1-.473.551c-.409.389-.443.438-.443.615,0,.2,0,.2.921,1.058a1.663,1.663,0,0,1,.576,1.226c.113.807.4,1.068,1.088.97.133-.025.241-.069.256-.113a2.161,2.161,0,0,0-.1-.547,5.183,5.183,0,0,1-.153-1.585,6.113,6.113,0,0,0-.143-1.625,11.909,11.909,0,0,0-1.95-3.914c-.394-.6-.724-1.108-.734-1.132a2.233,2.233,0,0,1,.428-.438,30.839,30.839,0,0,0,3.515-3.805c.482-.645.487-.66.182-.433a27.424,27.424,0,0,1-4.012,2.412c-.62.305-1.172.566-1.216.581-.069.024-.231-.172-.753-.926-.364-.522-.7-1.049-.758-1.167a6.286,6.286,0,0,1-.35-1.817c-.133-1.309-.266-1.748-.615-2.053-.266-.236-3.476-1.994-7.015-3.84-.881-.458-1.738-.916-1.91-1.014a10.855,10.855,0,0,1-1.831-1.477c-.418-.4-1.147-1.078-1.62-1.516s-.94-.9-1.044-1.034a1.637,1.637,0,0,1-.34-.975,4.594,4.594,0,0,1,.586-1.817l.094-.123.689.133c.379.074.748.133.817.133.153,0,.226-.148.226-.443a.505.505,0,0,1,.148-.364c.094-.1.138-.2.118-.246a.192.192,0,0,1,.059-.182c.089-.1.089-.108-.054-.448-.025-.059.02-.138.143-.261.187-.187.187-.266,0-.423a.926.926,0,0,1-.172-.217c-.089-.143-.089-.148.015-.256l.108-.113-.158.029-.158.03.079-.236a4.1,4.1,0,0,0,.108-.512.417.417,0,0,1,.251-.414c.207-.138.212-.148.187-.354a1.871,1.871,0,0,0-.487-.975,1.35,1.35,0,0,0-.443-.182,1.137,1.137,0,0,1-.542-.275,3.9,3.9,0,0,0-1.551-.872,2.618,2.618,0,0,0-1.575.1c-.1.024-.1.015-.079-.168s.025-.2-.148-.231c-.286-.054-.354-.02-.369.187l-.015.182-.212-.148a1.6,1.6,0,0,0-1.487-.192,1.244,1.244,0,0,0-.66.433,3.259,3.259,0,0,0-1.083,3.161c.177.586.478.96,1.388,1.723.67.566.778.694.778.9,0,.394-.33.5-.586.192l-.148-.182-.054.138c-.143.374.069.748.566,1a1.238,1.238,0,0,0,1.447-.158c.182-.212.222-.4.192-1a1.326,1.326,0,0,0-.645-1.236,3.253,3.253,0,0,1-.985-1.137,1.3,1.3,0,0,1-.153-.714,1.557,1.557,0,0,1,.369-1.123c.172-.2.6-.438.66-.369a1.265,1.265,0,0,1-.069.325,4.06,4.06,0,0,0-.192,1.462,2.121,2.121,0,0,0,1.019,1.792c.625.527.665.6.684,1.235.034.881-.039,1.054-1.113,2.668a13.609,13.609,0,0,0-1.758,3.013l-.1.34-.113-.463c-.886-3.638-2.767-5.765-5.612-6.346-.665-.133-.743-.113-.384.1a4.673,4.673,0,0,1,1.7,1.4,3.819,3.819,0,0,1,.606,2.363,9.358,9.358,0,0,1-.335,2.427,5.034,5.034,0,0,0-.222,1.905c.212,1.216,1.285,1.8,4.18,2.289a3.758,3.758,0,0,1,.606.133c.015.025.182.714.364,1.541,1.108,5.031,1.59,6.6,2.255,7.32.108.118.172.212.143.212a15.92,15.92,0,0,1-1.659-.6,22.694,22.694,0,0,1-7.9-5.258,22.028,22.028,0,0,1-3.062-3.727,23.216,23.216,0,0,1-3.535-8.95,19.645,19.645,0,0,1-.315-3.914,19.472,19.472,0,0,1,.3-3.791A23.5,23.5,0,0,1,25.091-1268.3a24.313,24.313,0,0,1,16.271-4,25.553,25.553,0,0,1,13.44,5.819c.694.571.793.645.738.557a33.91,33.91,0,0,0-2.732-3.766c-.61-.714-2.348-2.452-3.028-3.037a31.223,31.223,0,0,0-4.357-3.062,29.74,29.74,0,0,0-12.012-3.8C32.7-1279.662,29.886-1279.726,29.374-1279.682Zm4.849,2.629a27.028,27.028,0,0,1,5.218.792,29.254,29.254,0,0,1,12.14,6.3,24.1,24.1,0,0,1,1.841,1.718c.015.044-.108-.059-.281-.222a23.981,23.981,0,0,0-3.077-2.4,24.587,24.587,0,0,0-11.569-3.924,36.242,36.242,0,0,0-4.79.1,25.285,25.285,0,0,0-12.445,5,26.051,26.051,0,0,0-7.537,8.99,25.663,25.663,0,0,0-2.693,9.28,32.877,32.877,0,0,0,0,4.824,27.1,27.1,0,0,0,2.319,8.64,26.356,26.356,0,0,0,7.389,9.383,25.412,25.412,0,0,0,18.742,5.356,6.08,6.08,0,0,1,.7-.059,7.078,7.078,0,0,1-.315,1.187,19.755,19.755,0,0,1-2.865.62,25.514,25.514,0,0,1-3.884.285,26.264,26.264,0,0,1-2.742-.054,27.928,27.928,0,0,1-9-2.206,27.917,27.917,0,0,1-16.187-18.87,25.5,25.5,0,0,1-.837-6.818,23.5,23.5,0,0,1,.266-3.963,28.217,28.217,0,0,1,7.2-15.035,28.411,28.411,0,0,1,12.756-7.852A29.89,29.89,0,0,1,34.223-1277.053Zm.207,39.453a34.082,34.082,0,0,0,8.556,3.756c.625.2,1.147.384,1.172.4.039.039-.192.1-8.108,2.191-.674.177-1.241.325-1.255.325-.039,0-1.255-1.364-1.615-1.8-.517-.645-.576-.94-.546-2.639l.025-1.172.212-.428a2.579,2.579,0,0,1,.522-.743,1.724,1.724,0,0,1,.359-.305A6.153,6.153,0,0,1,34.43-1237.6Zm9.812,8.458a6.54,6.54,0,0,0,1.492,2.289,2.831,2.831,0,0,1,.374.428,21.068,21.068,0,0,1-3.456.807c-.113-.015-.1-.054.576-1.92C44.01-1229.708,44.025-1229.733,44.241-1229.142Zm7.483.842a.6.6,0,0,1-.108.113l-.113.094.094-.113C51.685-1228.31,51.724-1228.339,51.724-1228.3Zm-.418.359c-.231.207-1.393,1.088-1.836,1.4-.251.172-.32.2-.369.147s-.044-.069,0-.084c.118-.044,1.644-1.083,2-1.363C51.5-1228.152,51.6-1228.2,51.306-1227.941Zm-10.629,1.349c-.069.66-.138,1.206-.153,1.221a5.059,5.059,0,0,1-.753.074,26.164,26.164,0,0,1-5.844-.453l-.443-.094.689.03a9.3,9.3,0,0,0,4.254-.857c.34-.153.719-.31.842-.349a3.049,3.049,0,0,0,.522-.291c.517-.364.98-.62.994-.546C40.8-1227.818,40.746-1227.251,40.677-1226.592Zm6.636,1.275c.1.113.113.1-.586.487a36.786,36.786,0,0,1-3.372,1.6,11.354,11.354,0,0,1-1.905.655,2.124,2.124,0,0,1,.162-.527l.192-.5.935-.236a24.591,24.591,0,0,0,4.086-1.442C47.121-1225.43,47.2-1225.44,47.313-1225.317Z"
        transform="translate(0 0)"
        fill={fillColor}
      />
      <path
        id="Path_40"
        data-name="Path 40"
        d="M502.378-382.851a2.5,2.5,0,0,0-1.206.625c-.354.409-.379.8-.162,2.368a3.141,3.141,0,0,1-.069,1.8c-.1.2-.118.276-.074.31a1.519,1.519,0,0,0,.852-.1,4.888,4.888,0,0,0,1.738-2.742,20.647,20.647,0,0,0,.6-2.24c0-.094-.034-.1-.674-.094A6.7,6.7,0,0,0,502.378-382.851Z"
        transform="translate(-475.712 -852.622)"
        fill={fillColor}
      />
    </g>
  </svg>
);

export const SuspenseIcon = ({
  width = "30",
  height = "30",
  fillColor = "currentColor",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 66.46 66.636"
  >
    <path
      id="spy-icon"
      d="M21.15,2.846a13.992,13.992,0,0,0-2.006,2.563c-2.259,3.618-3.945,9.1-5.192,16.018C6.63,22.811,2.11,25.868,2.26,28.989c.135,2.827,3.7,5,9.061,6.493-.352,1.09-.269,1.277.208,2.618-4,1.688-8.186,6.815-11.53,11.306L13.01,58.2,8.416,66.633h50L53.566,58.2,66.46,49.242c-3.782-5.313-8.348-9.827-11.2-11.052.6-1.563.708-1.836.2-2.7,5.36-1.524,8.874-3.751,8.866-6.694-.008-3.21-4.617-6.292-11.485-7.364C51.2,14.469,49.563,8.991,47.48,5.4A15.578,15.578,0,0,0,46.3,3.624c-6.2-7.949-8.371-.35-12.764-.359-5.094-.01-5.742-6.983-12.384-.419Zm8.73,51.811a.841.841,0,1,1,0-1.683h1.368a.837.837,0,0,1,.481.152,3.144,3.144,0,0,0,1.432.445,2.353,2.353,0,0,0,1.4-.449.847.847,0,0,1,.47-.144l1.662,0a.841.841,0,0,1,0,1.683H35.273a3.922,3.922,0,0,1-2.151.589,4.716,4.716,0,0,1-2.082-.589H29.88Zm-8.99-18.31a35.524,35.524,0,0,0,23.58.238,139.983,139.983,0,0,1-23.58-.238Zm27.1-.112c2.717,9.186-8.913,13.851-13.259,3.639H31.855C27.418,50.056,15.97,45.62,18.568,36.111q-1.426-.156-2.8-.341l-.042.245-.077.463-.453,2.714c-3.952-.874-1.738,9.334,1.855,8.437.549,1.584,1,2.942,1.464,4.187,4.787,12.854,24.826,13.631,29.517.827.492-1.342.891-2.814,1.462-4.6,3.309.528,6.028-9.535,2-8.8l-.415-2.738L51,36.032l-.03-.2q-1.457.226-2.98.4Zm-31.9-13.3.966-3.307c6.264,5.257,27.909,4.434,32.628,0l.814,3.307c-5.5,5.82-28.526,5.029-34.408,0Z"
      transform="translate(0 0.003)"
      fill={fillColor}
      fillRule="evenodd"
    />
  </svg>
);

export const DramaIcon = ({
  width = "30",
  height = "30",
  fillColor = "currentColor",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 86.296 57"
  >
    <g id="_2028292" data-name="2028292" transform="translate(-0.498 845)">
      <path
        id="Path_47"
        data-name="Path 47"
        d="M56.884-844.535A11.94,11.94,0,0,0,55-842.261c-.135.189-.209.216-.8.317a23.661,23.661,0,0,0-3.487,1.16l-2.847,1.059L45.8-838.558c-1.133.641-3.218,1.848-4.621,2.692l-2.557,1.531-.263-.256c-.223-.216-.256-.283-.216-.459a2.183,2.183,0,0,1,1.261-1.423,1.711,1.711,0,0,0,.7-.9c.081-.324-.027-.378-.863-.4a4.186,4.186,0,0,0-2.59.553l-.2.162.02,1.309.027,1.309-.506.25a2.591,2.591,0,0,0-1.147,1.059,1.488,1.488,0,0,1-.742.54,10.542,10.542,0,0,1-2.159.722,12.513,12.513,0,0,1-3.784-.034,14.39,14.39,0,0,1-3.312-1.16l-.944-.459-.944-.951c-.9-.917-.965-.958-1.383-1.086-1.106-.324-1.828-.337-2.132-.034s-.155.6.418,1.005l.371.256-.681.54c-.371.3-.675.553-.675.567a1.091,1.091,0,0,0,.108.236.594.594,0,0,1,.081.236,18.518,18.518,0,0,1-2.388-.742,4.249,4.249,0,0,0-1.788-.344l-.971-.041-2.327.938c-1.282.513-2.934,1.214-3.676,1.545s-1.578.681-1.855.762a7.677,7.677,0,0,0-.992.378c-.857.4-1.093.836-2.152,3.906a9.227,9.227,0,0,0-.769,2.8,8.338,8.338,0,0,1-.29,1.619l-.25.911v3.845l-.384.958-.378.958.31.877c.175.479.317.9.317.931s-.223.634-.5,1.342-.486,1.282-.479,1.3A4.683,4.683,0,0,0,1.031-811a1.927,1.927,0,0,1,.513-.155c0,.027-.094.492-.209,1.032l-.216.985.384,3.029c.216,1.666.567,4.088.782,5.383l.391,2.361-.3,1.578c-.169.87-.3,1.6-.283,1.626a4.341,4.341,0,0,0,.722-.715,5.928,5.928,0,0,1,.729-.735c.02.02.209.681.425,1.47.371,1.383.391,1.437.567,1.457.115.014.175-.007.175-.074s-.088-.728-.2-1.5-.2-1.457-.2-1.525c0-.108.034-.1.317.081l.324.2.04-.223c.061-.31.074-.216.121.891l.04.971.472.142.472.142.317,1.012a4.257,4.257,0,0,1,.324,1.956v.944l1.74.216c1.956.243,2.509.27,2.509.115,0-.054-.155-.654-.344-1.322l-.344-1.228-1.019-1.187c-.553-.654-1.073-1.248-1.14-1.329-.121-.142-.121-.148.054-.567l.182-.418-.189-1.005-.2-1,.189-2.381a21.957,21.957,0,0,1,.378-3.184,5.583,5.583,0,0,1,.25-.857,5.436,5.436,0,0,1,.351,1.268c.155.735.607,2.793,1,4.573.688,3.143.715,3.245.931,3.474a18.684,18.684,0,0,1,1.444,1.916,4.6,4.6,0,0,1,.108.8l.047.648.978.358.985.358.884-.121c1.315-.175,1.187-.1,1.187-.722v-.526l-.492-.769a5.606,5.606,0,0,0-1.477-1.632l-.985-.864.169-.31.175-.31-.782-1.558-.782-1.558-.074-1.241a24.254,24.254,0,0,1,.061-3.474l.135-2.24.432-.864a24.5,24.5,0,0,0,1.356-3.771c1.174-3.676,1.5-4.607,1.72-4.843a1.329,1.329,0,0,1,.513-.29c.344-.108.364-.108,1.221.094.479.115,2.037.472,3.467.789,3.46.769,5.214,1.187,5.289,1.248a9.319,9.319,0,0,1-.358,1.605c-.223.85-.411,1.585-.411,1.639a4.7,4.7,0,0,0,.729.823l.722.722h1.889l1.889-.007.621-.782.614-.782-.567-1.147a10.252,10.252,0,0,1-.546-1.167,1.449,1.449,0,0,1,.391.034c.2.034,1.268.081,2.374.108l2,.054v.175c-.007.094-.135.992-.3,2l-.29,1.821.2.722.2.722-.4,1.976c-.223,1.086-.492,2.4-.6,2.921s-.634,2.368-1.153,4.108-.951,3.191-.951,3.231a6.928,6.928,0,0,0,.641.756l.641.688v1.228c0,.668.007,1.221.02,1.228.27.061,3.865.418,3.879.384a11.813,11.813,0,0,0-.256-1.255l-.283-1.194-.7-.708-.7-.708v-2.172l.438-1.828.438-1.828.735-1.531c.4-.836.756-1.538.776-1.565s.04.081.047.229.04.7.088,1.241l.081.978-.283,2.125c-.155,1.167-.4,2.739-.526,3.494l-.243,1.369.553.627a10.874,10.874,0,0,1,.978,1.3l.418.668-.263.843c-.148.465-.27.877-.27.917a11.84,11.84,0,0,0,2.111.142c1.153.041,2.111.068,2.118.061s-.243-.708-.546-1.558a5.772,5.772,0,0,0-1.551-2.739l-.317-.385-.189-1.5-.189-1.511.256-1.619a12.232,12.232,0,0,1,.836-3.224A37.7,37.7,0,0,0,42.59-806.5c.31-1.234.715-2.8.9-3.487a13.038,13.038,0,0,0,.479-2.455c.074-.661.135-1.228.135-1.248a6.284,6.284,0,0,1,.769-.614,6.325,6.325,0,0,0,1.848-2.091c1.16-1.734,1.4-2.745,1.349-5.835l-.02-1.484.749-1.046c.4-.573,1.538-2.327,2.516-3.9s1.788-2.847,1.8-2.847.3.135.621.3a2.569,2.569,0,0,0,1.14.344l.553.047,1.133.776c.621.432,1.14.782,1.14.789s-.061.567-.142,1.255c-.715,5.666-.6,11.11.29,14.2a6.421,6.421,0,0,0,2.577,3.973,5.261,5.261,0,0,1,.911.749,3.239,3.239,0,0,0,1.774,1.046c1.572.29,3.191-1.437,4.52-4.83.31-.8.917-2.637,1.093-3.3a1.348,1.348,0,0,1,.2-.432l.128-.162.283.223c.324.256.472.27,1.093.094a1.3,1.3,0,0,1,.492-.081c.027.02-.02.189-.094.371a6.312,6.312,0,0,0-.277,3.022c.034.223.094,1.019.135,1.774a12.1,12.1,0,0,1-.04,2.327,35.175,35.175,0,0,0-.094,4.6,15.444,15.444,0,0,1-.054,1.956c-.074.438-.054.675.3,3.238l.378,2.766.843,2.361c.459,1.3.877,2.543.924,2.759.081.4.081.4.411.513l.337.115.034.351a1.106,1.106,0,0,1-.02.452c-.115.2.384.971,1,1.525.25.223.324.25.877.317.337.041.87.074,1.194.074h.594l.162-.256a1.677,1.677,0,0,0,.209-.627l.047-.378-.526-.722c-.492-.668-.526-.735-.506-1.019.013-.263,0-.3-.115-.3s-.135-.068-.162-1.032l-.034-1.025-.83-1.889-.836-1.889-.452-1.848-.459-1.855.142-.2c.128-.175.135-.229.067-.634-.074-.438-.067-.472.594-3.184l.668-2.739.648-1.268c.358-.7.661-1.261.675-1.248s.223.479.459,1.032.735,1.619,1.106,2.361a9.289,9.289,0,0,1,1,2.631c.263,1.032.358,1.309.479,1.4l.162.121-.128.25c-.128.243-.121.263.034,1.3a12.8,12.8,0,0,1,.162,2.206,10.047,10.047,0,0,1-.27,2.577l-.277,1.423.175.344.175.337-.277,1.248a15.225,15.225,0,0,1-.418,1.565c-.128.29-.135.391-.094,1.288.027.54.054.985.061.992s.432.094.944.189a3.169,3.169,0,0,0,1.3.1,4.667,4.667,0,0,1,1.774.209l1.4.27.863-.175a7.756,7.756,0,0,0,1.187-.324l.324-.148-.256-.31c-.256-.3-.29-.31-1.268-.587-.553-.162-1.032-.31-1.073-.331a4.4,4.4,0,0,1-.627-.971.274.274,0,0,1,.074-.169,6.454,6.454,0,0,0-.067-1.68c-.088-1.046-.162-2.665-.2-4.6a14.583,14.583,0,0,1,.04-3.292,1.18,1.18,0,0,0-.007-.83,4.075,4.075,0,0,1,.027-1.632,4.856,4.856,0,0,0,0-2.334c-.067-.162-.3-1.073-.513-2.024s-.587-2.584-.843-3.616-.465-1.97-.465-2.084a.584.584,0,0,0-.169-.391l-.169-.175.209-1.113a6.083,6.083,0,0,1,.324-1.275c.088-.128.229-.189.56-.263l.432-.088.263-.465c.182-.331.283-.445.337-.4s.148-.155.331-.749a20.117,20.117,0,0,1,.863-2.1,12.808,12.808,0,0,0,.776-1.936,2.989,2.989,0,0,0,.081-1.5c-.074-.782-.1-.89-.27-1.1-.1-.135-.816-1.214-1.585-2.408a25.984,25.984,0,0,0-3.116-4.25,2.425,2.425,0,0,0-1.3-.755,7.587,7.587,0,0,0-1.214-.344,1.573,1.573,0,0,1-.452-.088c-.034-.02-.27-.317-.533-.647l-.472-.607.155-.371a1.824,1.824,0,0,0,.142-.83.816.816,0,0,1,.236-.755c.243-.283.25-.317.25-.823a1.622,1.622,0,0,1,.128-.782l.128-.25H77.4c-.148,0-.283-.169-.182-.223a4.175,4.175,0,0,1,.418-.148,3.274,3.274,0,0,0,1.241-.654c.229-.324.081-.735-.364-.992q-.1-.061-.607.142a1.705,1.705,0,0,1-.971.169c-.573-.041-.607-.074-.911-.917-.4-1.12-.83-1.558-1.531-1.558-.331,0-.371.02-.675.324a1.125,1.125,0,0,1-.782.411c-.324.068-.479.068-.58.014a.705.705,0,0,0-.277-.074c-.2,0-.6.378-.8.769-.169.317-.182.4-.175,1.12a6.886,6.886,0,0,0,.081,1.066l.067.29-.3.128a4.257,4.257,0,0,1-.58.2c-.162.04-.337.094-.391.115a1.331,1.331,0,0,1-.4.047l-.3.007v.385c0,.31.034.418.162.553.229.243.762.337,1.578.283l.654-.041v.256a1.066,1.066,0,0,0,.3.661,2.82,2.82,0,0,1,.513.9c0,.1-.175.081-.27-.034-.155-.189-.2-.027-.067.236s.142.256.351.2c.3-.088.29-.094.411.209.054.148.081.27.061.27a1.137,1.137,0,0,0-.229.324,4.662,4.662,0,0,1-1.781,1.5,3.315,3.315,0,0,1-1.309.634c-.337.047-.411.094-.884.533a58.893,58.893,0,0,0-4.142,4.9c-1.99,2.489-1.9,2.266-1.605,3.622l.175.823,1.12.958c1.059.911,3.656,3.319,3.7,3.44a22.954,22.954,0,0,1-1.471,2.806c-1.551,2.557-3.022,4.047-4.31,4.378a1.678,1.678,0,0,1-1.194-.074,5.254,5.254,0,0,1-.863-1.666,21.091,21.091,0,0,1-.85-7,54.094,54.094,0,0,1,.459-7.15l.115-.9.337-.088a23.607,23.607,0,0,0,2.327-.681c.061-.068.944-2.361.944-2.455,0-.041-.3-.607-.661-1.261a22.719,22.719,0,0,1-1.214-2.543c-.3-.742-.6-1.484-.675-1.653l-.135-.31.31-.4a2.182,2.182,0,0,0,.553-1.187c0-.182-.067-.31-.29-.58a7.335,7.335,0,0,1-.951-1.963l-.661-1.619.29-.418c.5-.735.56-1.046.3-1.612a3.617,3.617,0,0,0-.7-1.019,9,9,0,0,0-.58,1.147l-.533,1.147h-1.18l.175-.425a2.868,2.868,0,0,0,.088-1.923c-.081-.3-.182-.553-.229-.553A3.453,3.453,0,0,0,56.884-844.535ZM58.193-828.9a5.692,5.692,0,0,1,.216.729,1.788,1.788,0,0,0,.695,1.16l.54.546-.148,1.275a53.282,53.282,0,0,0-.391,5.821c-.074,4.088.283,6.732,1.167,8.688l.223.492-.2-.121a4.843,4.843,0,0,1-1.127-1.228c-1.659-2.59-2.172-8.25-1.4-15.461C57.977-828.939,58.038-829.2,58.193-828.9Zm22.746,3.251.438.317.371,1.046c.209.573.425,1.147.486,1.275a5.147,5.147,0,0,1,.256,1.491.85.85,0,0,1-.128.452,3.072,3.072,0,0,0-.243.755,12.035,12.035,0,0,1-.573,1.862c-.054.135-.088.142-.384.088-.175-.034-.418-.074-.526-.094-.2-.034-.209-.041-.223-.465a2.924,2.924,0,0,1,.088-.762,5.062,5.062,0,0,0-.034-2.179,3.552,3.552,0,0,1-.04-1.734,1.9,1.9,0,0,0,.04-.762,5.81,5.81,0,0,1-.013-1.612A3.794,3.794,0,0,1,80.939-825.647Zm-11.387,2.455c.148.627.459,1.653.729,2.408.438,1.221.492,1.336.762,1.565s.27.256.169.337l-.5.391-.384.3-.648-.681a10.723,10.723,0,0,0-1.025-.965,1.6,1.6,0,0,1-.459-.465,1.17,1.17,0,0,0-.378-.378c-.27-.169-.3-.216-.3-.438a.579.579,0,0,0-.243-.486,5.065,5.065,0,0,1-.445-.486l-.209-.256.364-.331a5.917,5.917,0,0,1,.971-.668,6.142,6.142,0,0,0,.944-.641,2.79,2.79,0,0,1,.371-.3A8.182,8.182,0,0,1,69.552-823.192Zm-1.194,7.117c-.094.344-.3,1.046-.472,1.565-1.349,4.115-3.049,6.388-4.627,6.172a3.164,3.164,0,0,1-1.545-.816c-.29-.3-.3-.31-.115-.27a1.8,1.8,0,0,0,.607-.034c1.275-.229,2.752-1.558,4.223-3.8.526-.8,1.329-2.206,1.734-3.022.142-.29.283-.5.31-.472A2.048,2.048,0,0,1,68.358-816.075ZM28.323-814c.2.054.567.128.809.169a6.484,6.484,0,0,1,.742.169l.3.1.56,1.113c.3.614.553,1.147.553,1.187a2.139,2.139,0,0,1-.283.432l-.29.364H29.2l-1.524.007-.425-.432-.432-.432L27.1-812.4c.162-.587.331-1.228.384-1.423C27.6-814.213,27.521-814.193,28.323-814Z"
        transform="translate(0)"
        fill={fillColor}
      />
    </g>
  </svg>
);

export const IIcon = ({
  width = "20",
  height = "20",
  fillColor = "#eee",
  style = {},
  className = "",
}) => (
  <svg
    id="Group_8760"
    data-name="Group 8760"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 8.164 16"
  >
    <g id="help" data-name="help" transform="translate(0 0)">
      <path
        id="Path_4641"
        data-name="Path 4641"
        d="M9.476,16.877a.209.209,0,0,0-.262-.072,24.461,24.461,0,0,1-2.428,1.047.175.175,0,0,1-.027-.031.278.278,0,0,1-.046-.169,31.014,31.014,0,0,1,1.306-5.266,18.335,18.335,0,0,0,.816-3.122.8.8,0,0,0-.288-.635,1.138,1.138,0,0,0-.742-.222,3.894,3.894,0,0,0-1.85.606A9.941,9.941,0,0,0,3.635,11a.209.209,0,0,0,.234.334c.3-.12,1.776-.727,1.992-.863a.907.907,0,0,1,.455-.167h.012a.244.244,0,0,1,0,.039,1.572,1.572,0,0,1-.078.448c-1.263,4.091-1.877,6.6-1.877,7.668a1.272,1.272,0,0,0,.312.9,1.1,1.1,0,0,0,.844.341,2.95,2.95,0,0,0,1.386-.475,16.206,16.206,0,0,0,2.529-2.083A.211.211,0,0,0,9.476,16.877Z"
        transform="translate(-3.581 -4.706)"
        fill={fillColor}
      />
      <path
        id="Path_4642"
        data-name="Path 4642"
        d="M11.085,3.348a1.055,1.055,0,0,0-.785-.319,1.334,1.334,0,0,0-1.012.46,1.564,1.564,0,0,0-.416,1.094,1.158,1.158,0,0,0,.306.829,1.031,1.031,0,0,0,.774.327,1.339,1.339,0,0,0,1.008-.486,1.6,1.6,0,0,0,.434-1.105A1.1,1.1,0,0,0,11.085,3.348Z"
        transform="translate(-5.231 -3.029)"
        fill={fillColor}
      />
    </g>
  </svg>
);

export const StarIcon = ({
  width = "20",
  height = "20",
  fillColor = "#fff",
  style = {},
  className = "",
}) => (
  <svg
    id="Group_8760"
    data-name="Group 8760"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 56.001 56"
  >
    <g id="star" transform="translate(-721.067 -350.184)">
      <g
        id="Group_2134"
        data-name="Group 2134"
        transform="translate(721.067 350.184)"
      >
        <path
          id="Path_48"
          data-name="Path 48"
          d="M756.541,371.978l-7.512-21.794L741.3,371.8l-20.236.175L737.7,385.79l-5.979,20.394,17.3-12.381,17.3,12.381-5.982-20.262,16.717-13.944Z"
          transform="translate(-721.067 -350.184)"
          fill={fillColor}
        />
      </g>
    </g>
  </svg>
);
export const RightArrowIcon = ({
  width = "8.906",
  height = "12.592",
  fillColor = "#fff",
  style = {},
  className = "",
}) => (
  <svg
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 8.906 12.592"
  >
    <path
      id="MenuRightArrow"
      data-name="MenuRightArrow"
      d="M0,8.906,6.3,0l6.3,8.906Z"
      transform="translate(8.906) rotate(90)"
      fill={fillColor}
    />
  </svg>
);

export const CheveronArrowLeftIcon = ({
  width = "42.148",
  height = "46.758",
  fillColor = "var(--color-bloodred)",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 7.148 11.758"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
  >
    <path
      id="arrow-01"
      d="M5.441,0,0,5.159l.545.576L5.411,1.121l4.358,4.6.576-.545Z"
      transform="translate(0.707 11.052) rotate(-90)"
      fill={fillColor}
      stroke={fillColor}
      strokeWidth="1"
    />
  </svg>
);

export const CheveronArrowRightIcon = ({
  width = "42.148",
  height = "46.758",
  fillColor = "var(--color-bloodred)",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 7.148 11.758"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
  >
    <path
      id="arrow-01"
      d="M5.441,5.734,0,.576.545,0,5.411,4.613,9.769.017l.576.545Z"
      transform="translate(0.707 11.052) rotate(-90)"
      fill={fillColor}
      stroke={fillColor}
      strokeWidth="1"
    />
  </svg>
);

export const DownArrowIcon = ({
  width = "8.906",
  height = "12.592",
  fillColor = "#fff",
  style = {},
  className = "",
}) => (
  <svg
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 12.592 8.906"
  >
    <path
      id="MenuDownArrow"
      data-name="MenuDownArrow"
      d="M4.4,7.45l6.3,8.906,6.3-8.906Z"
      transform="translate(-4.396 -7.45)"
      fill={fillColor}
    />
  </svg>
);

export const UpArrowIcon = ({
  width = "8.906",
  height = "12.592",
  fillColor = "#fff",
  style = {},
  className = "",
}) => (
  <svg
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 12.592 8.906"
  >
    <path
      id="MenuUpArrow"
      data-name="MenuUpArrow"
      d="M4.4,16.356l6.3-8.906,6.3,8.906Z"
      transform="translate(-4.396 -7.45)"
      fill={fillColor}
    />
  </svg>
);

export const LeftArrowIcon = ({
  width = "8.906",
  height = "12.592",
  fillColor = "#fff",
  style = {},
  className = "",
}) => (
  <svg
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 8.906 12.592"
  >
    <path
      id="MenuLeftArrow"
      data-name="MenuLeftArrow"
      d="M4.4,7.45l6.3,8.906,6.3-8.906Z"
      transform="translate(16.356 -4.396) rotate(90)"
      fill={fillColor}
    />
  </svg>
);

export const UploadCloudIcon = ({
  width = "50",
  height = "50",
  fillColor = "#f6fafc",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 54.069 39.344"
  >
    <g id="UploadCloud1" transform="translate(-3.683 -12.518)">
      <g
        id="Group_2136"
        data-name="Group 2136"
        transform="translate(3.683 12.518)"
      >
        <g id="Group_2135" data-name="Group 2135">
          <path
            id="Path_52"
            data-name="Path 52"
            d="M45.936,51.862H34.328V40.14h3.836a1.2,1.2,0,0,0,.973-1.9l-7.457-10.32a1.183,1.183,0,0,0-1.93,0l-7.467,10.32a1.2,1.2,0,0,0,.977,1.9H27.1V51.862h-13C8.3,51.539,3.683,46.116,3.683,40.238a11,11,0,0,1,5.46-9.5,7.29,7.29,0,0,1-.454-2.576,7.482,7.482,0,0,1,7.491-7.491,7.387,7.387,0,0,1,2.564.454,15,15,0,0,1,28.5,4.949,13.047,13.047,0,0,1-1.3,25.787Z"
            transform="translate(-3.683 -12.518)"
            fill={fillColor}
          />
        </g>
      </g>
    </g>
  </svg>
);

export const PowerIcon = ({
  strokeColor = "#fff",
  width = "25",
  height = "35",
  fillColor = "#fff",
  strokeWidth = "1",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    viewBox="0 0 157.987 180.047"
    style={style}
  >
    <g id="power-icon" transform="translate(-25.246 -3.601)">
      <path
        id="Path_53"
        data-name="Path 53"
        d="M147.921,71.364a8.225,8.225,0,0,0-11.013,2.61,7.219,7.219,0,0,0,2.6,10.119l2.967,2.171A60.335,60.335,0,0,1,167.594,135c0,33.773-28.364,61.152-63.353,61.152S40.888,168.778,40.888,135A60.294,60.294,0,0,1,65.357,86.745l3.153-2.37a7.512,7.512,0,0,0,3.064-10.4,8.223,8.223,0,0,0-11.009-2.613L57.295,73.7c-19.44,13.887-32.049,36.17-32.049,61.309,0,42.108,35.366,76.249,78.993,76.249S183.233,177.116,183.233,135c0-25.134-12.606-47.416-32.042-61.3l-3.272-2.334Z"
        transform="translate(0 -27.607)"
        fill={fillColor}
        strokeWidth={strokeWidth}
        stroke={strokeColor}
      />
      <path
        id="Path_54"
        data-name="Path 54"
        d="M182.631,96.7c0,5.334-4.04,9.7-8.979,9.7s-8.979-4.363-8.979-9.7V13.3c0-5.333,4.041-9.7,8.979-9.7s8.979,4.364,8.979,9.7Z"
        transform="translate(-69.412)"
        fill={fillColor}
      />
    </g>
  </svg>
);

export const RemoteIcon = ({
  width = "170.786",
  height = "170.786",
  fillColor = "#C79F27",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`fill ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 70.786 70.786"
  >
    <path
      id="remote-control-svgrepo-com"
      d="M36.781,0a1.008,1.008,0,0,0,.25,2,6.688,6.688,0,0,1,2.156.406,12.5,12.5,0,0,1,5.094,3.281,13.666,13.666,0,0,1,3.281,5.156A7.02,7.02,0,0,1,48,13a1,1,0,1,0,2,0,10.178,10.178,0,0,0-.562-2.781,15.627,15.627,0,0,0-3.719-5.906A14.725,14.725,0,0,0,39.813.5,9.369,9.369,0,0,0,36.969,0h-.187ZM28.688,6a4.363,4.363,0,0,0-2.969,1.156l-.031.031L1.188,31.781a4.291,4.291,0,0,0-.031,5.906l.031.031L12.406,48.906a4.252,4.252,0,0,0,5.875.031l.031-.031,24.5-24.5a.466.466,0,0,0,.031-.062,4.369,4.369,0,0,0-.031-5.937L31.594,7.188A4.076,4.076,0,0,0,28.688,6Zm8.125,0A1,1,0,0,0,37,8a2.818,2.818,0,0,1,.938.188,6.084,6.084,0,0,1,2.344,1.531,6.084,6.084,0,0,1,1.531,2.344A2.818,2.818,0,0,1,42,13a1,1,0,1,0,2,0,5.99,5.99,0,0,0-.312-1.562,8.24,8.24,0,0,0-5.125-5.125A5.99,5.99,0,0,0,37,6h-.187ZM28.688,8a2.084,2.084,0,0,1,1.5.594L41.406,19.813a2.387,2.387,0,0,1-.062,3.25L16.906,47.469a2.233,2.233,0,0,1-3.094.031l-3.366-3.366L2.625,36.313l-.031-.031a2.231,2.231,0,0,1,0-3.062l24.5-24.594A2.333,2.333,0,0,1,28.688,8ZM28,14a8,8,0,1,0,8,8A8.015,8.015,0,0,0,28,14Zm0,2a6,6,0,1,1-6,6A5.987,5.987,0,0,1,28,16Zm0,4a2,2,0,1,0,2,2A2,2,0,0,0,28,20ZM15,27a2,2,0,1,0,2,2A2,2,0,0,0,15,27Zm-5,5a2,2,0,1,0,2,2A2,2,0,0,0,10,32Zm11,1a2,2,0,1,0,2,2A2,2,0,0,0,21,33Zm-5,5a2,2,0,1,0,2,2A2,2,0,0,0,16,38Z"
      transform="translate(0.004 35.356) rotate(-45)"
      fill={fillColor}
    />
  </svg>
);
// Example of a generic SVG icon component
export const DynamicCircleIcon = ({
  fillColor = "currentColor",
  height = "12px",
  width = "12px",
  style = {},
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 50 50"
    style={{ borderRadius: "50%", border: "solid 1px #eee", ...style }}
    className={className}
  >
    <circle cx="25" cy="25" r="20" fill={fillColor} />
  </svg>
);

export const DynamicCircleLindearColorsIcon = ({
  theme = "default", // Added a theme prop to determine which gradient to use
  height = "10px",
  width = "10px",
  style = {},
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 50 50"
    style={{ borderRadius: "50%", border: "solid 1px #eee", ...style }}
    className={className}
  >
    <defs>
      <linearGradient id="stealGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style={{ stopColor: "#ccc", stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: "#fff", stopOpacity: 1 }} />
      </linearGradient>
      <linearGradient id="jeanGradient" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="20%" style={{ stopColor: "#233F5F", stopOpacity: 1 }} />
        <stop offset="112%" style={{ stopColor: "#fff", stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: "#233F5F", stopOpacity: 1 }} />
      </linearGradient>
      <radialGradient
        id="greyishGradient"
        cx="50%"
        cy="0%"
        r="50%"
        fx="50%"
        fy="0%"
      >
        <stop
          offset="0%"
          style={{ stopColor: "rgba(255, 255, 255, 0.65)", stopOpacity: 1 }}
        />
        <stop
          offset="100%"
          style={{ stopColor: "rgba(255, 255, 255, 0.35)", stopOpacity: 1 }}
        />
      </radialGradient>
    </defs>
    <circle
      cx="25"
      cy="25"
      r="20"
      fill={
        theme === "steal"
          ? "url(#stealGradient)"
          : theme === "jean"
            ? "url(#jeanGradient)"
            : theme === "greyish"
              ? "url(#greyishGradient)"
              : "currentColor"
      }
    />
  </svg>
);

export const RedCircleIcon = ({
  diameter = 20, // The diameter of the circle, you can set default or pass as a prop
  fillColor = "#b03a2e", // The fill color of the circle
  style = {}, // Additional styles if needed
  className = "", // Any additional class names
}) => {
  const radius = diameter / 2; // Radius is half the diameter

  return (
    <svg
      width={diameter}
      height={diameter}
      viewBox={`0 0 ${diameter} ${diameter}`}
      style={{ ...style, borderRadius: "50%", backgroundColor: fillColor }}
      className={className}
    >
      <circle cx={radius} cy={radius} r={radius} fill={fillColor} />
    </svg>
  );
};

export const HomeIcon = ({
  fillColor = "#c79f27",
  style = {},
  className = "",
  width = "64px", // Set the width as desired
  height = "64px", // Set the height as desired
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    style={style}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g>
        <path
          fill={fillColor}
          d="M32,18.347L10.726,35.885c0,0.025-0.006,0.063-0.02,0.111c-0.011,0.05-0.017,0.086-0.017,0.11v17.759
          c0,0.642,0.235,1.198,0.702,1.666c0.469,0.467,1.024,0.703,1.665,0.703h14.208V42.026h9.474v14.209h14.206
          c0.642,0,1.197-0.235,1.665-0.704c0.47-0.468,0.705-1.024,0.705-1.666V36.106c0-0.099-0.014-0.173-0.038-0.222L32,18.347z"
        />
        <path
          fill={fillColor}
          d="M61.414,31.89l-8.103-6.735V10.058c0-0.345-0.109-0.628-0.332-0.851c-0.222-0.221-0.507-0.333-0.853-0.333
          h-7.103c-0.346,0-0.63,0.111-0.851,0.333c-0.223,0.222-0.334,0.506-0.334,0.851v7.217l-9.027-7.549
          c-0.788-0.641-1.726-0.962-2.812-0.962c-1.085,0-2.023,0.321-2.813,0.962L2.587,31.89c-0.247,0.196-0.382,0.462-0.409,0.795
          c-0.024,0.332,0.062,0.623,0.259,0.87l2.295,2.738c0.197,0.222,0.456,0.357,0.776,0.406c0.296,0.025,0.592-0.062,0.889-0.26
          L32,15.091l25.604,21.348c0.198,0.173,0.458,0.258,0.778,0.258h0.109c0.32-0.047,0.578-0.185,0.777-0.405l2.295-2.737
          c0.197-0.248,0.284-0.538,0.257-0.872C61.796,32.352,61.661,32.086,61.414,31.89z"
        />
      </g>
    </g>
  </svg>
);

export const ColorPalleteIcon = ({
  fillColor = "#c79f27",
  style = {},
  className = "",
  width = "50",
  height = "50",
}) => (
  <svg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    className={className}
    viewBox="0 0 40.778 34.875"
  >
    <g
      id="Group_19062"
      data-name="Group 19062"
      transform="translate(-20.99 -1015.5)"
    >
      <g id="palette" transform="translate(20.99 1015.5)">
        <path
          id="Path_19583"
          data-name="Path 19583"
          d="M12.644,7.533A2.766,2.766,0,1,0,9.877,4.766,2.766,2.766,0,0,0,12.644,7.533Zm7.377,5.533A2.766,2.766,0,1,0,17.255,10.3,2.766,2.766,0,0,0,20.021,13.066ZM8.033,11.222A2.766,2.766,0,1,1,5.266,8.455a2.766,2.766,0,0,1,2.766,2.766Zm.922,11.066a2.766,2.766,0,1,0-2.766-2.766A2.766,2.766,0,0,0,8.955,22.288Z"
          transform="translate(2.111 1.689)"
          fill={fillColor}
        />
        <path
          id="Path_19587"
          data-name="Path 19587"
          d="M4.793,7.141ZM8.482,20.973a2.766,2.766,0,1,0-2.766-2.766A2.766,2.766,0,0,0,8.482,20.973Z"
          transform="translate(6.352 -4.531)"
          fill={fillColor}
        />
        <path
          id="Path_19584"
          data-name="Path 19584"
          d="M29.509,14.755c0,5.81-3.442,4.768-6.579,3.818-1.868-.566-3.63-1.1-4.487-.129-1.112,1.26-.876,3.355-.647,5.385.326,2.9.64,5.681-3.041,5.681A14.755,14.755,0,1,1,29.509,14.755ZM14.755,27.665c1.127,0,1.206-.315,1.208-.325a4.268,4.268,0,0,0,.129-2.064c-.026-.31-.068-.682-.113-1.09-.1-.856-.207-1.854-.218-2.7a6.141,6.141,0,0,1,1.3-4.268,3.489,3.489,0,0,1,2.346-1.14,6.954,6.954,0,0,1,2.139.192c.633.142,1.295.343,1.89.524l.052.015c.638.194,1.214.367,1.758.491,1.2.273,1.667.153,1.828.044.07-.048.592-.452.592-2.593a12.91,12.91,0,1,0-12.91,12.91Z"
          transform="translate(0 0)"
          fill={fillColor}
        />
      </g>
      <path
        id="brush"
        d="M16.107.13a.565.565,0,0,1,.134.632A49.086,49.086,0,0,1,9.018,12.285,6.152,6.152,0,0,1,6.6,13.946a4.765,4.765,0,0,1-.163.94A2.54,2.54,0,0,1,4.7,16.77a7.783,7.783,0,0,1-3.134.143,3.541,3.541,0,0,1-.572-.146A1.381,1.381,0,0,1,.519,16.5a.774.774,0,0,1-.208-.312.714.714,0,0,1,0-.48.942.942,0,0,1,.469-.489,2.2,2.2,0,0,0,.883-.895c.1-.156.187-.322.292-.511l.119-.214c.154-.276.332-.585.556-.918a1.958,1.958,0,0,1,1.778-.97,2.112,2.112,0,0,1,.354.052c.063-.186.145-.412.242-.658A9.656,9.656,0,0,1,6.218,8.863,47.936,47.936,0,0,1,15.5.087a.485.485,0,0,1,.607.043ZM4.785,12.9a1.191,1.191,0,0,0-.427-.108.966.966,0,0,0-.895.519c-.2.3-.361.576-.509.841l-.107.192c-.108.2-.217.392-.326.572a3.61,3.61,0,0,1-.774.932,6.831,6.831,0,0,0,2.705-.13A1.488,1.488,0,0,0,5.464,14.57a3.577,3.577,0,0,0,.128-.812L4.785,12.9Zm1.466.028a4.556,4.556,0,0,0,.466-.2,5.181,5.181,0,0,0,1.563-1.191,48.831,48.831,0,0,0,6.162-9.347A47.48,47.48,0,0,0,7.008,9.547a8.623,8.623,0,0,0-1.061,1.977c-.123.312-.218.585-.28.78h0l.585.623ZM1.188,16.22l.007-.005-.007,0Zm3.647-3.3h0Z"
        transform="matrix(0.469, 0.883, -0.883, 0.469, 54.123, 1028.01)"
        fill={fillColor}
      />
    </g>
  </svg>
);

export const XIcon = ({
  fillColor = "rgb(176, 58, 46)",
  width = "12.728",
  height = "12.727",
  style = {},
  className = "",
  id,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    id={id}
    onClick={onClick}
    style={{ cursor: "pointer", ...style }}
    className={className}
    fill={fillColor}
    viewBox="0 0 12.728 12.727"
  >
    <g transform="translate(-8.514 -8.518)">
      <path
        d="M19.377,10.38a6.364,6.364,0,1,0,0,9A6.365,6.365,0,0,0,19.377,10.38Zm-2.271,7.628-2.229-2.229-2.229,2.229-.9-.9,2.229-2.229-2.228-2.228.9-.9,2.228,2.228,2.228-2.229.9.9L15.777,14.88l2.229,2.229Z"
        fill={fillColor}
      />
    </g>
  </svg>
);

export const BankIcon = ({
  fillColor = "rgb(176, 58, 46)",
  width = "28",
  height = "27.778",
  style = {},
  className = "",
  id,
  onClick,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    id={id}
    onClick={onClick}
    style={{ cursor: "pointer", ...style }}
    className={className}
    fill={fillColor}
    viewBox="0 0 28 27.778"
  >
    <g id="Groupe_3594" data-name="Groupe 3594" transform="translate(0 0)">
      <path
        id="Tracé_4128"
        data-name="Tracé 4128"
        d="M3.338,10.455,14,2.7l10.662,7.751H28L14,.278,0,10.455Z"
        transform="translate(0 -0.278)"
      />
      <g
        id="Groupe_3592"
        data-name="Groupe 3592"
        transform="translate(0.544 22.315)"
      >
        <rect
          id="Rectangle_1492"
          data-name="Rectangle 1492"
          width="20.931"
          height="2.131"
          transform="translate(2.99)"
        />
        <rect
          id="Rectangle_1493"
          data-name="Rectangle 1493"
          width="26.913"
          height="2.131"
          transform="translate(0 3.332)"
        />
      </g>
      <g
        id="Groupe_3593"
        data-name="Groupe 3593"
        transform="translate(6.689 6.986)"
      >
        <path
          id="Tracé_4129"
          data-name="Tracé 4129"
          d="M36.941,37.236a3.827,3.827,0,0,0-1.132-.456v3.344a1.658,1.658,0,0,0,1.5-.794,1.787,1.787,0,0,0,.216-.884A1.391,1.391,0,0,0,36.941,37.236Z"
          transform="translate(-28.19 -29.181)"
        />
        <path
          id="Tracé_4130"
          data-name="Tracé 4130"
          d="M30.768,26.529a1.642,1.642,0,0,0-.356,1,1.225,1.225,0,0,0,.419.986,2.417,2.417,0,0,0,1.133.5V26.019A1.472,1.472,0,0,0,30.768,26.529Z"
          transform="translate(-24.949 -22.72)"
        />
        <path
          id="Tracé_4131"
          data-name="Tracé 4131"
          d="M24.052,17.762a7.311,7.311,0,1,0,7.311,7.309A7.311,7.311,0,0,0,24.052,17.762Zm2.07,11.358a4.153,4.153,0,0,1-1.761.519v1.234h-.6V29.64a2.839,2.839,0,0,1-2.513-1.309,3.537,3.537,0,0,1-.362-1.737h1.125a3.109,3.109,0,0,0,.276,1.274,1.7,1.7,0,0,0,1.474.806V25.208a4.09,4.09,0,0,1-2.039-.872,2.194,2.194,0,0,1-.658-1.691,2.51,2.51,0,0,1,.71-1.74,2.587,2.587,0,0,1,1.988-.792v-.845h.6V20.1a2.98,2.98,0,0,1,1.943.746,2.411,2.411,0,0,1,.709,1.733H25.9a1.9,1.9,0,0,0-.26-.834,1.464,1.464,0,0,0-1.279-.675v3.1a7.519,7.519,0,0,1,2,.776,2.018,2.018,0,0,1,.857,1.769A2.649,2.649,0,0,1,26.122,29.12Z"
          transform="translate(-16.741 -17.762)"
        />
      </g>
    </g>
  </svg>
);

export const ClapIcon = ({
  fillColor = "currentColor",
  width = "57.844",
  height = "84.82",
}) => (
  <svg
    viewBox="0 0 72 72"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
  >
    <g
      style={{
        fill: fillColor, // Uses the provided fill color
        stroke: "#000",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeMiterlimit: 10,
        strokeWidth: 2,
      }}
    >
      <path d="m22.7484 27.2535c-3.1923-3.1923 1.6882-7.6885 4.2795-5.0972l16.3092 16.3092-3.4575-3.4575c-1.1612-2.8574-.8089-7.4235 2.2659-7.4235 5.01 5.01 8.4731 8.9333 10.6782 11.0721 6.2265 6.2265 6.2265 16.3217 0 22.5483s-16.1868 6.2579-22.4133.0314l-17.2387-17.2387c-2.8935-2.8935 1.1791-6.8155 3.4228-4.5718l9.8594 10.043-8.5742-8.7339-4.5079-4.5918c-3.7489-3.7489 1.5155-7.6739 4.0062-5.1832-4.9957-4.9957.5147-8.5621 3.3047-5.7722l13.3909 13.3909" />
      <path d="m20.3603 18.3415.281 1.8296" />
      <path d="m15.4078 12.9103-1.3475-6.2866" />
      <path d="m12.5067 18.5051-5.9145 2.5211" />
      <path d="m13.6526 15.5204-4.4387-2.3017" />
      <path d="m54.532 14.4973-.2618-6.4241" />
      <path d="m58.7358 19.1926 6.3562.9676" />
      <path d="m56.8822 16.5876 3.7251-3.3352" />
      <path d="m29.9173 43.7429-13.0821-13.3257" />
      <path d="m34.0735 38.5786-13.3909-13.3909" />
      <path d="m13.1717 43.9976c-2.8935-2.8935 1.1791-6.8155 3.4228-4.5718l9.8594 10.043" />
      <path d="m13.3717 36.1431c-3.7489-3.7489 1.5155-7.6739 4.0062-5.1832" />
      <path d="m20.6826 25.1877c-2.79-2.79-8.3004.7764-3.3047 5.7722" />
      <path d="m52.8236 38.6567c-2.2051-2.1389-5.6682-6.0622-10.6782-11.0721-3.0748 0-3.4271 4.5661-2.2659 7.4235l3.4575 3.4575-16.3091-16.3092c-2.5914-2.5914-7.4718 1.9049-4.2795 5.0972" />
      <path d="m13.3717 36.1431 4.5079 4.5919" />
      <path d="m52.8236 38.6567c6.2265 6.2265 6.2265 16.3217 0 22.5483s-16.1868 6.2579-22.4133.0314" />
      <path d="m13.1717 43.9976 17.2386 17.2387" />
      <path d="m33.3873 23.7062-2.0397-14.147" />
      <path d="m40.0786 24.6186-2.5355-16.9998" />
      <path d="m20.3603 18.3415c-.6213-4.0446 4.9823-4.7977 5.4641-1.6614l.2215 1.702" />
      <path d="m25.1679 12.127c-.805-5.2403 5.7614-5.2907 6.2962-1.8092" />
      <path d="m37.5431 7.6188c-.5991-3.8999-7.1517-4.2841-6.079 2.6991" />
      <path d="m55.3349 36.5565c-.5127-3.0289-.8291-7.3059-1.9048-14.3089-2.4791-1.8189-5.4643 1.6542-6.2183 4.6449l-2.7594-17.9642c-.5564-3.6223-7.1511-2.8841-6.4657 1.5781" />
      <path d="m25.1679 12.127.7763 5.4448" />
      <path d="m20.3603 18.3415.281 1.8296" />
      <path d="m15.4078 12.9103-1.3475-6.2866" />
      <path d="m12.5067 18.5051-5.9145 2.5211" />
      <path d="m13.6526 15.5204-4.4387-2.3017" />
      <path d="m54.532 14.4973-.2618-6.4241" />
      <path d="m58.7358 19.1926 6.3562.9676" />
      <path d="m56.8822 16.5876 3.7251-3.3352" />
    </g>
  </svg>
);

export const BallotIcon = ({
  fillColor = "rgb(176, 58, 46)",
  width = "57.844",
  height = "84.82",
  style = {},
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={style}
    viewBox="0 0 95.844 122.82"
  >
    <path
      id="ballot-box-voting-icon"
      d="M25.46,87.48h5.87L27,104.87H18.89L14.58,87.48h5.87l2.36,11h.25l2.4-11ZM42,53a1.74,1.74,0,1,1,0-3.48h6.71a1.74,1.74,0,0,1,0,3.48Zm3.94-30c0-3.24.12-6,4.18-7a1.53,1.53,0,0,1-.15-.63V14.8H49.9l.69-3.76a5.18,5.18,0,0,1,4-2.72,1.7,1.7,0,0,1,0-.24v-2a2.069,2.069,0,0,1,0-.35C55.54,0,61.22.08,65.8.13H67L72.27,0h.16c4.5.21,7.42,2,10.79,4,2.36,1.47,9.39,2.45,11.1,4.9a8.44,8.44,0,0,1,1.52,4.76V31.51a4.68,4.68,0,0,1-2.29,4.21c-1.22.84-7.8,1.38-10,1.67a161.077,161.077,0,0,1-16.43,9.47,13.3,13.3,0,0,1-3.75,1.27v2.69H79.85a1.74,1.74,0,0,1,1.6,1l9.33,18a1.86,1.86,0,0,1,.19.89l.15,50.38a1.73,1.73,0,0,1-1.73,1.73H1.74A1.74,1.74,0,0,1,0,121.14V70.67H0v-.05H0l9.48-18a1.71,1.71,0,0,1,1.53-.93H27.36V34.32a2.15,2.15,0,0,1,2.16-2.16h5.6a6.54,6.54,0,0,1,1.47-6c4.16-4.8,9.3-1.72,9.36-3.1Zm14,25.06c-5.24-1-7.56-6.69-3.15-10.9H43.3a9.72,9.72,0,0,1-5.7-1.58H30.84V59.75H59.92V48.11ZM81.74,34.7a1.53,1.53,0,0,1,.7-.26c1.88-.23,8.15-.63,9-1.21a1.87,1.87,0,0,0,1-1.68V13.81a5.38,5.38,0,0,0-1-3.08C90.2,9,83.09,7.81,81.25,6.7c-7.31-4.46-7.19-3.33-15-3.48-3.39,0-7.6-.1-8.12,3v2c1,0,1.93.08,2.87.13s1.65.11,2.43.11a1.5,1.5,0,0,1,0,3c-.79,0-1.68-.05-2.62-.11-3.21-.2-6.87-.44-7.34,2.11v2.33a34.4,34.4,0,0,1,3.51.12c.85.06,1.65.11,2.43.11a1.5,1.5,0,0,1,0,3c-.79,0-1.68-.05-2.62-.11-3.21-.21-6.87-.44-7.33,2.12v2a1.68,1.68,0,0,1-.05.4h5.85a1.5,1.5,0,1,1,0,3H43.48c-3.14,0-6.67,2-5,5.34a3.349,3.349,0,0,0,.21.36h0v.05h0l.05.05h.24l.14.07H65.64c1.95,0,2,2.38,0,2.39a20,20,0,0,0-3.72.48h-.8a4.78,4.78,0,0,0-1,.93c-1.35,1.72-1.27,4.27,1,5.16h2.33l.38-.07c4.17-.87,9.36-3.9,17.94-10ZM27.36,54.3h-15L4.62,68.94H86.39L78.8,54.3H63.4v5.45h3.83a1.74,1.74,0,0,1,0,3.48H24.43a1.74,1.74,0,1,1,0-3.48h2.94V54.3ZM3.48,72.43v47H87.64l-.14-47Zm32-27.58a1.74,1.74,0,0,1,0-3.48H48.71a1.74,1.74,0,1,1,0,3.48ZM31.89,96.19c0-3.17.59-5.49,1.78-6.94s3.33-2.19,6.42-2.19,5.24.73,6.43,2.19S48.3,93,48.3,96.19a18,18,0,0,1-.37,4,7.13,7.13,0,0,1-1.3,2.81,5.19,5.19,0,0,1-2.53,1.75,12.411,12.411,0,0,1-4,.56,12.39,12.39,0,0,1-4-.56A5.19,5.19,0,0,1,33.56,103a7.13,7.13,0,0,1-1.3-2.81,18,18,0,0,1-.37-4Zm6-2.89v7.23H40.2a3.91,3.91,0,0,0,1.65-.26c.35-.18.52-.58.52-1.21V91.82H40a3.72,3.72,0,0,0-1.63.27c-.34.17-.51.58-.51,1.21Zm24.76-1.37h-4v12.94H53V91.93H49V87.48H62.63v4.45Zm12.66,6.38H69.73v2.11h6.82v4.45H64.16V87.48H76.41l-.7,4.45h-6v2.34h5.56v4Z"
      fill={fillColor}
    />
  </svg>
);

export const MegaphoneIcon = ({
  width = "61.379",
  height = "42",
  style = {},
  fillColor = "rgb(176, 58, 46)",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={style}
    viewBox="0 0 61.379 42"
  >
    <g id="Group_21" data-name="Group 21" transform="translate(20602 18020)">
      <g id="Group_20" data-name="Group 20" transform="translate(-10188 -7939)">
        <path
          id="Rectangle_405"
          data-name="Rectangle 405"
          d="M8.5,0H15a0,0,0,0,1,0,0V17a0,0,0,0,1,0,0H8.5A8.5,8.5,0,0,1,0,8.5v0A8.5,8.5,0,0,1,8.5,0Z"
          transform="translate(-10414 -10071)"
          fill={fillColor}
        />
        <path
          id="Rectangle_406"
          data-name="Rectangle 406"
          d="M3.5,0H13a0,0,0,0,1,0,0V7a0,0,0,0,1,0,0H3.5A3.5,3.5,0,0,1,0,3.5v0A3.5,3.5,0,0,1,3.5,0Z"
          transform="translate(-10408 -10039) rotate(-90)"
          fill={fillColor}
        />
        <path
          id="Path_186"
          data-name="Path 186"
          d="M5.387,0H6.593a19.037,19.037,0,0,1,.926,5.387,19.037,19.037,0,0,1-.926,5.387H5.387A5.387,5.387,0,0,1,5.387,0Z"
          transform="translate(-10378.832 -10057.362) rotate(180)"
          fill={fillColor}
        />
        <path
          id="Path_185"
          data-name="Path 185"
          d="M-10222-10059.634s13.8-11.638,16.48-9.5-6.636,7.731-6.636,16.879,9.316,15.165,6.636,16.927-16.48-8.694-16.48-8.694Z"
          transform="translate(-177.98 -10.674)"
          fill={fillColor}
        />
        <rect
          id="Rectangle_408"
          data-name="Rectangle 408"
          width="4.824"
          height="12.462"
          rx="2.412"
          transform="translate(-10358.313 -10079.008) rotate(60) translate(0 5)"
          fill={fillColor}
        />
        <rect
          id="Rectangle_410"
          data-name="Rectangle 410"
          width="4.824"
          height="12.462"
          rx="2.412"
          transform="translate(-10355.898 -10051.069) rotate(120) translate(0 5)"
          fill={fillColor}
        />
        <rect
          id="Rectangle_409"
          data-name="Rectangle 409"
          width="4.824"
          height="12.462"
          rx="2.412"
          transform="translate(-10352.621 -10065.362) rotate(90) translate(0 5)"
          fill={fillColor}
        />
        <g
          id="Ellipse_103"
          data-name="Ellipse 103"
          transform="translate(-10393 -10081)"
          fill="none"
          strokeWidth="4"
        >
          <ellipse cx="11.5" cy="18.5" rx="11.5" ry="18.5" stroke="none" />
          <ellipse cx="11.5" cy="18.5" rx="9.5" ry="16.5" fill="none" />
        </g>
      </g>
    </g>
  </svg>
);

export const SearchGlassIcon = ({
  width = "30",
  height = "30",
  fillColor = "#b03a2e", // Default fill color updated to match SVG
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`search-glass-icon ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 64 64" // ViewBox adjusted to match the original SVG
  >
    <g>
      <g>
        <path
          fill={fillColor}
          d="M37.499,45.866c0,0,0.571-0.355,1.054,0.148c2.618,2.72,10.48,10.89,10.48,10.89
          c2.091,2.172,5.013,2.688,6.867,0.763l0.32-0.331c1.852-1.928,1.356-4.965-0.735-7.137c0,0-7.877-8.186-10.503-10.914
          c-0.461-0.478-0.118-1.07-0.118-1.07c4.744-8.221,3.712-18.742-3.098-25.818c-8.026-8.34-21.086-8.34-29.113,0
          c-8.026,8.339-8.027,21.911,0,30.25C19.463,49.725,29.591,50.796,37.499,45.866z M16.455,38.699
          c-5.932-6.164-5.932-16.189,0-22.354c5.93-6.162,15.581-6.162,21.511,0c5.932,6.165,5.932,16.19,0,22.354
          C32.035,44.861,22.385,44.861,16.455,38.699z"
        />
        <g>
          <path
            fill={fillColor}
            d="M34.693,24.905c-1.96-4.816-7.325-7.077-11.959-5.039c-1.083,0.474-2.328-0.049-2.786-1.172
            c-0.457-1.125,0.048-2.418,1.13-2.894c6.792-2.987,14.655,0.325,17.53,7.383c0.456,1.124-0.049,2.418-1.13,2.895
            c-0.271,0.116-0.55,0.176-0.826,0.176C35.824,26.254,35.037,25.747,34.693,24.905z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const SidewaysRightTriangleIcon = ({
  width = "25px", // Default width
  height = "25px", // Default height
  fillColor = "#B03A2E", // Default fill color
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`sideways-right-triangle ${className}`.trim()}
    width={width}
    height={height}
    viewBox="-0.5 0 7 7" // Preserving original viewBox
    style={style}
  >
    <g
      id="playbtn"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="play"
        transform="translate(-347.000000, -3766.000000)"
        fill={fillColor}
      >
        <g id="icons" transform="translate(56.000000, 160.000000)">
          <path
            d="M296.494737,3608.57322 L292.500752,3606.14219 C291.83208,3605.73542 291,3606.25002 291,3607.06891 L291,3611.93095 C291,3612.7509 291.83208,3613.26444 292.500752,3612.85767 L296.494737,3610.42771 C297.168421,3610.01774 297.168421,3608.98319 296.494737,3608.57322"
            id="play-[#1003]"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const VerticalTwoBarsIcon = ({
  width = "25",
  height = "25",
  fillColor = "#B03A2E",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 217 384"
    style={style}
    className={className}
  >
    <path
      d="M224,435.8V76.1A12.1,12.1,0,0,0,211.8,64H140.2A12.1,12.1,0,0,0,128,76.1V435.8A12.184,12.184,0,0,0,140.2,448h71.6A12.121,12.121,0,0,0,224,435.8Z"
      transform="translate(-128 -64)"
      fill={fillColor}
    />
    <path
      d="M371.8,64H300.2A12.163,12.163,0,0,0,288,76.1V435.8A12.184,12.184,0,0,0,300.2,448h71.6A12.184,12.184,0,0,0,384,435.8V76.1A12.1,12.1,0,0,0,371.8,64Z"
      transform="translate(-167 -64)"
      fill={fillColor}
    />
  </svg>
);

export const TwoLeftArrowsIcon = ({
  width = "25", // Default width
  height = "25", // Default height
  fillColor = "#B03A2E", // Default fill color
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width} // Use the width prop
    height={height} // Use the height prop
    viewBox="0 0 224 192"
    style={style} // Apply custom styles if any
    className={className} // Apply custom className if any
  >
    <g transform="translate(-128 -160)">
      <path
        d="M128,256l128,96V280l96,72V160l-96,72V160Z"
        fill={fillColor} // Use the fillColor prop
        fillRule="evenodd"
      />
    </g>
  </svg>
);

export const TwoRightArrowsIcon = ({
  width = "25", // Default width
  height = "25", // Default height
  fillColor = "#B03A2E", // Default fill color
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width} // Use the width prop
    height={height} // Use the height prop
    style={style} // Apply custom styles if any
    className={className} // Apply custom className if any
    viewBox="0 0 224 192"
  >
    <path
      id="fastforward"
      data-name="fastforward"
      d="M352,256,224,352V280l-96,72V160l96,72V160Z"
      transform="translate(-128 -160)"
      fill={fillColor} // Use the fillColor prop
      fillRule="evenodd"
    />
  </svg>
);

export const WhistleIcon = ({
  fillColor = "#b03a2e",
  width = "25px",
  height = "25px",
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={fillColor}
    width={width}
    height={height}
    viewBox="0 0 31.636 31.636"
    style={style}
    className={className}
  >
    <g>
      <g>
        <polygon points="15.761,9.771 17.092,11.45 20.704,9.28 19.086,7.741" />
        <path
          d="M31.623,17.509v-0.01l-0.006,0.003c-0.501-0.567-8.354-9.46-12.005-12.382
          c-3.5-2.693-9.892-2.522-15.854,2.308L2.934,8.085C2.887,8.12,2.838,8.147,2.793,8.185
          c-3.449,2.72-3.744,8.097-0.659,12.006c3.084,3.911,8.381,4.876,11.829,2.156
          c0.705-0.555,1.416-1.793,1.855-2.535l7.126,8.449l8.555-5.65l0.123-5.073l0.014-0.013
          C31.633,17.521,31.626,17.513,31.623,17.509z M29.808,21.906l-4.161,2.542v-1.189l4.161-2.541V21.906z
          M24.02,21.808l-9.327-11.37c-0.025-0.032-0.045-0.066-0.071-0.099c-0.064-0.081-0.134-0.152-0.2-0.23
          l-0.214-0.261l-0.004,0.007C12.351,7.784,9.846,6.676,7.426,6.65c4.385-2.331,8.731-2.615,11.368-0.506
          c3.288,2.63,10.38,10.58,11.656,12.019L24.02,21.808z"
        />
      </g>
    </g>
  </svg>
);

export const TrashCanIcon = ({
  fillColor = "#b03a2e",
  width = "25px",
  height = "25px",
  style = {},
}) => (
  <svg
    version="1.1"
    id="TrashCanIcon"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill={fillColor}
    style={style}
    viewBox="0 0 100 100"
  >
    <g>
      <ellipse
        fill={fillColor}
        stroke="#010203"
        strokeWidth="1.4"
        strokeMiterlimit="10"
        cx="47.575"
        cy="19.308"
        rx="27.522"
        ry="11.526"
      />
      <path
        fill={fillColor}
        d="M46.414,37.474c-11.727,0-22.03-3.007-26.248-7.663l1.01-0.916c3.911,4.316,14.053,7.216,25.238,7.216
       c11.977,0,23.918-4.297,27.561-8.312l1.01,0.916C70.604,33.545,57.786,37.474,46.414,37.474z"
      />
      <path
        fill={fillColor}
        d="M47.804,92.221c-16.133,0-27.487-10.039-27.656-10.191l-0.256-0.23V21.403h1.56v59.695
  c2.803,2.404,25.603,20.588,52.248-0.029V21.403h1.56V81.83l-0.299,0.234C65.244,89.682,55.92,92.221,47.804,92.221z"
      />
      <polygon
        fill={fillColor}
        points="29.694,81.139 27.285,81.139 27.285,33.94 29.694,34.518 	"
      />
      <polygon
        fill={fillColor}
        points="54.232,84.359 51.824,84.359 51.824,37.161 54.232,36.454 	"
      />
      <polygon
        fill={fillColor}
        points="67.865,81.139 65.457,81.139 65.457,33.94 67.779,32.525 	"
      />
      <polygon
        fill={fillColor}
        points="41.964,83.59 39.554,83.59 39.554,36.055 41.964,36.391 	"
      />
    </g>
  </svg>
);

export const PencilIcon = ({
  fillColor = "#b03a2e",
  width = "25px",
  height = "25px",
  style = {},
}) => (
  <svg
    id="editPen"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width={width}
    height={height}
    style={style}
    viewBox="0 0 100 100"
  >
    <g>
      <path
        fill={fillColor}
        d="M86.688,27.509l-4.52,4.495L70.434,20.653l-5.24-5.626l4.548-4.544"
      />
      <path
        fill={fillColor}
        d="M71.734,25.303l0.17,0.169L24.313,73.047l-0.162-0.158l23.795-23.795L71.734,25.303 M71.74,21.574L46.083,47.23
		L20.427,72.885l3.883,3.889l51.316-51.295L71.74,21.574L71.74,21.574z"
      />
      <path
        fill={fillColor}
        d="M65.193,18.75l0.166,0.17L41.568,42.715L17.773,66.507l-0.167-0.167L65.193,18.75 M65.193,15.026L13.882,66.34l3.891,3.891
		L43.43,44.577L69.084,18.92L65.193,15.026L65.193,15.026z"
      />
      <path
        fill={fillColor}
        d="M78.277,31.834l0.166,0.169l-47.57,47.601l-0.17-0.17L78.277,31.834 M78.277,28.111L26.979,79.436l3.894,3.894
		l51.295-51.324L78.277,28.111L78.277,28.111z"
      />
      <path
        fill={fillColor}
        d="M78.189,5.902c0.066,0,0.164,0.018,0.248,0.1l12.774,12.771c0.046,0.046,0.087,0.108,0.087,0.234
		c0,0.105-0.027,0.19-0.087,0.247l-6.378,6.383l-9.911-9.916l-3.354-3.343L77.947,6C78.031,5.92,78.125,5.902,78.189,5.902
		 M78.189,3.269c-0.762,0-1.527,0.291-2.105,0.872l-8.242,8.24l5.221,5.205L84.835,29.36l8.239-8.245
		c0.563-0.563,0.859-1.316,0.859-2.108s-0.297-1.53-0.859-2.093L80.299,4.141C79.721,3.56,78.957,3.269,78.189,3.269L78.189,3.269z"
      />
      <path
        fill={fillColor}
        d="M15.088,71.27l10.85,10.851L10.1,87.102L15.088,71.27 M13.882,66.34L6.067,91.13l24.806-7.802L13.882,66.34L13.882,66.34z"
      />
    </g>
  </svg>
);

export const CurveUpArrow = ({
  fillColor = "#b03a2e",
  width = "25px",
  height = "25px",
  style = {},
}) => (
  <svg
    id="curveUpArrow"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width={width}
    height={height}
    style={style}
    viewBox="0 0 20.354 20.658"
  >
    <g id="noun_Undo_1777980" transform="translate(20.354 8.566) rotate(130)">
      <g id="Group_1457" data-name="Group 1457">
        <path
          id="Path_473"
          data-name="Path 473"
          d="M0,5.256,6.366,0V2.6c8.386.372,11.753,6.849,7.713,10.725h-.918c1.224-2.655-1.347-5.044-6.795-5.362v2.655Z"
          fill={fillColor}
          fillRule="evenodd"
        />
      </g>
    </g>
  </svg>
);
export const NotInterestedIcon = ({
  width = "50px", // Adjusted to a more standard size
  height = "50px", // Adjusted to a more standard size
  fillColor = "#fff",
  onClick,
  className = "",
}) => (
  <div
    onClick={onClick}
    className={`not-interested-icon ${className}`}
    style={{ cursor: "pointer" }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 1279.178 420.009" // Adjust this based on your SVG content
      // Preserve aspect ratio and scale SVG content for different sizes
      preserveAspectRatio="xMidYMid meet"
    >
      <g id="Group_1" data-name="Group 1" transform="translate(-1208 -2420)">
        <g
          id="_311831"
          data-name="311831"
          transform="translate(1207.778 2950.609)"
          fill={fillColor}
        >
          <path
            id="Path_1"
            data-name="Path 1"
            d="M996-530c-43.7,2.2-80.3,7.4-166.5,23.6-108.4,20.3-139.7,24-198,23.1-45-.7-64.3-3.2-129-16.7-43.2-9-50.7-10.5-65-12.9-26.5-4.5-90.7-12.3-124.5-15.3-22.1-1.9-81.6-1.6-101.5.5C177.3-524,148.4-519.1,84-506c-21.7,4.5-49.1,9.9-60.9,12-11.8,2.2-21.6,4.1-21.7,4.3-.2.2-.6,9.9-1,21.7-.7,24.2.6,35.9,5.1,45.3,1.4,3.1,6.9,10.1,13.2,17C43.1-379.2,47.1-373,52-354.9c10.9,39.5,19.5,66.5,30.8,95.9,13,34,28.3,67,35.8,77.6,25.7,36,82.2,61.2,156.4,69.6,7.2.8,22.8,1.2,41.5,1.2,51.7-.2,84.8-5.5,116-18.9,51.6-22.2,91.2-62.9,129.4-133.3,9.3-17.2,13.1-26.7,19.7-49.4,8.3-29.2,11.1-37.3,16.9-49.3,6.4-13.2,10.6-18.4,17.7-21.6,5.1-2.3,6.1-2.4,26.6-2.2,25.6.2,29.5,1.1,37.1,7.9,12,10.8,18.4,23,29.6,56.8,16.7,50.4,33,83.7,56,114.4,9.2,12.3,25.7,29.8,36.2,38.4,55.4,45.3,147.1,66.1,230.3,52.2,68.9-11.5,124.2-46.1,153.7-96.1,11.6-19.8,21.6-47.1,33.2-91.3,19.9-75.6,27.5-91.9,49.5-106.4,5.8-3.8,8.7-6.4,9.6-8.6,1.3-3.2,1.4-4.9,1.3-32.5,0-8.3,0-18.2.1-22.2,0-5.8-.3-7.7-2-10-3.1-4.1-9-7.1-16.9-8.3-16.5-2.7-33.8-6.5-60.5-13.5-37-9.7-45.4-11.3-88.5-17.4C1053.5-530.1,1030-531.7,996-530ZM358.9-502c26.1,1.3,42.3,3.2,64.1,7.6,86.5,17.3,130.9,44.6,141,86.6,2.2,9.3,2.7,27.7,1,38.8-4.2,27-15.3,57.5-36.7,100.5-14.8,29.6-26,46.1-43.7,64.4C446.9-165.4,398.2-143.5,337-138c-38.6,3.6-98.4-3.2-128.6-14.6-36.5-13.7-64.6-39.6-81.5-75.1C113.7-255.3,97.8-312.6,92.4-352c-2.6-18.4-2.6-58.6-.1-69.3,3.1-13,8.7-22.8,19.2-33.2,20-20,49.4-31.2,100.5-38.4,30-4.2,68.2-7.8,96.5-9C334.9-503.1,336.6-503.1,358.9-502ZM978-502c52.2,2.3,109.6,9.1,138.5,16.5,44.7,11.5,69.4,29.8,78.9,58.5,7.3,22.1,5.1,66.9-5.5,114.2-5.6,25-17.4,62.8-25.4,80.9a145.309,145.309,0,0,1-86.6,80.4c-11.4,4-37.3,9.5-56.9,12-17.1,2.3-51.2,3.1-68,1.6-70-6.2-125.2-34.6-163.7-84.1-13.1-16.9-30.9-49.5-45.2-83-7.3-17.1-15.5-42.2-18.3-56-3-15-3.2-36.8-.4-47.5,10.6-40.4,50.7-66,131.4-83.9a388.534,388.534,0,0,1,71.4-9.5C951.2-503.1,952.7-503.1,978-502Z"
            fill={fillColor}
          />
        </g>
        <g id="closed-eyes" transform="translate(1325.474 2183.475)">
          <path
            id="Path_3"
            data-name="Path 3"
            d="M194.864,491.96c-57.675,0-115.273-17.584-156.3-52.674a11.851,11.851,0,0,1,15.63-17.818c72.368,62.521,209.288,62.521,281.343,0a11.851,11.851,0,0,1,15.63,17.818C310.136,474.376,252.539,491.96,194.864,491.96Z"
            fill={fillColor}
          />
          <path
            id="Path_4"
            data-name="Path 4"
            d="M184.155,618.238a9.615,9.615,0,0,1-2.11,0,11.644,11.644,0,0,1-9.769-14.145l7.815-46.109a11.9,11.9,0,1,1,23.445,4.064l-7.815,46.109a11.723,11.723,0,0,1-11.566,10.081Zm175.683-23.445a11.566,11.566,0,0,1-8.284-3.517L313.026,552.2a11.723,11.723,0,1,1,16.646-16.412L368.2,574.865a11.723,11.723,0,0,1,0,16.568,12.192,12.192,0,0,1-8.362,3.361Zm-265.713,0a12.191,12.191,0,0,1-7.815-3.361,11.723,11.723,0,0,1,0-16.568l38.528-39.076A11.723,11.723,0,1,1,141.016,552.2l-38.529,39.076a11.566,11.566,0,0,1-8.362,3.517Zm176.23,23.445a11.723,11.723,0,0,1-11.488-9.691l-7.815-46.109a11.723,11.723,0,1,1,22.82-4.454l7.815,46.109a11.644,11.644,0,0,1-9.456,13.6A9.617,9.617,0,0,1,270.356,618.238Z"
            transform="translate(-32.118 -74.543)"
            fill={fillColor}
          />
        </g>
        <g
          id="closed-eyes-2"
          data-name="closed-eyes"
          transform="translate(2004.474 2183.475)"
          fill={fillColor}
        >
          <path
            id="Path_3-2"
            data-name="Path 3"
            d="M194.864,491.96c-57.675,0-115.273-17.584-156.3-52.674a11.851,11.851,0,0,1,15.63-17.818c72.368,62.521,209.288,62.521,281.343,0a11.851,11.851,0,0,1,15.63,17.818C310.136,474.376,252.539,491.96,194.864,491.96Z"
            fill={fillColor}
          />
          <path
            id="Path_4-2"
            data-name="Path 4"
            d="M184.155,618.238a9.615,9.615,0,0,1-2.11,0,11.644,11.644,0,0,1-9.769-14.145l7.815-46.109a11.9,11.9,0,1,1,23.445,4.064l-7.815,46.109a11.723,11.723,0,0,1-11.566,10.081Zm175.683-23.445a11.566,11.566,0,0,1-8.284-3.517L313.026,552.2a11.723,11.723,0,1,1,16.646-16.412L368.2,574.865a11.723,11.723,0,0,1,0,16.568,12.192,12.192,0,0,1-8.362,3.361Zm-265.713,0a12.191,12.191,0,0,1-7.815-3.361,11.723,11.723,0,0,1,0-16.568l38.528-39.076A11.723,11.723,0,1,1,141.016,552.2l-38.529,39.076a11.566,11.566,0,0,1-8.362,3.517Zm176.23,23.445a11.723,11.723,0,0,1-11.488-9.691l-7.815-46.109a11.723,11.723,0,1,1,22.82-4.454l7.815,46.109a11.644,11.644,0,0,1-9.456,13.6A9.617,9.617,0,0,1,270.356,618.238Z"
            transform="translate(-32.118 -74.543)"
            fill={fillColor}
          />
        </g>
      </g>
    </svg>
  </div>
);

export const LightBulbIcon = ({
  width = "50px", // Adjust the default size
  height = "50px", // Adjust the default size
  fillColor = "#fff",
  strokeColor = "#000", // Define a stroke color
  strokeWidth = "2", // Adjust this value for thicker border
  onClick,
  className = "",
}) => (
  <div
    onClick={onClick}
    className={`lightbulb-icon ${className}`}
    style={{ cursor: "pointer" }}
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 113.01 122.88"
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="m44.13 102.06c-1.14.03-2.14-.81-2.3-1.96-.17-1.2.64-2.31 1.82-2.54-1.3-7.37-4.85-11.43-8.6-15.72-2.92-3.34-5.95-6.81-8.34-11.92-2.35-5.03-3.64-10.23-3.6-15.63.05-5.4 1.42-10.96 4.4-16.71.02-.04.04-.07.06-.11 3.91-6.62 9.38-11.04 15.47-13.52 5.11-2.09 10.66-2.8 16.1-2.3 5.42.5 10.73 2.2 15.37 4.94 5.9 3.49 10.75 8.67 13.42 15.21 1.44 3.54 2.42 7.49 2.54 11.82.12 4.31-.62 8.96-2.61 13.88-2.66 6.59-6.18 10.68-9.47 14.51-3.03 3.53-5.85 6.81-7.42 11.84.89.21 1.59.94 1.73 1.9.17 1.24-.7 2.39-1.94 2.56l-.77.11c-.14 1.09-.23 2.26-.27 3.51l.25-.04c1.24-.17 2.39.7 2.56 1.94s-.7 2.39-1.94 2.56l-.78.11c.01.15.02.3.03.45.07.88.08 1.73.03 2.54l.13-.02c1.25-.15 2.38.74 2.54 1.98.15 1.25-.74 2.38-1.98 2.54l-1.68.21c-1.2 3.11-3.34 5.48-5.87 6.94-1.74 1.01-3.67 1.59-5.61 1.71-1.97.12-3.96-.25-5.78-1.13-2.08-1.02-3.94-2.71-5.29-5.14-.65-.33-1.13-.97-1.23-1.75-.04-.31-.01-.61.07-.89-.39-1.16-.68-2.43-.87-3.83l-.07.01c-1.24.17-2.39-.7-2.56-1.94s.7-2.39 1.94-2.56l.54-.08c.04-1.22.03-2.38-.02-3.48zm-41.95-43.2c-1.17.03-2.14-.88-2.18-2.05s.88-2.14 2.05-2.18l8.7-.3c1.17-.04 2.14.88 2.18 2.05s-.88 2.14-2.05 2.18zm108.5-8.61c1.16-.12 2.2.73 2.32 1.89s-.73 2.2-1.89 2.32l-8.66.91c-1.16.12-2.2-.73-2.32-1.89s.73-2.2 1.89-2.32zm-15.77-35.47c.65-.97 1.96-1.23 2.93-.58s1.23 1.96.58 2.93l-4.84 7.24c-.65.97-1.96 1.23-2.93.58s-1.23-1.96-.58-2.93zm-37.28-12.72c.03-1.17 1-2.09 2.16-2.06 1.17.03 2.09 1 2.06 2.16l-.22 8.7c-.03 1.17-1 2.09-2.16 2.06-1.17-.03-2.09-1-2.06-2.16zm-43.75 13.47c-.86-.8-.9-2.14-.11-2.99.8-.86 2.14-.9 2.99-.11l6.37 5.94c.86.8.9 2.14.11 2.99-.8.86-2.14.9-2.99.11zm34 81.42 18.49-2.63c1.59-6.7 5.05-10.73 8.8-15.08 3.08-3.58 6.36-7.4 8.76-13.34 1.76-4.35 2.41-8.43 2.31-12.19-.1-3.75-.96-7.21-2.24-10.34-2.3-5.63-6.51-10.11-11.65-13.15-4.11-2.43-8.8-3.94-13.59-4.37-4.77-.44-9.64.19-14.13 2.02-5.26 2.15-9.99 5.97-13.39 11.72-2.64 5.12-3.86 10.02-3.9 14.73-.04 4.74 1.11 9.33 3.2 13.8 2.13 4.56 4.97 7.8 7.69 10.92 4.24 4.86 8.25 9.45 9.65 17.91zm17.74 2.07-17.27 2.45c.05 1.1.07 2.25.05 3.47l17.05-2.42c.02-1.23.07-2.4.17-3.5zm-17.13 10.5c.12.92.3 1.76.53 2.54l16.55-2.04c.11-.86.13-1.77.05-2.74v-.02l-.01-.17zm2.88 6.84c.64.67 1.35 1.19 2.1 1.55 1.15.56 2.42.79 3.67.72 1.29-.08 2.57-.47 3.74-1.15 1.1-.64 2.09-1.53 2.88-2.65z"
        fill={fillColor}
        stroke={strokeColor} // Apply stroke color
        strokeWidth={strokeWidth} // Apply stroke width
      />
    </svg>
  </div>
);

export const BellIcon = ({
  fillColor = "#b03a2e",
  width = "20px",
  height = "20px",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 32.43 41.802"
  >
    <g
      id="Bell_black-01"
      data-name="Bell  black-01"
      transform="translate(-734.268 -353.72)"
    >
      <g id="Group_9" data-name="Group 9" transform="translate(734.268 353.72)">
        <g id="Group_8" data-name="Group 8">
          <path
            id="Path_23"
            data-name="Path 23"
            d="M757.481,429.624c0,.011,0,.022,0,.033a4.956,4.956,0,0,0,9.912,0c0-.011,0-.022,0-.033Z"
            transform="translate(-746.222 -392.811)"
            fill={fillColor}
          />
          <path
            id="Path_24"
            data-name="Path 24"
            d="M766.306,384.339l-4.46-6.554v-8.175a11.368,11.368,0,0,0-9.135-11.145v-2.517a2.229,2.229,0,1,0-4.457,0v2.517a11.367,11.367,0,0,0-9.135,11.145v8.175l-4.461,6.554a2.253,2.253,0,0,0,1.863,3.521h27.923a2.253,2.253,0,0,0,1.862-3.521Z"
            transform="translate(-734.268 -353.72)"
            fill={fillColor}
          />
        </g>
      </g>
    </g>
  </svg>
);

export const NoBellIcon = ({ width = "20px", height = "20px", style = {} }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={style}
    viewBox="0 0 20.318 20.318"
  >
    <g
      id="Group_18720"
      data-name="Group 18720"
      transform="translate(21231.877 20909.316)"
    >
      <g
        id="Bell_black-01"
        data-name="Bell  black-01"
        transform="translate(-21961.535 -21261.439)"
      >
        <g
          id="Group_9"
          data-name="Group 9"
          transform="translate(734.267 353.719)"
        >
          <g id="Group_8" data-name="Group 8" transform="translate(0 0)">
            <path
              id="Path_23"
              data-name="Path 23"
              d="M757.481,429.624v.011a1.7,1.7,0,0,0,3.392,0s0-.008,0-.011Z"
              transform="translate(-753.628 -417.025)"
              fill="#b03a2e"
            />
            <path
              id="Path_24"
              data-name="Path 24"
              d="M745.232,364.2l-1.526-2.243v-2.8a3.89,3.89,0,0,0-3.126-3.814v-.861a.763.763,0,1,0-1.526,0v.861a3.89,3.89,0,0,0-3.126,3.814v2.8L734.4,364.2a.771.771,0,0,0,.638,1.2h9.556a.771.771,0,0,0,.637-1.2Z"
              transform="translate(-734.267 -353.719)"
              fill="#b03a2e"
            />
          </g>
        </g>
      </g>
      <g
        id="no_fees-01"
        data-name="no fees-01"
        transform="translate(-21241.217 -20915.045)"
      >
        <rect
          id="Rectangle_5295"
          data-name="Rectangle 5295"
          width="1.131"
          height="19.505"
          transform="translate(13.926 24.104) rotate(-140.885)"
          fill="#b03a2e"
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="0.5"
        />
        <ellipse
          id="Ellipse_518"
          data-name="Ellipse 518"
          cx="9.659"
          cy="9.659"
          rx="9.659"
          ry="9.659"
          transform="translate(9.84 6.228)"
          fill="none"
          stroke="#000"
          strokeMiterlimit="10"
          strokeWidth="1"
        />
      </g>
    </g>
  </svg>
);

export const LeftArrow = ({
  fillColor = "#fff",
  width = "16.354",
  height = "23.502",
  strokeWidth = "2",
  strokeColor = "#fff",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16.354 29.502"
  >
    <path
      id="arrow-01"
      d="M15.518,16.354,0,1.641,1.555,0,15.433,13.156,27.86.048,29.5,1.6Z"
      transform="translate(16.354) rotate(90)"
      strokeWidth={strokeWidth}
      stroke={strokeColor}
      fill={fillColor}
    />
  </svg>
);

export const BroomIcon = ({
  fillColor = "#00000", // default fill color if needed
  width = "99.828",
  height = "99.826",
  style = {},
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={style}
    viewBox="0 0 99.828 99.826"
  >
    <defs>
      <filter
        id="broom"
        x="0"
        y="0"
        width="99.828"
        height="99.826"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="blur" />
        <feFlood floodOpacity="0.161" />
        <feComposite operator="in" in2="blur" />
        <feComposite in="SourceGraphic" />
      </filter>
    </defs>
    <g transform="matrix(1, 0, 0, 1, 0, 0)">
      <path
        id="broom-2"
        data-name="broom"
        d="M81.3.534a1.82,1.82,0,0,0-2.572,0l-34.5,34.5a4.871,4.871,0,0,0-2.2-.532,7,7,0,0,0-4.368,1.831,10.187,10.187,0,0,0-2.813-.39c-4.947,0-10.067,3.427-15.084,7.221h0c-.785.594-1.568,1.2-2.347,1.8l-.253.2C9.07,51.38.807,57.61.724,57.673a1.819,1.819,0,0,0-.191,2.738L21.418,81.3a1.82,1.82,0,0,0,1.286.533c.042,0,.084,0,.127,0a1.819,1.819,0,0,0,1.325-.72c.062-.082,6.292-8.346,12.514-16.43l.2-.256C42.049,57.69,47.4,50.745,45.494,44.175A7.118,7.118,0,0,0,47.32,40a4.868,4.868,0,0,0-.528-2.394l34.5-34.5a1.819,1.819,0,0,0,0-2.572ZM37.048,58.154,23.677,44.782c1.291-.939,2.576-1.822,3.837-2.583L39.638,54.324C38.88,55.573,38,56.852,37.048,58.154Zm-3.259,4.3c-4.564,5.93-9.133,11.956-11.276,14.791l-2.459-2.459,6.232-7.076a1.818,1.818,0,0,0-2.729-2.4l-6.08,6.9-2.644-2.644,2.313-2.313a1.818,1.818,0,0,0-2.571-2.572L12.261,67,9.617,64.352l6.9-6.08a1.818,1.818,0,0,0-2.4-2.729L7.04,61.775,4.582,59.316c2.835-2.144,8.86-6.712,14.79-11.276l.254-.2,1.114-.857,14.1,14.1-.854,1.11-.2.257ZM42.221,42.34a1.819,1.819,0,0,0-.488,2.1c.847,1.979.588,4.162-.35,6.489L30.916,40.458a10.6,10.6,0,0,1,3.924-.875,6.362,6.362,0,0,1,2.554.514,1.818,1.818,0,0,0,2.1-.489,4.314,4.314,0,0,1,2.531-1.466,1.518,1.518,0,0,1,1.117.55,1.5,1.5,0,0,1,.549,1.164,4.422,4.422,0,0,1-1.465,2.485Z"
        transform="translate(9 6)"
        fill={fillColor}
      />
    </g>
  </svg>
);
export const LineThroughCircleIcon = ({
  width = "15.414",
  height = "15.414",
  strokeColor = "#fff",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15.414 15.414"
    width={width}
    height={height}
  >
    <g
      id="Group_23"
      data-name="Group 23"
      transform="translate(20533.207 17989.207)"
    >
      <g id="Group_22" data-name="Group 22">
        <g
          id="Group_19"
          data-name="Group 19"
          transform="translate(-23411.191 -17998)"
        >
          <g
            id="Ellipse_3"
            data-name="Ellipse 3"
            transform="translate(2878.192 9)"
            fill="none"
            stroke={strokeColor}
            strokeWidth="1"
          >
            <circle cx="7.5" cy="7.5" r="7.5" stroke="none" />
            <circle cx="7.5" cy="7.5" r="7" fill="none" />
          </g>
        </g>
        <line
          id="Line_1"
          data-name="Line 1"
          x1="14"
          y2="14"
          transform="translate(-20532.5 -17988.5)"
          fill={strokeColor}
          stroke={strokeColor}
          strokeWidth="2"
        />
      </g>
    </g>
  </svg>
);

export const LineChartIcon = ({
  width = "330.986",
  height = "248.24",
  fillColor = "#000000", // Default fill color, you can customize it
  style = {},
  className = "",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={`line-chart-icon ${className}`.trim()}
    width={width}
    height={height}
    style={style}
    viewBox="0 0 330.986 248.24" // ViewBox matches the original SVG
  >
    <path
      fill={fillColor}
      d="M320.644,270.867H41.373V74.343A10.34,10.34,0,0,0,31.03,64H10.343A10.34,10.34,0,0,0,0,74.343v217.21A20.689,20.689,0,0,0,20.687,312.24H320.644A10.34,10.34,0,0,0,330.987,301.9V281.21A10.341,10.341,0,0,0,320.644,270.867ZM299.957,84.687H223.636a15.515,15.515,0,0,0-10.97,26.485l20.945,20.945L186.18,179.555l-47.431-47.431a20.679,20.679,0,0,0-29.252,0L65.092,176.529a10.343,10.343,0,0,0,0,14.629l14.623,14.623a10.343,10.343,0,0,0,14.629,0L124.12,176l47.431,47.431a20.679,20.679,0,0,0,29.252,0l62.06-62.06,20.945,20.945a15.515,15.515,0,0,0,26.485-10.97V95.03a10.331,10.331,0,0,0-10.337-10.343Z"
      transform="translate(0 -64)"
    />
  </svg>
);

export const CheckMark = ({ fill = "#000", stroke = "#000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 13.08 13.316"
    width="24"
    height="24"
  >
    <path
      id="Path_2332"
      data-name="Path 2332"
      d="M6297.454,19190.949l3.891,4.619a48.73,48.73,0,0,1,3.251-5.287c2.1-3.014,5.167-6.781,5.167-6.781s-3.692,3.83-5.768,6.16-2.772,3.119-2.772,3.119Z"
      transform="translate(-6297.072 -19183.152)"
      fill={fill}
      stroke={stroke}
      strokeWidth="1"
    />
  </svg>
);

export const VisaIcon = ({
  width = 75,
  height = 51,
  style = {},
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`VisaIcon ${className}`.trim()}
      width={width}
      height={height}
      style={style}
      viewBox="0 0 795 515"
    >
      <g id="visa" transform="translate(7.5 7.5)">
        <path
          id="Path_1"
          data-name="Path 1"
          d="M0,0H780V500H0Z"
          fill="#fff"
          stroke="#000"
          strokeWidth="15"
        />
        <path
          id="Path_2"
          data-name="Path 2"
          d="M293.2,348.73l33.359-195.76h53.358L346.533,348.73ZM539.31,157.19a137.789,137.789,0,0,0-47.821-8.222c-52.726,0-89.863,26.551-90.181,64.6-.3,28.129,26.515,43.822,46.754,53.185,20.771,9.6,27.752,15.716,27.652,24.283-.133,13.123-16.586,19.115-31.924,19.115-21.355,0-32.7-2.967-50.225-10.273l-6.878-3.111L379.2,340.593c12.463,5.467,35.508,10.2,59.438,10.445,56.09,0,92.5-26.248,92.916-66.885.2-22.27-14.016-39.215-44.8-53.188-18.65-9.056-30.072-15.1-29.951-24.269,0-8.137,9.668-16.838,30.56-16.838a98.442,98.442,0,0,1,39.936,7.5l4.781,2.259Zm137.31-4.223H635.39c-12.772,0-22.332,3.486-27.94,16.234L528.205,348.6h56.031s9.159-24.121,11.231-29.418c6.123,0,60.555.084,68.336.084,1.6,6.854,6.492,29.334,6.492,29.334h49.512L676.62,152.961ZM611.2,279.377c4.414-11.279,21.26-54.724,21.26-54.724-.314.521,4.381-11.334,7.074-18.684l3.606,16.878s10.217,46.729,12.353,56.527H611.2ZM247.9,152.967l-52.239,133.5L190.1,259.338c-9.726-31.274-40.025-65.157-73.9-82.12l47.767,171.2,56.455-.063,84-195.39H247.9"
          fill="#0e4595"
        />
        <path
          id="Path_3"
          data-name="Path 3"
          d="M146.92,152.96H60.879l-.682,4.073c66.939,16.2,111.23,55.363,129.62,102.42l-18.709-89.96c-3.229-12.4-12.6-16.1-24.186-16.528"
          fill="#f2ae14"
        />
      </g>
    </svg>
  );
};

export const MasterCardIcon = ({
  src = `${process.env.PUBLIC_URL}/mastercard.jpg`,
  width = 78,
  height = 50,
  alt = "MasterCard Icon",
  style = {},
  className = "",
  ...props
}) => {
  return (
    <img
      src={src}
      width={width}
      height={height}
      alt={alt}
      style={style}
      className={`MasterCardIcon ${className}`.trim()}
      {...props}
    />
  );
};

export const DiscoverIcon = ({
  src = `${process.env.PUBLIC_URL}/discover.jpg`,
  width = 78,
  height = 50,
  alt = "Discover Icon",
  style = {},
  className = "",
  ...props
}) => {
  return (
    <img
      src={src}
      width={width}
      height={height}
      alt={alt}
      style={style}
      className={`DiscoverIcon ${className}`.trim()}
      {...props}
    />
  );
};

export const AmexIcon = ({
  width = 78,
  height = 50,
  style = {},
  className = "",
}) => {
  return (
    <svg
      id="amex"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      style={style}
      className={`AmexIcon ${className}`.trim()}
      viewBox="0 0 780 500"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="0.401"
          y1="0.5"
          x2="0.399"
          y2="1"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#3c73d8" />
          <stop offset="1" stopColor="#1e3a6c" />
        </linearGradient>
      </defs>
      <path
        id="Path_13"
        data-name="Path 13"
        d="M0,0H780V500H0Z"
        fill="url(#linear-gradient)"
      />
      <path
        id="Path_14"
        data-name="Path 14"
        d="M.253,235.69H37.694l8.442-19.51h18.9l8.42,19.51h73.668V220.775l6.576,14.98h38.243l6.576-15.2v15.138H381.6l-.085-32.026h3.542c2.479.083,3.2.3,3.2,4.226v27.8h94.689v-7.455c7.639,3.92,19.518,7.455,35.148,7.455h39.836l8.525-19.51h18.9l8.337,19.51H670.46V217.159l11.626,18.532H743.6V113.181h-60.88v14.468L674.2,113.181H611.728v14.468L603.9,113.181H519.52c-14.123,0-26.539,1.889-36.569,7.153v-7.153H424.722v7.153c-6.383-5.426-15.079-7.153-24.75-7.153H187.232l-14.274,31.641L158.3,113.181h-67v14.468l-7.362-14.468H26.787L.248,171.427v64.261h0Zm236.34-17.67H214.129l-.083-68.794-31.775,68.793h-19.24l-31.858-68.854v68.854H86.6l-8.42-19.592H32.556l-8.505,19.592H.25l39.241-87.837H72.05l37.269,83.164V130.182h35.766l28.678,59.587,26.344-59.587h36.485ZM70.693,180.2l-15-35.017L40.78,180.2Zm255.3,37.821h-73.2V130.181h73.2v18.291H274.7V164.3h50.06V182.31H274.7v17.542h51.289Zm103.16-64.18a24.767,24.767,0,0,1-15.439,23.412,25.391,25.391,0,0,1,10.84,7.4c3.094,4.369,3.628,8.271,3.628,16.116v17.255h-22.1l-.083-11.077c0-5.285.528-12.886-3.458-17.112-3.2-3.09-8.083-3.76-15.973-3.76H363.041v31.95H341.127V130.181h50.4c11.2,0,19.451.283,26.535,4.207,6.933,3.924,11.09,9.652,11.09,19.45Zm-27.7,13.042c-3.013,1.752-6.573,1.81-10.841,1.81h-26.62V149.18h26.982c3.818,0,7.8.164,10.393,1.584,2.842,1.28,4.6,4,4.6,7.765C405.969,162.369,404.3,165.458,401.454,166.88ZM464.3,218.018H441.94V130.181H464.3Zm259.56,0H692.805L651.27,152.091v65.927H606.642l-8.527-19.592H552.594l-8.271,19.592H518.675c-10.649,0-24.138-2.257-31.773-9.715-7.7-7.458-11.708-17.56-11.708-33.533,0-13.027,2.395-24.936,11.812-34.347,7.085-7.01,18.18-10.242,33.28-10.242H541.5V149H520.73c-8,0-12.514,1.14-16.862,5.2-3.735,3.7-6.3,10.69-6.3,19.9,0,9.41,1.951,16.2,6.023,20.628,3.373,3.476,9.506,4.53,15.272,4.53h9.842l30.884-69.076h32.835l37.1,83.081v-83.08h33.366l38.519,61.174V130.185h22.445Zm-133.2-37.82-15.165-35.017L560.412,180.2ZM779.7,358.278c-5.322,7.457-15.694,11.238-29.736,11.238H707.643v-18.84H749.79c4.181,0,7.106-.527,8.868-2.175a7.587,7.587,0,0,0,2.591-5.729,7.087,7.087,0,0,0-2.677-5.811c-1.59-1.342-3.9-1.95-7.722-1.95-20.574-.67-46.244.608-46.244-27.194,0-12.742,8.443-26.156,31.439-26.156h43.649V264.182H739.137c-12.237,0-21.129,2.81-27.425,7.174v-7.175H651.727c-9.595,0-20.854,2.279-26.179,7.175v-7.175H518.428v7.175c-8.524-5.892-22.908-7.175-29.549-7.175H418.223v7.175c-6.745-6.258-21.742-7.175-30.886-7.175H308.26l-18.094,18.764-16.949-18.764H155.087v122.59h115.9l18.646-19.062L307.2,386.771l71.442.061V357.994h7.021c9.479.14,20.66-.228,30.523-4.312v33.085h58.928V354.815h2.842c3.628,0,3.985.144,3.985,3.615v28.333h179.01c11.364,0,23.244-2.786,29.824-7.845v7.845h56.78c11.815,0,23.354-1.587,32.134-5.649l0-22.84Zm-354.94-47.155c0,24.406-19.005,29.445-38.159,29.445H359.256v29.469H316.665l-26.984-29.086-28.042,29.086h-86.8V282.178h88.135l26.961,28.8,27.875-28.8h70.021C405.218,282.178,424.758,286.791,424.758,311.123Zm-174.22,40.434H196.66v-17.48h48.11V316.151H196.66V300.177H251.6l23.969,25.6Zm86.81,10.06L303.7,325.828l33.644-34.65ZM387.1,322.551H358.787V300.177h28.572c7.912,0,13.4,3.09,13.4,10.772C400.763,318.548,395.525,322.551,387.1,322.551Zm148.36-40.373H608.6v18.17H557.288v15.973H607.35v17.926H557.288v17.48l51.314.08v18.23H535.463Zm-28.119,47.029c4.878,1.725,8.865,4.816,10.734,7.375,3.095,4.291,3.542,8.294,3.631,16.037v17.418h-22V359.045c0-5.286.531-13.112-3.542-17.2-3.2-3.147-8.083-3.9-16.076-3.9h-23.42v32.09h-22.02V282.179h50.594c11.093,0,19.173.47,26.366,4.146,6.915,4,11.266,9.487,11.266,19.511a24.648,24.648,0,0,1-15.531,23.371ZM494.961,318.1c-2.932,1.667-6.556,1.811-10.818,1.811H457.521V300.179H484.5c3.9,0,7.807.08,10.458,1.587,2.84,1.423,4.538,4.146,4.538,7.9a9.372,9.372,0,0,1-4.538,8.431Zm197.82,5.6c4.27,4.229,6.554,9.571,6.554,18.613,0,18.9-12.322,27.723-34.425,27.723H622.23v-18.84h42.51c4.157,0,7.1-.525,8.95-2.175a7.64,7.64,0,0,0,2.589-5.729,7.405,7.405,0,0,0-2.675-5.811c-1.675-1.34-3.986-1.949-7.8-1.949-20.493-.67-46.157.609-46.157-27.192,0-12.744,8.355-26.158,31.33-26.158h43.932v18.7h-40.2c-3.984,0-6.575.145-8.779,1.587-2.4,1.422-3.29,3.534-3.29,6.319a6.759,6.759,0,0,0,4.795,6.546,26.253,26.253,0,0,0,8.526.995l11.8.306c11.9.276,20.061,2.248,25.024,7.065Zm86.955-23.52H739.8c-3.986,0-6.638.144-8.867,1.587-2.312,1.423-3.2,3.534-3.2,6.322a6.657,6.657,0,0,0,4.791,6.544,25.993,25.993,0,0,0,8.444,1l11.878.3c11.983.284,19.982,2.258,24.86,7.072a11.349,11.349,0,0,1,2.033,2.175v-25Z"
        fill="#fff"
      />
    </svg>
  );
};

export const CreditCardWithLockIcon = ({
  cardWidth = 35.572,
  cardHeight = 24.455,
  lockFillColor = "var(--color-darkGold)", // default lock color
  creditCardFillColor = "#b03a2e",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 35.572 24.455"
      width={cardWidth}
      height={cardHeight}
    >
      {/* Credit Card Paths */}
      <path
        id="Path_4115"
        data-name="Path 4115"
        d="M35.572,85.767V83.891A3.891,3.891,0,0,0,31.682,80H3.891A3.891,3.891,0,0,0,0,83.891v1.876a.347.347,0,0,0,.347.347H35.225A.347.347,0,0,0,35.572,85.767Z"
        transform="translate(0 -80)"
        fill={creditCardFillColor}
      />
      <path
        id="Path_4116"
        data-name="Path 4116"
        d="M0,200.347v11.881a3.891,3.891,0,0,0,3.891,3.891H31.682a3.891,3.891,0,0,0,3.891-3.891V200.347a.347.347,0,0,0-.347-.347H.347A.347.347,0,0,0,0,200.347Zm8.893,9.1a1.112,1.112,0,0,1-1.112,1.112H6.67a1.112,1.112,0,0,1-1.112-1.112v-1.112a1.112,1.112,0,0,1,1.112-1.112H7.781a1.112,1.112,0,0,1,1.112,1.112Z"
        transform="translate(0 -191.663)"
        fill={creditCardFillColor}
      />

      {/* Lock Icon Group */}
      {/* 
          We wrap the lock icon paths in a group that is scaled down and translated
          so that the lock sits on the credit card. Adjust these values as needed.
      */}
      <g transform="translate(25, 0) scale(0.4)">
        {/* The transforms below are from your original lock SVG.
            Note: translate(16.5 -24.499) and its inverse cancel out,
            leaving the path with a transform="translate(-50)".
        */}
        <g transform="translate(16.5 -24.499)">
          <g transform="translate(-16.5 24.499)">
            <path
              d="M51.705,37.52H74.445a1.706,1.706,0,0,0,1.705-1.705V16.486a1.706,1.706,0,0,0-1.705-1.705H72.739V9.664a9.664,9.664,0,1,0-19.329,0v5.116H51.705A1.706,1.706,0,0,0,50,16.486V35.815A1.706,1.706,0,0,0,51.705,37.52Zm13.075-10.8v2.276a1.705,1.705,0,1,1-3.411,0V26.717a2.842,2.842,0,1,1,3.411,0ZM56.822,9.664a6.253,6.253,0,0,1,12.507,0v5.116H56.822Z"
              transform="translate(-50)"
              fill={lockFillColor}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const DollarSignLockIcon = ({
  dollarLockWidth = "13.999",
  dollarLockHeight = "18.996",
  lockFill = "#b03a2e",
  moneySignFill = "#fff",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={dollarLockWidth}
      height={dollarLockHeight}
      viewBox="0 0 14.999 19.996"
    >
      <g
        id="Group_6252"
        data-name="Group 6252"
        transform="translate(10491.979 -14963.784)"
      >
        <g
          id="dollarSignLockIcon"
          data-name="fixed price large-01 (1)"
          transform="translate(-10491.979 14963.784)"
        >
          <path
            id="Path_5919"
            data-name="Path 5919"
            d="M-9.706-28.742h-1.252v-1.665a5.838,5.838,0,0,0-5.832-5.832,5.839,5.839,0,0,0-5.833,5.832v1.666H-23.87a.418.418,0,0,0-.419.418v10.415a1.668,1.668,0,0,0,1.667,1.666h11.665A1.667,1.667,0,0,0-9.29-17.909V-28.325A.419.419,0,0,0-9.706-28.742Zm-3.749,0h-6.667v-1.665a3.338,3.338,0,0,1,3.333-3.333,3.339,3.339,0,0,1,3.334,3.333v1.665Z"
            transform="translate(24.289 36.239)"
            fill={lockFill}
          />
          <path
            id="Path_5920"
            data-name="Path 5920"
            d="M-.785,14.288.45,14.164a1.263,1.263,0,0,0,1.364,1.2c.534,0,1.225-.218,1.225-.863,0-.673-1.082-.8-1.59-.923-1-.25-2-.69-2-1.888,0-1.069.837-1.58,1.757-1.716V9.181H2.315v.8a1.873,1.873,0,0,1,1.812,1.875l-1.27.044c-.114-.677-.474-.91-1.142-.91C1.33,10.986.66,11.1.66,11.6c0,.542.957.709,1.348.8,1.219.288,2.3.648,2.3,2.087A1.84,1.84,0,0,1,3.166,16.2a3.071,3.071,0,0,1-.848.2v.78H1.209v-.8a2.16,2.16,0,0,1-1.994-2.1Z"
            transform="translate(5.808 0.525)"
            fill={moneySignFill}
          />
        </g>
      </g>
    </svg>
  );
};

export const BankDollarSignIcon = ({
  bankDollarkWidth = "20.242",
  bankDollarHeight = "20.082",
  bankFill = "#b03a2e",
}) => {
  return (
    <svg
      id="bankDollarSign"
      xmlns="http://www.w3.org/2000/svg"
      width={bankDollarkWidth}
      height={bankDollarHeight}
      viewBox="0 0 20.242 20.082"
    >
      <g id="Group_3594" data-name="Group 3594" transform="translate(0 0)">
        <path
          id="Path_4128"
          data-name="Path 4128"
          d="M2.413,7.635l7.708-5.6,7.708,5.6h2.413L10.121.278,0,7.635Z"
          transform="translate(0 -0.278)"
          fill={bankFill}
        />
        <g
          id="Group_3592"
          data-name="Group 3592"
          transform="translate(0.393 16.132)"
        >
          <rect
            id="Rectangle_1492"
            data-name="Rectangle 1492"
            width="15.132"
            height="1.541"
            transform="translate(2.162)"
            fill={bankFill}
          />
          <rect
            id="Rectangle_1493"
            data-name="Rectangle 1493"
            width="19.456"
            height="1.541"
            transform="translate(0 2.409)"
            fill={bankFill}
          />
        </g>
        <g
          id="Group_3593"
          data-name="Group 3593"
          transform="translate(4.836 5.051)"
        >
          <path
            id="Path_4129"
            data-name="Path 4129"
            d="M36.627,37.11a2.767,2.767,0,0,0-.818-.33V39.2a1.2,1.2,0,0,0,1.084-.574,1.292,1.292,0,0,0,.156-.639A1,1,0,0,0,36.627,37.11Z"
            transform="translate(-30.301 -31.286)"
            fill={bankFill}
          />
          <path
            id="Path_4130"
            data-name="Path 4130"
            d="M30.669,26.388a1.187,1.187,0,0,0-.257.721.885.885,0,0,0,.3.713,1.748,1.748,0,0,0,.819.358V26.019A1.064,1.064,0,0,0,30.669,26.388Z"
            transform="translate(-26.463 -23.634)"
            fill={bankFill}
          />
          <path
            id="Path_4131"
            data-name="Path 4131"
            d="M22.026,17.762a5.285,5.285,0,1,0,5.285,5.284A5.285,5.285,0,0,0,22.026,17.762Zm1.5,8.211a3,3,0,0,1-1.273.376v.892h-.436v-.892A2.052,2.052,0,0,1,20,25.4a2.557,2.557,0,0,1-.262-1.256h.813a2.248,2.248,0,0,0,.2.921,1.23,1.23,0,0,0,1.065.583V23.145a2.957,2.957,0,0,1-1.474-.63,1.586,1.586,0,0,1-.476-1.222,1.815,1.815,0,0,1,.513-1.258,1.87,1.87,0,0,1,1.437-.572v-.611h.436v.6a2.155,2.155,0,0,1,1.4.539,1.743,1.743,0,0,1,.512,1.253h-.8a1.37,1.37,0,0,0-.188-.6,1.058,1.058,0,0,0-.924-.488V22.4a5.436,5.436,0,0,1,1.448.561,1.459,1.459,0,0,1,.62,1.279A1.915,1.915,0,0,1,23.523,25.973Z"
            transform="translate(-16.741 -17.762)"
            fill={bankFill}
          />
        </g>
      </g>
    </svg>
  );
};
export const HouseIcon = ({
  houseWidth = "39.346",
  houseHeight = "31.313",
  houseFillColor = "#b03a2e",
}) => {
  return (
    <svg
      id="_2-01_5_"
      data-name="2-01 (5)"
      width={houseWidth}
      height={houseHeight}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 39.346 31.313"
    >
      <g id="Group_1807" data-name="Group 1807" transform="translate(0)">
        <path
          id="Path_574"
          data-name="Path 574"
          d="M24.746,18.347,10.713,29.915a.281.281,0,0,1-.013.073.385.385,0,0,0-.011.072V41.774a1.582,1.582,0,0,0,1.561,1.563h9.371V33.965h6.249v9.372H37.24A1.586,1.586,0,0,0,38.8,41.774V30.06a.344.344,0,0,0-.026-.146Z"
          transform="translate(-5.073 -12.026)"
          fill={houseFillColor}
        />
        <path
          id="Path_575"
          data-name="Path 575"
          d="M41.248,24.018,35.9,19.575V9.618a.756.756,0,0,0-.219-.561.764.764,0,0,0-.563-.22H30.436a.753.753,0,0,0-.782.781v4.76L23.7,9.4a3.029,3.029,0,0,0-3.71,0L2.446,24.018a.712.712,0,0,0-.27.524.794.794,0,0,0,.171.573l1.514,1.806a.824.824,0,0,0,.512.268.911.911,0,0,0,.586-.171l16.888-14.08L38.735,27.019a.758.758,0,0,0,.513.17h.072a.835.835,0,0,0,.512-.267l1.514-1.805a.788.788,0,0,0,.17-.575A.7.7,0,0,0,41.248,24.018Z"
          transform="translate(-2.174 -8.764)"
          fill={houseFillColor}
        />
      </g>
    </svg>
  );
};

export const PlusIcon = ({
  width = "17",
  height = "29",
  fillColor = "rgba(53, 53, 53, .902)",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17 29"
    >
      <text
        id="_"
        data-name="+"
        transform="translate(0 22)"
        fill={fillColor}
        fontSize="29"
        fontFamily="Helvetica"
      >
        <tspan x="0" y="0">
          +
        </tspan>
      </text>
    </svg>
  );
};

export const PuppeteerIcon = ({
  width = "17",
  height = "29",
  fillColor = "currentColor",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="5 10 42 40"
      xmlns="http://www.w3.org/2000/svg"
      fill={fillColor} // this sets the fill for all child elements
    >
      <circle fill={fillColor} cx="23.588" cy="38.103" r="3.601" />
      <path
        fill={fillColor}
        d="m46.73 12.567v-12.574l-9.669 8.956s-.649.558-1.813 1.108c-.447.21-1.018.341-1.384.388l-18.862.055c-1.388.013-2.069 1.051-2.389 1.993l10.071-.008c.279 0 .491.298.492.577 0 .281-.228.509-.505.509l-10.264.009c-.008 0-.015-.005-.025-.007l-3.768.007c-1.074.001-1.941.875-1.939 1.954 0 1.07.874 1.937 1.948 1.936l1.654-.001v21.448l-2.833 1.652c-.8.468-1.071 1.494-.604 2.295.466.799 1.492 1.07 2.294.603l5.152-3.004 2.1 2.073c-.084.083-.172.164-.238.249-2.782 3.354-3.906 7.617-3.906 7.617h10.733s-.003-1.571-.37-3.42l5.729 1.482c.139.036.28.053.42.053.551 0 1.08-.271 1.396-.746l4.438-6.657c.514-.771.306-1.812-.465-2.326-.765-.51-1.787-.306-2.307.445v-11.244zm-31.001 24.603c-.541-.531-1.369-.639-2.024-.255l-2.496 1.456v-20.904l7.042-.003 2.71-1.666c.233-.144.544-.07.693.17.145.24.072.55-.165.694l-1.299.798h.014l-6.199 3.793c-.91.574-1.185 1.77-.615 2.681.371.592 1.007.91 1.656.909.35 0 .704-.099 1.024-.297l.777-.476v14.204zm12.291 7.747-6.005-1.554c-.005-.001-.01-.001-.016-.002l-4.219-4.168v-15.695l5.38-3.301 7.304-.015c.465.034 1.244.213 1.303.98.065.84-.621 1.437-.621 1.437l.022-.004-2.953 3.004c-.756.767-1.153 2.44-.223 3.284.396.358 1.014.589 1.611.537.456-.032.913-.174 1.281-.491v11.503h.125z"
      />
    </svg>
  );
};
